import "@dxos/node-std/globals";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined") return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x + '" is not supported');
});
var __commonJS = (cb, mod) => function __require2() {
  try {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  } catch (e) {
    throw mod = 0, e;
  }
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/.pnpm/nanoassert@2.0.0/node_modules/nanoassert/index.js
var require_nanoassert = __commonJS({
  "../../node_modules/.pnpm/nanoassert@2.0.0/node_modules/nanoassert/index.js"(exports, module) {
    module.exports = assert;
    var AssertionError = class extends Error {
    };
    AssertionError.prototype.name = "AssertionError";
    function assert(t, m) {
      if (!t) {
        var err = new AssertionError(m);
        if (Error.captureStackTrace) Error.captureStackTrace(err, assert);
        throw err;
      }
    }
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/randombytes.js
var require_randombytes = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/randombytes.js"(exports, module) {
    var assert = require_nanoassert();
    var randombytes = (function() {
      var QUOTA = 65536;
      var crypto = globalThis.crypto || globalThis.msCrypto;
      function browserBytes(out, n) {
        for (let i = 0; i < n; i += QUOTA) {
          crypto.getRandomValues(new Uint8Array(out.buffer, i + out.byteOffset, Math.min(n - i, QUOTA)));
        }
      }
      function nodeBytes(out, n) {
        new Uint8Array(out.buffer, out.byteOffset, n).set(crypto.randomBytes(n));
      }
      function noImpl() {
        throw new Error("No secure random number generator available");
      }
      if (crypto && crypto.getRandomValues) return browserBytes;
      if (__require != null) {
        crypto = __require("@dxos/node-std/crypto");
        if (crypto && crypto.randomBytes) return nodeBytes;
      }
      return noImpl;
    })();
    Object.defineProperty(module.exports, "randombytes", {
      value: randombytes
    });
    module.exports.randombytes_buf = function(out) {
      assert(out, "out must be given");
      randombytes(out, out.byteLength);
    };
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/memory.js
var require_memory = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/memory.js"(exports, module) {
    function sodium_malloc(n) {
      return new Uint8Array(n);
    }
    function sodium_free(n) {
      sodium_memzero(n);
      loadSink().port1.postMessage(n.buffer, [n.buffer]);
    }
    function sodium_memzero(arr) {
      arr.fill(0);
    }
    var sink;
    function loadSink() {
      if (sink) return sink;
      var MessageChannel = globalThis.MessageChannel;
      if (MessageChannel == null) ({ MessageChannel } = __require("@dxos/node-std/worker_threads"));
      sink = new MessageChannel();
      return sink;
    }
    module.exports = {
      sodium_malloc,
      sodium_free,
      sodium_memzero
    };
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_verify.js
var require_crypto_verify = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_verify.js"(exports, module) {
    module.exports = {
      crypto_verify_16,
      crypto_verify_32,
      crypto_verify_64
    };
    function vn(x, xi, y, yi, n) {
      var d = 0;
      for (let i = 0; i < n; i++) d |= x[xi + i] ^ y[yi + i];
      return (1 & d - 1 >>> 8) - 1;
    }
    Object.defineProperty(module.exports, "vn", {
      value: vn
    });
    function crypto_verify_16(x, xi, y, yi) {
      return vn(x, xi, y, yi, 16) === 0;
    }
    function crypto_verify_32(x, xi, y, yi) {
      return vn(x, xi, y, yi, 32) === 0;
    }
    function crypto_verify_64(x, xi, y, yi) {
      return vn(x, xi, y, yi, 64) === 0;
    }
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/helpers.js
var require_helpers = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/helpers.js"(exports, module) {
    var assert = require_nanoassert();
    var { vn } = require_crypto_verify();
    function sodium_increment(n) {
      const nlen = n.byteLength;
      var c = 1;
      for (var i = 0; i < nlen; i++) {
        c += n[i];
        n[i] = c;
        c >>= 8;
      }
    }
    function sodium_memcmp(a, b) {
      assert(a.byteLength === b.byteLength, "buffers must be the same size");
      return vn(a, 0, b, 0, a.byteLength) === 0;
    }
    function sodium_is_zero(arr) {
      var d = 0;
      for (let i = 0; i < arr.length; i++) d |= arr[i];
      return d === 0;
    }
    module.exports = {
      sodium_increment,
      sodium_memcmp,
      sodium_is_zero
    };
  }
});

// ../../node_modules/.pnpm/b4a@1.6.4/node_modules/b4a/lib/ascii.js
var require_ascii = __commonJS({
  "../../node_modules/.pnpm/b4a@1.6.4/node_modules/b4a/lib/ascii.js"(exports, module) {
    function byteLength(string) {
      return string.length;
    }
    function toString(buffer) {
      const len = buffer.byteLength;
      let result = "";
      for (let i = 0; i < len; i++) {
        result += String.fromCharCode(buffer[i]);
      }
      return result;
    }
    function write(buffer, string, offset = 0, length = byteLength(string)) {
      const len = Math.min(length, buffer.byteLength - offset);
      for (let i = 0; i < len; i++) {
        buffer[offset + i] = string.charCodeAt(i);
      }
      return len;
    }
    module.exports = {
      byteLength,
      toString,
      write
    };
  }
});

// ../../node_modules/.pnpm/b4a@1.6.4/node_modules/b4a/lib/base64.js
var require_base64 = __commonJS({
  "../../node_modules/.pnpm/b4a@1.6.4/node_modules/b4a/lib/base64.js"(exports, module) {
    var alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var codes = new Uint8Array(256);
    for (let i = 0; i < alphabet.length; i++) {
      codes[alphabet.charCodeAt(i)] = i;
    }
    codes[
      /* - */
      45
    ] = 62;
    codes[
      /* _ */
      95
    ] = 63;
    function byteLength(string) {
      let len = string.length;
      if (string.charCodeAt(len - 1) === 61) len--;
      if (len > 1 && string.charCodeAt(len - 1) === 61) len--;
      return len * 3 >>> 2;
    }
    function toString(buffer) {
      const len = buffer.byteLength;
      let result = "";
      for (let i = 0; i < len; i += 3) {
        result += alphabet[buffer[i] >> 2] + alphabet[(buffer[i] & 3) << 4 | buffer[i + 1] >> 4] + alphabet[(buffer[i + 1] & 15) << 2 | buffer[i + 2] >> 6] + alphabet[buffer[i + 2] & 63];
      }
      if (len % 3 === 2) {
        result = result.substring(0, result.length - 1) + "=";
      } else if (len % 3 === 1) {
        result = result.substring(0, result.length - 2) + "==";
      }
      return result;
    }
    function write(buffer, string, offset = 0, length = byteLength(string)) {
      const len = Math.min(length, buffer.byteLength - offset);
      for (let i = 0, j = 0; j < len; i += 4) {
        const a = codes[string.charCodeAt(i)];
        const b = codes[string.charCodeAt(i + 1)];
        const c = codes[string.charCodeAt(i + 2)];
        const d = codes[string.charCodeAt(i + 3)];
        buffer[j++] = a << 2 | b >> 4;
        buffer[j++] = (b & 15) << 4 | c >> 2;
        buffer[j++] = (c & 3) << 6 | d & 63;
      }
      return len;
    }
    module.exports = {
      byteLength,
      toString,
      write
    };
  }
});

// ../../node_modules/.pnpm/b4a@1.6.4/node_modules/b4a/lib/hex.js
var require_hex = __commonJS({
  "../../node_modules/.pnpm/b4a@1.6.4/node_modules/b4a/lib/hex.js"(exports, module) {
    function byteLength(string) {
      return string.length >>> 1;
    }
    function toString(buffer) {
      const len = buffer.byteLength;
      buffer = new DataView(buffer.buffer, buffer.byteOffset, len);
      let result = "";
      let i = 0;
      for (let n = len - len % 4; i < n; i += 4) {
        result += buffer.getUint32(i).toString(16).padStart(8, "0");
      }
      for (; i < len; i++) {
        result += buffer.getUint8(i).toString(16).padStart(2, "0");
      }
      return result;
    }
    function write(buffer, string, offset = 0, length = byteLength(string)) {
      const len = Math.min(length, buffer.byteLength - offset);
      for (let i = 0; i < len; i++) {
        const a = hexValue(string.charCodeAt(i * 2));
        const b = hexValue(string.charCodeAt(i * 2 + 1));
        if (a === void 0 || b === void 0) {
          return buffer.subarray(0, i);
        }
        buffer[offset + i] = a << 4 | b;
      }
      return len;
    }
    module.exports = {
      byteLength,
      toString,
      write
    };
    function hexValue(char) {
      if (char >= 48 && char <= 57) return char - 48;
      if (char >= 65 && char <= 70) return char - 65 + 10;
      if (char >= 97 && char <= 102) return char - 97 + 10;
    }
  }
});

// ../../node_modules/.pnpm/b4a@1.6.4/node_modules/b4a/lib/utf8.js
var require_utf8 = __commonJS({
  "../../node_modules/.pnpm/b4a@1.6.4/node_modules/b4a/lib/utf8.js"(exports, module) {
    function byteLength(string) {
      let length = 0;
      for (let i = 0, n = string.length; i < n; i++) {
        const code = string.charCodeAt(i);
        if (code >= 55296 && code <= 56319 && i + 1 < n) {
          const code2 = string.charCodeAt(i + 1);
          if (code2 >= 56320 && code2 <= 57343) {
            length += 4;
            i++;
            continue;
          }
        }
        if (code <= 127) length += 1;
        else if (code <= 2047) length += 2;
        else length += 3;
      }
      return length;
    }
    var toString;
    if (typeof TextDecoder !== "undefined") {
      const decoder = new TextDecoder();
      toString = function toString2(buffer) {
        return decoder.decode(buffer);
      };
    } else {
      toString = function toString2(buffer) {
        const len = buffer.byteLength;
        let output = "";
        let i = 0;
        while (i < len) {
          let byte = buffer[i];
          if (byte <= 127) {
            output += String.fromCharCode(byte);
            i++;
            continue;
          }
          let bytesNeeded = 0;
          let codePoint = 0;
          if (byte <= 223) {
            bytesNeeded = 1;
            codePoint = byte & 31;
          } else if (byte <= 239) {
            bytesNeeded = 2;
            codePoint = byte & 15;
          } else if (byte <= 244) {
            bytesNeeded = 3;
            codePoint = byte & 7;
          }
          if (len - i - bytesNeeded > 0) {
            let k = 0;
            while (k < bytesNeeded) {
              byte = buffer[i + k + 1];
              codePoint = codePoint << 6 | byte & 63;
              k += 1;
            }
          } else {
            codePoint = 65533;
            bytesNeeded = len - i;
          }
          output += String.fromCodePoint(codePoint);
          i += bytesNeeded + 1;
        }
        return output;
      };
    }
    var write;
    if (typeof TextEncoder !== "undefined") {
      const encoder = new TextEncoder();
      write = function write2(buffer, string, offset = 0, length = byteLength(string)) {
        const len = Math.min(length, buffer.byteLength - offset);
        encoder.encodeInto(string, buffer.subarray(offset, offset + len));
        return len;
      };
    } else {
      write = function write2(buffer, string, offset = 0, length = byteLength(string)) {
        const len = Math.min(length, buffer.byteLength - offset);
        buffer = buffer.subarray(offset, offset + len);
        let i = 0;
        let j = 0;
        while (i < string.length) {
          const code = string.codePointAt(i);
          if (code <= 127) {
            buffer[j++] = code;
            i++;
            continue;
          }
          let count = 0;
          let bits = 0;
          if (code <= 2047) {
            count = 6;
            bits = 192;
          } else if (code <= 65535) {
            count = 12;
            bits = 224;
          } else if (code <= 2097151) {
            count = 18;
            bits = 240;
          }
          buffer[j++] = bits | code >> count;
          count -= 6;
          while (count >= 0) {
            buffer[j++] = 128 | code >> count & 63;
            count -= 6;
          }
          i += code >= 65536 ? 2 : 1;
        }
        return len;
      };
    }
    module.exports = {
      byteLength,
      toString,
      write
    };
  }
});

// ../../node_modules/.pnpm/b4a@1.6.4/node_modules/b4a/lib/utf16le.js
var require_utf16le = __commonJS({
  "../../node_modules/.pnpm/b4a@1.6.4/node_modules/b4a/lib/utf16le.js"(exports, module) {
    function byteLength(string) {
      return string.length * 2;
    }
    function toString(buffer) {
      const len = buffer.byteLength;
      let result = "";
      for (let i = 0; i < len - 1; i += 2) {
        result += String.fromCharCode(buffer[i] + buffer[i + 1] * 256);
      }
      return result;
    }
    function write(buffer, string, offset = 0, length = byteLength(string)) {
      const len = Math.min(length, buffer.byteLength - offset);
      let units = len;
      for (let i = 0; i < string.length; ++i) {
        if ((units -= 2) < 0) break;
        const c = string.charCodeAt(i);
        const hi = c >> 8;
        const lo = c % 256;
        buffer[offset + i * 2] = lo;
        buffer[offset + i * 2 + 1] = hi;
      }
      return len;
    }
    module.exports = {
      byteLength,
      toString,
      write
    };
  }
});

// ../../node_modules/.pnpm/b4a@1.6.4/node_modules/b4a/browser.js
var require_browser = __commonJS({
  "../../node_modules/.pnpm/b4a@1.6.4/node_modules/b4a/browser.js"(exports, module) {
    var ascii = require_ascii();
    var base64 = require_base64();
    var hex = require_hex();
    var utf8 = require_utf8();
    var utf16le = require_utf16le();
    var LE = new Uint8Array(Uint16Array.of(255).buffer)[0] === 255;
    function codecFor(encoding) {
      switch (encoding) {
        case "ascii":
          return ascii;
        case "base64":
          return base64;
        case "hex":
          return hex;
        case "utf8":
        case "utf-8":
        case void 0:
          return utf8;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return utf16le;
        default:
          throw new Error(`Unknown encoding: ${encoding}`);
      }
    }
    function isBuffer(value) {
      return value instanceof Uint8Array;
    }
    function isEncoding(encoding) {
      try {
        codecFor(encoding);
        return true;
      } catch {
        return false;
      }
    }
    function alloc(size, fill2, encoding) {
      const buffer = new Uint8Array(size);
      if (fill2 !== void 0) exports.fill(buffer, fill2, 0, buffer.byteLength, encoding);
      return buffer;
    }
    function allocUnsafe(size) {
      return new Uint8Array(size);
    }
    function allocUnsafeSlow(size) {
      return new Uint8Array(size);
    }
    function byteLength(string, encoding) {
      return codecFor(encoding).byteLength(string);
    }
    function compare(a, b) {
      if (a === b) return 0;
      const len = Math.min(a.byteLength, b.byteLength);
      a = new DataView(a.buffer, a.byteOffset, a.byteLength);
      b = new DataView(b.buffer, b.byteOffset, b.byteLength);
      let i = 0;
      for (let n = len - len % 4; i < n; i += 4) {
        const x = a.getUint32(i, LE);
        const y = b.getUint32(i, LE);
        if (x !== y) break;
      }
      for (; i < len; i++) {
        const x = a.getUint8(i);
        const y = b.getUint8(i);
        if (x < y) return -1;
        if (x > y) return 1;
      }
      return a.byteLength > b.byteLength ? 1 : a.byteLength < b.byteLength ? -1 : 0;
    }
    function concat(buffers, totalLength) {
      if (totalLength === void 0) {
        totalLength = buffers.reduce((len, buffer) => len + buffer.byteLength, 0);
      }
      const result = new Uint8Array(totalLength);
      let offset = 0;
      for (const buffer of buffers) {
        if (offset + buffer.byteLength > result.byteLength) {
          const sub = buffer.subarray(0, result.byteLength - offset);
          result.set(sub, offset);
          return result;
        }
        result.set(buffer, offset);
        offset += buffer.byteLength;
      }
      return result;
    }
    function copy(source, target, targetStart = 0, start = 0, end = source.byteLength) {
      if (end > 0 && end < start) return 0;
      if (end === start) return 0;
      if (source.byteLength === 0 || target.byteLength === 0) return 0;
      if (targetStart < 0) throw new RangeError("targetStart is out of range");
      if (start < 0 || start >= source.byteLength) throw new RangeError("sourceStart is out of range");
      if (end < 0) throw new RangeError("sourceEnd is out of range");
      if (targetStart >= target.byteLength) targetStart = target.byteLength;
      if (end > source.byteLength) end = source.byteLength;
      if (target.byteLength - targetStart < end - start) {
        end = target.length - targetStart + start;
      }
      const len = end - start;
      if (source === target) {
        target.copyWithin(targetStart, start, end);
      } else {
        target.set(source.subarray(start, end), targetStart);
      }
      return len;
    }
    function equals(a, b) {
      if (a === b) return true;
      if (a.byteLength !== b.byteLength) return false;
      const len = a.byteLength;
      a = new DataView(a.buffer, a.byteOffset, a.byteLength);
      b = new DataView(b.buffer, b.byteOffset, b.byteLength);
      let i = 0;
      for (let n = len - len % 4; i < n; i += 4) {
        if (a.getUint32(i, LE) !== b.getUint32(i, LE)) return false;
      }
      for (; i < len; i++) {
        if (a.getUint8(i) !== b.getUint8(i)) return false;
      }
      return true;
    }
    function fill(buffer, value, offset, end, encoding) {
      if (typeof value === "string") {
        if (typeof offset === "string") {
          encoding = offset;
          offset = 0;
          end = buffer.byteLength;
        } else if (typeof end === "string") {
          encoding = end;
          end = buffer.byteLength;
        }
      } else if (typeof value === "number") {
        value = value & 255;
      } else if (typeof value === "boolean") {
        value = +value;
      }
      if (offset < 0 || buffer.byteLength < offset || buffer.byteLength < end) {
        throw new RangeError("Out of range index");
      }
      if (offset === void 0) offset = 0;
      if (end === void 0) end = buffer.byteLength;
      if (end <= offset) return buffer;
      if (!value) value = 0;
      if (typeof value === "number") {
        for (let i = offset; i < end; ++i) {
          buffer[i] = value;
        }
      } else {
        value = isBuffer(value) ? value : from(value, encoding);
        const len = value.byteLength;
        for (let i = 0; i < end - offset; ++i) {
          buffer[i + offset] = value[i % len];
        }
      }
      return buffer;
    }
    function from(value, encodingOrOffset, length) {
      if (typeof value === "string") return fromString(value, encodingOrOffset);
      if (Array.isArray(value)) return fromArray(value);
      if (ArrayBuffer.isView(value)) return fromBuffer(value);
      return fromArrayBuffer(value, encodingOrOffset, length);
    }
    function fromString(string, encoding) {
      const codec = codecFor(encoding);
      const buffer = new Uint8Array(codec.byteLength(string));
      codec.write(buffer, string, 0, buffer.byteLength);
      return buffer;
    }
    function fromArray(array) {
      const buffer = new Uint8Array(array.length);
      buffer.set(array);
      return buffer;
    }
    function fromBuffer(buffer) {
      const copy2 = new Uint8Array(buffer.byteLength);
      copy2.set(buffer);
      return copy2;
    }
    function fromArrayBuffer(arrayBuffer, byteOffset, length) {
      return new Uint8Array(arrayBuffer, byteOffset, length);
    }
    function includes(buffer, value, byteOffset, encoding) {
      return indexOf(buffer, value, byteOffset, encoding) !== -1;
    }
    function bidirectionalIndexOf(buffer, value, byteOffset, encoding, first) {
      if (buffer.byteLength === 0) return -1;
      if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
      } else if (byteOffset === void 0) {
        byteOffset = first ? 0 : buffer.length - 1;
      } else if (byteOffset < 0) {
        byteOffset += buffer.byteLength;
      }
      if (byteOffset >= buffer.byteLength) {
        if (first) return -1;
        else byteOffset = buffer.byteLength - 1;
      } else if (byteOffset < 0) {
        if (first) byteOffset = 0;
        else return -1;
      }
      if (typeof value === "string") {
        value = from(value, encoding);
      } else if (typeof value === "number") {
        value = value & 255;
        if (first) {
          return buffer.indexOf(value, byteOffset);
        } else {
          return buffer.lastIndexOf(value, byteOffset);
        }
      }
      if (value.byteLength === 0) return -1;
      if (first) {
        let foundIndex = -1;
        for (let i = byteOffset; i < buffer.byteLength; i++) {
          if (buffer[i] === value[foundIndex === -1 ? 0 : i - foundIndex]) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === value.byteLength) return foundIndex;
          } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
          }
        }
      } else {
        if (byteOffset + value.byteLength > buffer.byteLength) {
          byteOffset = buffer.byteLength - value.byteLength;
        }
        for (let i = byteOffset; i >= 0; i--) {
          let found = true;
          for (let j = 0; j < value.byteLength; j++) {
            if (buffer[i + j] !== value[j]) {
              found = false;
              break;
            }
          }
          if (found) return i;
        }
      }
      return -1;
    }
    function indexOf(buffer, value, byteOffset, encoding) {
      return bidirectionalIndexOf(
        buffer,
        value,
        byteOffset,
        encoding,
        true
        /* first */
      );
    }
    function lastIndexOf(buffer, value, byteOffset, encoding) {
      return bidirectionalIndexOf(
        buffer,
        value,
        byteOffset,
        encoding,
        false
        /* last */
      );
    }
    function swap(buffer, n, m) {
      const i = buffer[n];
      buffer[n] = buffer[m];
      buffer[m] = i;
    }
    function swap16(buffer) {
      const len = buffer.byteLength;
      if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (let i = 0; i < len; i += 2) swap(buffer, i, i + 1);
      return buffer;
    }
    function swap32(buffer) {
      const len = buffer.byteLength;
      if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (let i = 0; i < len; i += 4) {
        swap(buffer, i, i + 3);
        swap(buffer, i + 1, i + 2);
      }
      return buffer;
    }
    function swap64(buffer) {
      const len = buffer.byteLength;
      if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (let i = 0; i < len; i += 8) {
        swap(buffer, i, i + 7);
        swap(buffer, i + 1, i + 6);
        swap(buffer, i + 2, i + 5);
        swap(buffer, i + 3, i + 4);
      }
      return buffer;
    }
    function toBuffer(buffer) {
      return buffer;
    }
    function toString(buffer, encoding, start = 0, end = buffer.byteLength) {
      const len = buffer.byteLength;
      if (start >= len) return "";
      if (end <= start) return "";
      if (start < 0) start = 0;
      if (end > len) end = len;
      if (start !== 0 || end < len) buffer = buffer.subarray(start, end);
      return codecFor(encoding).toString(buffer);
    }
    function write(buffer, string, offset, length, encoding) {
      if (offset === void 0) {
        encoding = "utf8";
      } else if (length === void 0 && typeof offset === "string") {
        encoding = offset;
        offset = void 0;
      } else if (encoding === void 0 && typeof length === "string") {
        encoding = length;
        length = void 0;
      }
      return codecFor(encoding).write(buffer, string, offset, length);
    }
    function writeDoubleLE(buffer, value, offset) {
      if (offset === void 0) offset = 0;
      const view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
      view.setFloat64(offset, value, true);
      return offset + 8;
    }
    function writeFloatLE(buffer, value, offset) {
      if (offset === void 0) offset = 0;
      const view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
      view.setFloat32(offset, value, true);
      return offset + 4;
    }
    function writeUInt32LE(buffer, value, offset) {
      if (offset === void 0) offset = 0;
      const view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
      view.setUint32(offset, value, true);
      return offset + 4;
    }
    function writeInt32LE(buffer, value, offset) {
      if (offset === void 0) offset = 0;
      const view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
      view.setInt32(offset, value, true);
      return offset + 4;
    }
    function readDoubleLE(buffer, offset) {
      if (offset === void 0) offset = 0;
      const view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
      return view.getFloat64(offset, true);
    }
    function readFloatLE(buffer, offset) {
      if (offset === void 0) offset = 0;
      const view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
      return view.getFloat32(offset, true);
    }
    function readUInt32LE(buffer, offset) {
      if (offset === void 0) offset = 0;
      const view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
      return view.getUint32(offset, true);
    }
    function readInt32LE(buffer, offset) {
      if (offset === void 0) offset = 0;
      const view = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
      return view.getInt32(offset, true);
    }
    module.exports = exports = {
      isBuffer,
      isEncoding,
      alloc,
      allocUnsafe,
      allocUnsafeSlow,
      byteLength,
      compare,
      concat,
      copy,
      equals,
      fill,
      from,
      includes,
      indexOf,
      lastIndexOf,
      swap16,
      swap32,
      swap64,
      toBuffer,
      toString,
      write,
      writeDoubleLE,
      writeFloatLE,
      writeUInt32LE,
      writeInt32LE,
      readDoubleLE,
      readFloatLE,
      readUInt32LE,
      readInt32LE
    };
  }
});

// ../../node_modules/.pnpm/sha512-universal@1.2.1/node_modules/sha512-universal/sha512.js
var require_sha512 = __commonJS({
  "../../node_modules/.pnpm/sha512-universal@1.2.1/node_modules/sha512-universal/sha512.js"(exports, module) {
    var assert = require_nanoassert();
    var b4a = require_browser();
    module.exports = Sha512;
    var BLOCKSIZE = 128;
    var K = [
      1116352408,
      3609767458,
      1899447441,
      602891725,
      3049323471,
      3964484399,
      3921009573,
      2173295548,
      961987163,
      4081628472,
      1508970993,
      3053834265,
      2453635748,
      2937671579,
      2870763221,
      3664609560,
      3624381080,
      2734883394,
      310598401,
      1164996542,
      607225278,
      1323610764,
      1426881987,
      3590304994,
      1925078388,
      4068182383,
      2162078206,
      991336113,
      2614888103,
      633803317,
      3248222580,
      3479774868,
      3835390401,
      2666613458,
      4022224774,
      944711139,
      264347078,
      2341262773,
      604807628,
      2007800933,
      770255983,
      1495990901,
      1249150122,
      1856431235,
      1555081692,
      3175218132,
      1996064986,
      2198950837,
      2554220882,
      3999719339,
      2821834349,
      766784016,
      2952996808,
      2566594879,
      3210313671,
      3203337956,
      3336571891,
      1034457026,
      3584528711,
      2466948901,
      113926993,
      3758326383,
      338241895,
      168717936,
      666307205,
      1188179964,
      773529912,
      1546045734,
      1294757372,
      1522805485,
      1396182291,
      2643833823,
      1695183700,
      2343527390,
      1986661051,
      1014477480,
      2177026350,
      1206759142,
      2456956037,
      344077627,
      2730485921,
      1290863460,
      2820302411,
      3158454273,
      3259730800,
      3505952657,
      3345764771,
      106217008,
      3516065817,
      3606008344,
      3600352804,
      1432725776,
      4094571909,
      1467031594,
      275423344,
      851169720,
      430227734,
      3100823752,
      506948616,
      1363258195,
      659060556,
      3750685593,
      883997877,
      3785050280,
      958139571,
      3318307427,
      1322822218,
      3812723403,
      1537002063,
      2003034995,
      1747873779,
      3602036899,
      1955562222,
      1575990012,
      2024104815,
      1125592928,
      2227730452,
      2716904306,
      2361852424,
      442776044,
      2428436474,
      593698344,
      2756734187,
      3733110249,
      3204031479,
      2999351573,
      3329325298,
      3815920427,
      3391569614,
      3928383900,
      3515267271,
      566280711,
      3940187606,
      3454069534,
      4118630271,
      4000239992,
      116418474,
      1914138554,
      174292421,
      2731055270,
      289380356,
      3203993006,
      460393269,
      320620315,
      685471733,
      587496836,
      852142971,
      1086792851,
      1017036298,
      365543100,
      1126000580,
      2618297676,
      1288033470,
      3409855158,
      1501505948,
      4234509866,
      1607167915,
      987167468,
      1816402316,
      1246189591
    ];
    function Sha512() {
      if (!(this instanceof Sha512)) return new Sha512();
      this.hh = new Int32Array(8);
      this.hl = new Int32Array(8);
      this.buffer = new Uint8Array(128);
      this.finalised = false;
      this.bytesRead = 0;
      this.pos = 0;
      this.hh[0] = 1779033703;
      this.hh[1] = 3144134277;
      this.hh[2] = 1013904242;
      this.hh[3] = 2773480762;
      this.hh[4] = 1359893119;
      this.hh[5] = 2600822924;
      this.hh[6] = 528734635;
      this.hh[7] = 1541459225;
      this.hl[0] = 4089235720;
      this.hl[1] = 2227873595;
      this.hl[2] = 4271175723;
      this.hl[3] = 1595750129;
      this.hl[4] = 2917565137;
      this.hl[5] = 725511199;
      this.hl[6] = 4215389547;
      this.hl[7] = 327033209;
      return this;
    }
    Sha512.prototype.update = function(input, enc) {
      assert(this.finalised === false, "Hash instance finalised");
      var [inputBuf, len] = formatInput(input, enc);
      this.bytesRead += len;
      const full = len + this.pos & -128;
      this.buffer.set(inputBuf.subarray(0, BLOCKSIZE - this.pos), this.pos);
      const pos = this.pos;
      len -= BLOCKSIZE - this.pos;
      if (len >= 0) {
        compress(this.hh, this.hl, this.buffer, 128);
        this.pos = 0;
      }
      if (len > 127) {
        compress(this.hh, this.hl, inputBuf.subarray(BLOCKSIZE - pos, full - pos), full - BLOCKSIZE);
        len %= 128;
      }
      this.buffer.set(inputBuf.subarray(inputBuf.byteLength - len));
      this.pos = this.bytesRead & 127;
      this.buffer.fill(0, this.pos);
      return this;
    };
    Sha512.prototype.digest = function(enc, offset = 0) {
      assert(this.finalised === false, "Hash instance finalised");
      this.finalised = true;
      this.buffer.fill(0, this.pos);
      this.buffer[this.pos] = 128;
      if (this.pos > 111) {
        compress(this.hh, this.hl, this.buffer, 128);
        this.buffer.fill(0);
        this.pos = 0;
      }
      ts64(this.buffer, 120, this.bytesRead / 536870912 | 0, this.bytesRead << 3);
      compress(this.hh, this.hl, this.buffer, 128);
      if (enc instanceof Uint8Array && enc.byteLength > 63) {
        for (let i = 0; i < 8; i++) ts64(enc, 8 * i + offset, this.hh[i], this.hl[i]);
        return enc;
      }
      const resultBuf = new Uint8Array(64);
      for (let i = 0; i < 8; i++) ts64(resultBuf, 8 * i, this.hh[i], this.hl[i]);
      if (typeof enc === "string") {
        return b4a.toString(resultBuf, enc);
      }
      return resultBuf;
    };
    function ts64(x, i, h, l) {
      x[i] = h >> 24 & 255;
      x[i + 1] = h >> 16 & 255;
      x[i + 2] = h >> 8 & 255;
      x[i + 3] = h & 255;
      x[i + 4] = l >> 24 & 255;
      x[i + 5] = l >> 16 & 255;
      x[i + 6] = l >> 8 & 255;
      x[i + 7] = l & 255;
    }
    function formatInput(input, enc) {
      var result = b4a.from(input, enc);
      return [result, result.byteLength];
    }
    function compress(hh, hl, m, n) {
      var wh = new Int32Array(16), wl = new Int32Array(16), bh0, bh1, bh2, bh3, bh4, bh5, bh6, bh7, bl0, bl1, bl2, bl3, bl4, bl5, bl6, bl7, th, tl, i, j, h, l, a, b, c, d;
      var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
      var pos = 0;
      while (n >= 128) {
        for (i = 0; i < 16; i++) {
          j = 8 * i + pos;
          wh[i] = m[j + 0] << 24 | m[j + 1] << 16 | m[j + 2] << 8 | m[j + 3];
          wl[i] = m[j + 4] << 24 | m[j + 5] << 16 | m[j + 6] << 8 | m[j + 7];
        }
        for (i = 0; i < 80; i++) {
          bh0 = ah0;
          bh1 = ah1;
          bh2 = ah2;
          bh3 = ah3;
          bh4 = ah4;
          bh5 = ah5;
          bh6 = ah6;
          bh7 = ah7;
          bl0 = al0;
          bl1 = al1;
          bl2 = al2;
          bl3 = al3;
          bl4 = al4;
          bl5 = al5;
          bl6 = al6;
          bl7 = al7;
          h = ah7;
          l = al7;
          a = l & 65535;
          b = l >>> 16;
          c = h & 65535;
          d = h >>> 16;
          h = (ah4 >>> 14 | al4 << 32 - 14) ^ (ah4 >>> 18 | al4 << 32 - 18) ^ (al4 >>> 41 - 32 | ah4 << 32 - (41 - 32));
          l = (al4 >>> 14 | ah4 << 32 - 14) ^ (al4 >>> 18 | ah4 << 32 - 18) ^ (ah4 >>> 41 - 32 | al4 << 32 - (41 - 32));
          a += l & 65535;
          b += l >>> 16;
          c += h & 65535;
          d += h >>> 16;
          h = ah4 & ah5 ^ ~ah4 & ah6;
          l = al4 & al5 ^ ~al4 & al6;
          a += l & 65535;
          b += l >>> 16;
          c += h & 65535;
          d += h >>> 16;
          h = K[i * 2];
          l = K[i * 2 + 1];
          a += l & 65535;
          b += l >>> 16;
          c += h & 65535;
          d += h >>> 16;
          h = wh[i % 16];
          l = wl[i % 16];
          a += l & 65535;
          b += l >>> 16;
          c += h & 65535;
          d += h >>> 16;
          b += a >>> 16;
          c += b >>> 16;
          d += c >>> 16;
          th = c & 65535 | d << 16;
          tl = a & 65535 | b << 16;
          h = th;
          l = tl;
          a = l & 65535;
          b = l >>> 16;
          c = h & 65535;
          d = h >>> 16;
          h = (ah0 >>> 28 | al0 << 32 - 28) ^ (al0 >>> 34 - 32 | ah0 << 32 - (34 - 32)) ^ (al0 >>> 39 - 32 | ah0 << 32 - (39 - 32));
          l = (al0 >>> 28 | ah0 << 32 - 28) ^ (ah0 >>> 34 - 32 | al0 << 32 - (34 - 32)) ^ (ah0 >>> 39 - 32 | al0 << 32 - (39 - 32));
          a += l & 65535;
          b += l >>> 16;
          c += h & 65535;
          d += h >>> 16;
          h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
          l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
          a += l & 65535;
          b += l >>> 16;
          c += h & 65535;
          d += h >>> 16;
          b += a >>> 16;
          c += b >>> 16;
          d += c >>> 16;
          bh7 = c & 65535 | d << 16;
          bl7 = a & 65535 | b << 16;
          h = bh3;
          l = bl3;
          a = l & 65535;
          b = l >>> 16;
          c = h & 65535;
          d = h >>> 16;
          h = th;
          l = tl;
          a += l & 65535;
          b += l >>> 16;
          c += h & 65535;
          d += h >>> 16;
          b += a >>> 16;
          c += b >>> 16;
          d += c >>> 16;
          bh3 = c & 65535 | d << 16;
          bl3 = a & 65535 | b << 16;
          ah1 = bh0;
          ah2 = bh1;
          ah3 = bh2;
          ah4 = bh3;
          ah5 = bh4;
          ah6 = bh5;
          ah7 = bh6;
          ah0 = bh7;
          al1 = bl0;
          al2 = bl1;
          al3 = bl2;
          al4 = bl3;
          al5 = bl4;
          al6 = bl5;
          al7 = bl6;
          al0 = bl7;
          if (i % 16 === 15) {
            for (j = 0; j < 16; j++) {
              h = wh[j];
              l = wl[j];
              a = l & 65535;
              b = l >>> 16;
              c = h & 65535;
              d = h >>> 16;
              h = wh[(j + 9) % 16];
              l = wl[(j + 9) % 16];
              a += l & 65535;
              b += l >>> 16;
              c += h & 65535;
              d += h >>> 16;
              th = wh[(j + 1) % 16];
              tl = wl[(j + 1) % 16];
              h = (th >>> 1 | tl << 32 - 1) ^ (th >>> 8 | tl << 32 - 8) ^ th >>> 7;
              l = (tl >>> 1 | th << 32 - 1) ^ (tl >>> 8 | th << 32 - 8) ^ (tl >>> 7 | th << 32 - 7);
              a += l & 65535;
              b += l >>> 16;
              c += h & 65535;
              d += h >>> 16;
              th = wh[(j + 14) % 16];
              tl = wl[(j + 14) % 16];
              h = (th >>> 19 | tl << 32 - 19) ^ (tl >>> 61 - 32 | th << 32 - (61 - 32)) ^ th >>> 6;
              l = (tl >>> 19 | th << 32 - 19) ^ (th >>> 61 - 32 | tl << 32 - (61 - 32)) ^ (tl >>> 6 | th << 32 - 6);
              a += l & 65535;
              b += l >>> 16;
              c += h & 65535;
              d += h >>> 16;
              b += a >>> 16;
              c += b >>> 16;
              d += c >>> 16;
              wh[j] = c & 65535 | d << 16;
              wl[j] = a & 65535 | b << 16;
            }
          }
        }
        h = ah0;
        l = al0;
        a = l & 65535;
        b = l >>> 16;
        c = h & 65535;
        d = h >>> 16;
        h = hh[0];
        l = hl[0];
        a += l & 65535;
        b += l >>> 16;
        c += h & 65535;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[0] = ah0 = c & 65535 | d << 16;
        hl[0] = al0 = a & 65535 | b << 16;
        h = ah1;
        l = al1;
        a = l & 65535;
        b = l >>> 16;
        c = h & 65535;
        d = h >>> 16;
        h = hh[1];
        l = hl[1];
        a += l & 65535;
        b += l >>> 16;
        c += h & 65535;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[1] = ah1 = c & 65535 | d << 16;
        hl[1] = al1 = a & 65535 | b << 16;
        h = ah2;
        l = al2;
        a = l & 65535;
        b = l >>> 16;
        c = h & 65535;
        d = h >>> 16;
        h = hh[2];
        l = hl[2];
        a += l & 65535;
        b += l >>> 16;
        c += h & 65535;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[2] = ah2 = c & 65535 | d << 16;
        hl[2] = al2 = a & 65535 | b << 16;
        h = ah3;
        l = al3;
        a = l & 65535;
        b = l >>> 16;
        c = h & 65535;
        d = h >>> 16;
        h = hh[3];
        l = hl[3];
        a += l & 65535;
        b += l >>> 16;
        c += h & 65535;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[3] = ah3 = c & 65535 | d << 16;
        hl[3] = al3 = a & 65535 | b << 16;
        h = ah4;
        l = al4;
        a = l & 65535;
        b = l >>> 16;
        c = h & 65535;
        d = h >>> 16;
        h = hh[4];
        l = hl[4];
        a += l & 65535;
        b += l >>> 16;
        c += h & 65535;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[4] = ah4 = c & 65535 | d << 16;
        hl[4] = al4 = a & 65535 | b << 16;
        h = ah5;
        l = al5;
        a = l & 65535;
        b = l >>> 16;
        c = h & 65535;
        d = h >>> 16;
        h = hh[5];
        l = hl[5];
        a += l & 65535;
        b += l >>> 16;
        c += h & 65535;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[5] = ah5 = c & 65535 | d << 16;
        hl[5] = al5 = a & 65535 | b << 16;
        h = ah6;
        l = al6;
        a = l & 65535;
        b = l >>> 16;
        c = h & 65535;
        d = h >>> 16;
        h = hh[6];
        l = hl[6];
        a += l & 65535;
        b += l >>> 16;
        c += h & 65535;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[6] = ah6 = c & 65535 | d << 16;
        hl[6] = al6 = a & 65535 | b << 16;
        h = ah7;
        l = al7;
        a = l & 65535;
        b = l >>> 16;
        c = h & 65535;
        d = h >>> 16;
        h = hh[7];
        l = hl[7];
        a += l & 65535;
        b += l >>> 16;
        c += h & 65535;
        d += h >>> 16;
        b += a >>> 16;
        c += b >>> 16;
        d += c >>> 16;
        hh[7] = ah7 = c & 65535 | d << 16;
        hl[7] = al7 = a & 65535 | b << 16;
        pos += 128;
        n -= 128;
      }
    }
    function HMAC(key) {
      if (!(this instanceof HMAC)) return new HMAC(key);
      this.pad = b4a.alloc(128);
      this.inner = Sha512();
      this.outer = Sha512();
      const keyhash = b4a.alloc(64);
      if (key.byteLength > 128) {
        Sha512().update(key).digest(keyhash);
        key = keyhash;
      }
      this.pad.fill(54);
      for (let i = 0; i < key.byteLength; i++) {
        this.pad[i] ^= key[i];
      }
      this.inner.update(this.pad);
      this.pad.fill(92);
      for (let i = 0; i < key.byteLength; i++) {
        this.pad[i] ^= key[i];
      }
      this.outer.update(this.pad);
      this.pad.fill(0);
      keyhash.fill(0);
    }
    HMAC.prototype.update = function(input, enc) {
      this.inner.update(input, enc);
      return this;
    };
    HMAC.prototype.digest = function(enc, offset = 0) {
      this.outer.update(this.inner.digest());
      return this.outer.digest(enc, offset);
    };
    Sha512.HMAC = HMAC;
  }
});

// ../../node_modules/.pnpm/sha512-wasm@2.3.4/node_modules/sha512-wasm/sha512.js
var require_sha5122 = __commonJS({
  "../../node_modules/.pnpm/sha512-wasm@2.3.4/node_modules/sha512-wasm/sha512.js"(exports, module) {
    var __commonJS2 = (cb, mod) => function __require2() {
      return mod || (0, cb[Object.keys(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
    };
    var __toBinary = /* @__PURE__ */ (() => {
      var table = new Uint8Array(128);
      for (var i = 0; i < 64; i++)
        table[i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i * 4 - 205] = i;
      return (base64) => {
        var n = base64.length, bytes2 = new Uint8Array((n - (base64[n - 1] == "=") - (base64[n - 2] == "=")) * 3 / 4 | 0);
        for (var i2 = 0, j = 0; i2 < n; ) {
          var c0 = table[base64.charCodeAt(i2++)], c1 = table[base64.charCodeAt(i2++)];
          var c2 = table[base64.charCodeAt(i2++)], c3 = table[base64.charCodeAt(i2++)];
          bytes2[j++] = c0 << 2 | c1 >> 4;
          bytes2[j++] = c1 << 4 | c2 >> 2;
          bytes2[j++] = c2 << 6 | c3;
        }
        return bytes2;
      };
    })();
    var require_sha5123 = __commonJS2({
      "wasm-binary:./sha512.wat"(exports2, module2) {
        module2.exports = __toBinary("AGFzbQEAAAABNAVgAX4BfmAIfn5+fn5+fn4AYAR+fn5+AX5gEX9+fn5+fn5+fn5+fn5+fn5+AGAEf39/fwADBgUAAQIDBAUDAQABBikIfgFCAAt+AUIAC34BQgALfgFCAAt+AUIAC34BQgALfgFCAAt+AUIACwcTAgZtZW1vcnkCAAZzaGE1MTIABAqZHgVCACAAQoCA/P+PgECDQhCJIABC//+DgPD/P4NCEIqEIQAgAEL/gfyH8J/A/wCDQgiJIABCgP6D+I/gv4B/g0IIioQLvAMBBn4jBCMFgyMEQn+FIwaDhSEKIwAjAYMjACMCg4UjASMCg4UhCyMAQhyKIwBCIoqFIwBCJ4qFIQwjBEIOiiMEQhKKhSMEQimKhSENIwcgCnwgDXwgAHwgBHwhCCAMIAt8IQkjAyAIfCQHIAggCXwkAyMHIwSDIwdCf4UjBYOFIQojAyMAgyMDIwGDhSMAIwGDhSELIwNCHIojA0IiioUjA0InioUhDCMHQg6KIwdCEoqFIwdCKYqFIQ0jBiAKfCANfCABfCAFfCEIIAwgC3whCSMCIAh8JAYgCCAJfCQCIwYjB4MjBkJ/hSMEg4UhCiMCIwODIwIjAIOFIwMjAIOFIQsjAkIciiMCQiKKhSMCQieKhSEMIwZCDoojBkISioUjBkIpioUhDSMFIAp8IA18IAJ8IAZ8IQggDCALfCEJIwEgCHwkBSAIIAl8JAEjBSMGgyMFQn+FIweDhSEKIwEjAoMjASMDg4UjAyMCg4UhCyMBQhyKIwFCIoqFIwFCJ4qFIQwjBUIOiiMFQhKKhSMFQimKhSENIwQgCnwgDXwgA3wgB3whCCAMIAt8IQkjACAIfCQEIAggCXwkAAsrACAAQhOKIABCPYqFIABCBoiFIAF8IAJCAYogAkIIioUgAkIHiIUgA3x8C6QRACAAKQPQAUIAUQRAIABCiJLznf/M+YTqADcDACAAQrvOqqbY0Ouzu383AwggAEKr8NP0r+68tzw3AxAgAELx7fT4paf9p6V/NwMYIABC0YWa7/rPlIfRADcDICAAQp/Y+dnCkdqCm383AyggAELr+obav7X2wR83AzAgAEL5wvibkaOz8NsANwM4IABCATcD0AELIAApAwAkACAAKQMIJAEgACkDECQCIAApAxgkAyAAKQMgJAQgACkDKCQFIAApAzAkBiAAKQM4JAcgARAAIQEgAhAAIQIgAxAAIQMgBBAAIQQgBRAAIQUgBhAAIQYgBxAAIQcgCBAAIQggCRAAIQkgChAAIQogCxAAIQsgDBAAIQwgDRAAIQ0gDhAAIQ4gDxAAIQ8gEBAAIRAgASACIAMgBEKi3KK5jfOLxcIAQs3LvZ+SktGb8QBCr/a04v75vuC1f0K8t6eM2PT22mkQASAFIAYgByAIQrjqopq/y7CrOUKZoJewm77E+NkAQpuf5fjK1OCfkn9CmIK2093al46rfxABIAkgCiALIAxCwoSMmIrT6oNYQr7fwauU4NbBEkKM5ZL35LfhmCRC4un+r724n4bVABABIA0gDiAPIBBC75Luk8+ul9/yAEKxrdrY47+s74B/QrWknK7y1IHum39ClM2k+8yu/M1BEAEgDyAKIAIgARACIQEgECALIAMgAhACIQIgASAMIAQgAxACIQMgAiANIAUgBBACIQQgAyAOIAYgBRACIQUgBCAPIAcgBhACIQYgBSAQIAggBxACIQcgBiABIAkgCBACIQggByACIAogCRACIQkgCCADIAsgChACIQogCSAEIAwgCxACIQsgCiAFIA0gDBACIQwgCyAGIA4gDRACIQ0gDCAHIA8gDhACIQ4gDSAIIBAgDxACIQ8gDiAJIAEgEBACIRAgASACIAMgBELSlcX3mbjazWRC48u8wuPwkd9vQrWrs9zouOfgD0LluLK9x7mohiQQASAFIAYgByAIQvWErMn1jcv0LUKDyZv1ppWhusoAQtT3h+rLu6rY3ABCtafFmKib4vz2ABABIAkgCiALIAxCq7+b866qlJ+Yf0KQ5NDt0s3xmKh/Qr/C7MeJ+cmBsH9C5J289/v436y/fxABIA0gDiAPIBBCwp+i7bP+gvBGQqXOqpj5qOTTVULvhI6AnuqY5QZC8Ny50PCsypQUEAEgDyAKIAIgARACIQEgECALIAMgAhACIQIgASAMIAQgAxACIQMgAiANIAUgBBACIQQgAyAOIAYgBRACIQUgBCAPIAcgBhACIQYgBSAQIAggBxACIQcgBiABIAkgCBACIQggByACIAogCRACIQkgCCADIAsgChACIQogCSAEIAwgCxACIQsgCiAFIA0gDBACIQwgCyAGIA4gDRACIQ0gDCAHIA8gDhACIQ4gDSAIIBAgDxACIQ8gDiAJIAEgEBACIRAgASACIAMgBEL838i21NDC2ydCppKb4YWnyI0uQu3VkNbFv5uWzQBC3+fW7Lmig5zTABABIAUgBiAHIAhC3se93cjqnIXlAEKo5d7js9eCtfYAQubdtr/kpbLhgX9Cu+qIpNGQi7mSfxABIAkgCiALIAxC5IbE55SU+t+if0KB4Ijiu8mZjah/QpGv4oeN7uKlQkKw/NKysLSUtkcQASANIA4gDyAQQpikvbedg7rJUUKQ0parxcTBzFZCqsDEu9WwjYd0Qrij75WDjqi1EBABIA8gCiACIAEQAiEBIBAgCyADIAIQAiECIAEgDCAEIAMQAiEDIAIgDSAFIAQQAiEEIAMgDiAGIAUQAiEFIAQgDyAHIAYQAiEGIAUgECAIIAcQAiEHIAYgASAJIAgQAiEIIAcgAiAKIAkQAiEJIAggAyALIAoQAiEKIAkgBCAMIAsQAiELIAogBSANIAwQAiEMIAsgBiAOIA0QAiENIAwgByAPIA4QAiEOIA0gCCAQIA8QAiEPIA4gCSABIBAQAiEQIAEgAiADIARCyKHLxuuisNIZQtPWhoqFgdubHkKZ17v8zemdpCdCqJHtjN6Wr9g0EAEgBSAGIAcgCELjtKWuvJaDjjlCy5WGmq7JquzOAELzxo+798myztsAQqPxyrW9/puX6AAQASAJIAogCyAMQvzlvu/l3eDH9ABC4N7cmPTt2NL4AELy1sKPyoKe5IR/QuzzkNOBwcDjjH8QASANIA4gDyAQQqi8jJui/7/fkH9C6fuK9L2dm6ikf0KV8pmW+/7o/L5/QqumyZuunt64RhABIA8gCiACIAEQAiEBIBAgCyADIAIQAiECIAEgDCAEIAMQAiEDIAIgDSAFIAQQAiEEIAMgDiAGIAUQAiEFIAQgDyAHIAYQAiEGIAUgECAIIAcQAiEHIAYgASAJIAgQAiEIIAcgAiAKIAkQAiEJIAggAyALIAoQAiEKIAkgBCAMIAsQAiELIAogBSANIAwQAiEMIAsgBiAOIA0QAiENIAwgByAPIA4QAiEOIA0gCCAQIA8QAiEPIA4gCSABIBAQAiEQIAEgAiADIARCnMOZ0e7Zz5NKQoeEg47ymK7DUUKe1oPv7Lqf7WpC+KK78/7v0751EAEgBSAGIAcgCEK6392Qp/WZ+AZCprGiltq437EKQq6b5PfLgOafEUKbjvGY0ebCuBsQASAJIAogCyAMQoT7kZjS/t3tKEKTyZyGtO+q5TJCvP2mrqHBr888QsyawODJ+NmOwwAQASANIA4gDyAQQraF+dnsl/XizABCqvyV48+zyr/ZAELs9dvWs/Xb5d8AQpewndLEsYai7AAQASAAIAApAwAjAHw3AwAgACAAKQMIIwF8NwMIIAAgACkDECMCfDcDECAAIAApAxgjA3w3AxggACAAKQMgIwR8NwMgIAAgACkDKCMFfDcDKCAAIAApAzAjBnw3AzAgACAAKQM4Iwd8NwM4C8MIARV+IAApA0AhBCAAKQNIIQUgBEL/AIMgAq18IQggBCEGIAQgAq18IQQgACAENwNAIAQgBlQEQCAFQgF8IQUgACAFNwNICwJAIAApA1AhCSAAKQNYIQogACkDYCELIAApA2ghDCAAKQNwIQ0gACkDeCEOIAApA4ABIQ8gACkDiAEhECAAKQOQASERIAApA5gBIRIgACkDoAEhEyAAKQOoASEUIAApA7ABIRUgACkDuAEhFiAAKQPAASEXIAApA8gBIRggCEKAAX0iCEIAUw0AIAAgCSAKIAsgDCANIA4gDyAQIBEgEiATIBQgFSAWIBcgGBADA0AgASkDACEJIAEpAwghCiABKQMQIQsgASkDGCEMIAEpAyAhDSABKQMoIQ4gASkDMCEPIAEpAzghECABKQNAIREgASkDSCESIAEpA1AhEyABKQNYIRQgASkDYCEVIAEpA2ghFiABKQNwIRcgASkDeCEYIAFBgAFqIQEgCEKAAX0iCEIAUwRAIAAgCTcDUCAAIAo3A1ggACALNwNgIAAgDDcDaCAAIA03A3AgACAONwN4IAAgDzcDgAEgACAQNwOIASAAIBE3A5ABIAAgEjcDmAEgACATNwOgASAAIBQ3A6gBIAAgFTcDsAEgACAWNwO4ASAAIBc3A8ABIAAgGDcDyAEMAgsgACAJIAogCyAMIA0gDiAPIBAgESASIBMgFCAVIBYgFyAYEAMMAAsLIANBAUYEQCAEQv8AgyEIQoABIAhCB4NCA4aGIQcCQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAgCKdBA3YODwMEBQYHCAkKCwwNDg8QAQILCyAHIBeEIRdCACEHCyAHIBiEIRhCACEHIAAgCSAKIAsgDCANIA4gDyAQIBEgEiATIBQgFSAWIBcgGBADIAAgBDcDQEIAIQlCACEKQgAhC0IAIQxCACENQgAhDkIAIQ9CACEQQgAhEUIAIRJCACETQgAhFEIAIRVCACEWQgAhF0IAIRgLIAcgCYQhCUIAIQcLIAcgCoQhCkIAIQcLIAcgC4QhC0IAIQcLIAcgDIQhDEIAIQcLIAcgDYQhDUIAIQcLIAcgDoQhDkIAIQcLIAcgD4QhD0IAIQcLIAcgEIQhEEIAIQcLIAcgEYQhEUIAIQcLIAcgEoQhEkIAIQcLIAcgE4QhE0IAIQcLIAcgFIQhFEIAIQcLIAcgFYQhFUIAIQcLIAcgFoQhFkIAIQcLIARCPYggBUIDiHwQACEXIARCCH4QACEYIAAgCSAKIAsgDCANIA4gDyAQIBEgEiATIBQgFSAWIBcgGBADIAAgACkDABAANwMAIAAgACkDCBAANwMIIAAgACkDEBAANwMQIAAgACkDGBAANwMYIAAgACkDIBAANwMgIAAgACkDKBAANwMoIAAgACkDMBAANwMwIAAgACkDOBAANwM4Cws=");
      }
    });
    var bytes = require_sha5123();
    var compiled = new WebAssembly.Module(bytes);
    module.exports = (imports) => {
      const instance = new WebAssembly.Instance(compiled, imports);
      return instance.exports;
    };
  }
});

// ../../node_modules/.pnpm/sha512-wasm@2.3.4/node_modules/sha512-wasm/index.js
var require_sha512_wasm = __commonJS({
  "../../node_modules/.pnpm/sha512-wasm@2.3.4/node_modules/sha512-wasm/index.js"(exports, module) {
    var assert = require_nanoassert();
    var b4a = require_browser();
    var wasm = typeof WebAssembly !== "undefined" && require_sha5122()({
      imports: {
        debug: {
          log(...args) {
            console.log(...args.map((int) => (int >>> 0).toString(16).padStart(8, "0")));
          },
          log_tee(arg) {
            console.log((arg >>> 0).toString(16).padStart(8, "0"));
            return arg;
          }
        }
      }
    });
    var head = 0;
    var freeList = [];
    module.exports = Sha512;
    var SHA512_BYTES = module.exports.SHA512_BYTES = 64;
    var INPUT_OFFSET = 80;
    var STATEBYTES = 216;
    var BLOCKSIZE = 128;
    function Sha512() {
      if (!(this instanceof Sha512)) return new Sha512();
      if (!wasm) throw new Error("WASM not loaded. Wait for Sha512.ready(cb)");
      if (!freeList.length) {
        freeList.push(head);
        head += STATEBYTES;
      }
      this.finalized = false;
      this.digestLength = SHA512_BYTES;
      this.pointer = freeList.pop();
      this.pos = 0;
      this.wasm = wasm;
      this._memory = new Uint8Array(wasm.memory.buffer);
      this._memory.fill(0, this.pointer, this.pointer + STATEBYTES);
      if (this.pointer + this.digestLength > this._memory.length) this._realloc(this.pointer + STATEBYTES);
    }
    Sha512.prototype._realloc = function(size) {
      wasm.memory.grow(Math.max(0, Math.ceil(Math.abs(size - this._memory.length) / 65536)));
      this._memory = new Uint8Array(wasm.memory.buffer);
    };
    Sha512.prototype.update = function(input, enc) {
      assert(this.finalized === false, "Hash instance finalized");
      if (head % 8 !== 0) head += 8 - head % 8;
      assert(head % 8 === 0, "input should be aligned for int64");
      const [inputBuf, length] = formatInput(input, enc);
      assert(inputBuf instanceof Uint8Array, "input must be Uint8Array or Buffer");
      if (head + input.length > this._memory.length) this._realloc(head + input.length);
      this._memory.fill(0, head, head + roundUp(length, BLOCKSIZE) - BLOCKSIZE);
      this._memory.set(inputBuf.subarray(0, BLOCKSIZE - this.pos), this.pointer + INPUT_OFFSET + this.pos);
      this._memory.set(inputBuf.subarray(BLOCKSIZE - this.pos), head);
      this.pos = this.pos + length & 127;
      wasm.sha512(this.pointer, head, length, 0);
      return this;
    };
    Sha512.prototype.digest = function(enc, offset = 0) {
      assert(this.finalized === false, "Hash instance finalized");
      this.finalized = true;
      freeList.push(this.pointer);
      const paddingStart = this.pointer + INPUT_OFFSET + this.pos;
      this._memory.fill(0, paddingStart, this.pointer + INPUT_OFFSET + BLOCKSIZE);
      wasm.sha512(this.pointer, head, 0, 1);
      const resultBuf = this._memory.subarray(this.pointer, this.pointer + this.digestLength);
      if (!enc) {
        return resultBuf;
      }
      if (typeof enc === "string") {
        return b4a.toString(resultBuf, enc);
      }
      assert(enc instanceof Uint8Array, "output must be Uint8Array or Buffer");
      assert(
        enc.byteLength >= this.digestLength + offset,
        "output must have at least 'SHA512_BYTES' bytes remaining"
      );
      for (let i = 0; i < this.digestLength; i++) {
        enc[i + offset] = resultBuf[i];
      }
      return enc;
    };
    Sha512.WASM = wasm;
    Sha512.WASM_SUPPORTED = typeof WebAssembly !== "undefined";
    Sha512.ready = function(cb) {
      if (!cb) cb = noop;
      if (!wasm) return cb(new Error("WebAssembly not supported"));
      cb();
      return Promise.resolve();
    };
    Sha512.prototype.ready = Sha512.ready;
    function HMAC(key) {
      if (!(this instanceof HMAC)) return new HMAC(key);
      this.pad = b4a.alloc(128);
      this.inner = Sha512();
      this.outer = Sha512();
      const keyhash = b4a.alloc(64);
      if (key.byteLength > 128) {
        Sha512().update(key).digest(keyhash);
        key = keyhash;
      }
      this.pad.fill(54);
      for (let i = 0; i < key.byteLength; i++) {
        this.pad[i] ^= key[i];
      }
      this.inner.update(this.pad);
      this.pad.fill(92);
      for (let i = 0; i < key.byteLength; i++) {
        this.pad[i] ^= key[i];
      }
      this.outer.update(this.pad);
      this.pad.fill(0);
      keyhash.fill(0);
    }
    HMAC.prototype.update = function(input, enc) {
      this.inner.update(input, enc);
      return this;
    };
    HMAC.prototype.digest = function(enc, offset = 0) {
      this.outer.update(this.inner.digest());
      return this.outer.digest(enc, offset);
    };
    Sha512.HMAC = HMAC;
    function noop() {
    }
    function formatInput(input, enc) {
      var result = b4a.from(input, enc);
      return [result, result.byteLength];
    }
    function roundUp(n, base) {
      return n + base - 1 & -base;
    }
  }
});

// ../../node_modules/.pnpm/sha512-universal@1.2.1/node_modules/sha512-universal/index.js
var require_sha512_universal = __commonJS({
  "../../node_modules/.pnpm/sha512-universal@1.2.1/node_modules/sha512-universal/index.js"(exports, module) {
    var js = require_sha512();
    var wasm = require_sha512_wasm();
    var Proto = js;
    module.exports = function() {
      return new Proto();
    };
    module.exports.ready = function(cb) {
      wasm.ready(function() {
        cb();
      });
    };
    module.exports.WASM_SUPPORTED = wasm.SUPPORTED;
    module.exports.WASM_LOADED = false;
    var SHA512_BYTES = module.exports.SHA512_BYTES = 64;
    wasm.ready(function(err) {
      if (!err) {
        module.exports.WASM_LOADED = true;
        module.exports = Proto = wasm;
      }
    });
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_auth.js
var require_crypto_auth = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_auth.js"(exports, module) {
    var { crypto_verify_32 } = require_crypto_verify();
    var Sha512 = require_sha512_universal();
    var assert = require_nanoassert();
    var crypto_auth_BYTES = 32;
    var crypto_auth_KEYBYTES = 32;
    function crypto_auth(out, input, k) {
      assert(out.byteLength === crypto_auth_BYTES, "out should be 'crypto_auth_BYTES' in length");
      assert(k.byteLength === crypto_auth_KEYBYTES, "key should be 'crypto_auth_KEYBYTES' in length");
      const out0 = new Uint8Array(64);
      const hmac = Sha512.HMAC(k);
      hmac.update(input);
      hmac.digest(out0);
      out.set(out0.subarray(0, 32));
    }
    function crypto_auth_verify(h, input, k) {
      assert(h.byteLength === crypto_auth_BYTES, "h should be 'crypto_auth_BYTES' in length");
      assert(k.byteLength === crypto_auth_KEYBYTES, "key should be 'crypto_auth_KEYBYTES' in length");
      const correct = Sha512.HMAC(k).update(input).digest();
      return crypto_verify_32(h, 0, correct, 0);
    }
    module.exports = {
      crypto_auth_BYTES,
      crypto_auth_KEYBYTES,
      crypto_auth,
      crypto_auth_verify
    };
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_hash.js
var require_crypto_hash = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_hash.js"(exports, module) {
    var sha512 = require_sha512_universal();
    var assert = require_nanoassert();
    if (new Uint16Array([1])[0] !== 1) throw new Error("Big endian architecture is not supported.");
    var crypto_hash_sha512_BYTES = 64;
    var crypto_hash_BYTES = crypto_hash_sha512_BYTES;
    function crypto_hash_sha512(out, m, n) {
      assert(out.byteLength === crypto_hash_sha512_BYTES, "out must be 'crypto_hash_sha512_BYTES' bytes long");
      sha512().update(m.subarray(0, n)).digest(out);
      return 0;
    }
    function crypto_hash(out, m, n) {
      return crypto_hash_sha512(out, m, n);
    }
    module.exports = {
      crypto_hash,
      crypto_hash_sha512,
      crypto_hash_sha512_BYTES,
      crypto_hash_BYTES
    };
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/internal/ed25519.js
var require_ed25519 = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/internal/ed25519.js"(exports, module) {
    if (new Uint16Array([1])[0] !== 1) throw new Error("Big endian architecture is not supported.");
    var gf = function(init) {
      var i, r = new Float64Array(16);
      if (init) for (i = 0; i < init.length; i++) r[i] = init[i];
      return r;
    };
    var _0 = new Uint8Array(16);
    var _9 = new Uint8Array(32);
    _9[0] = 9;
    var gf0 = gf();
    var gf1 = gf([1]);
    var _121665 = gf([56129, 1]);
    var D = gf([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]);
    var D2 = gf([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]);
    var X = gf([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]);
    var Y = gf([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]);
    var I = gf([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
    function A(o, a, b) {
      for (var i = 0; i < 16; i++) o[i] = a[i] + b[i];
    }
    function Z(o, a, b) {
      for (var i = 0; i < 16; i++) o[i] = a[i] - b[i];
    }
    function M(o, a, b) {
      var v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
      v = a[0];
      t0 += v * b0;
      t1 += v * b1;
      t2 += v * b2;
      t3 += v * b3;
      t4 += v * b4;
      t5 += v * b5;
      t6 += v * b6;
      t7 += v * b7;
      t8 += v * b8;
      t9 += v * b9;
      t10 += v * b10;
      t11 += v * b11;
      t12 += v * b12;
      t13 += v * b13;
      t14 += v * b14;
      t15 += v * b15;
      v = a[1];
      t1 += v * b0;
      t2 += v * b1;
      t3 += v * b2;
      t4 += v * b3;
      t5 += v * b4;
      t6 += v * b5;
      t7 += v * b6;
      t8 += v * b7;
      t9 += v * b8;
      t10 += v * b9;
      t11 += v * b10;
      t12 += v * b11;
      t13 += v * b12;
      t14 += v * b13;
      t15 += v * b14;
      t16 += v * b15;
      v = a[2];
      t2 += v * b0;
      t3 += v * b1;
      t4 += v * b2;
      t5 += v * b3;
      t6 += v * b4;
      t7 += v * b5;
      t8 += v * b6;
      t9 += v * b7;
      t10 += v * b8;
      t11 += v * b9;
      t12 += v * b10;
      t13 += v * b11;
      t14 += v * b12;
      t15 += v * b13;
      t16 += v * b14;
      t17 += v * b15;
      v = a[3];
      t3 += v * b0;
      t4 += v * b1;
      t5 += v * b2;
      t6 += v * b3;
      t7 += v * b4;
      t8 += v * b5;
      t9 += v * b6;
      t10 += v * b7;
      t11 += v * b8;
      t12 += v * b9;
      t13 += v * b10;
      t14 += v * b11;
      t15 += v * b12;
      t16 += v * b13;
      t17 += v * b14;
      t18 += v * b15;
      v = a[4];
      t4 += v * b0;
      t5 += v * b1;
      t6 += v * b2;
      t7 += v * b3;
      t8 += v * b4;
      t9 += v * b5;
      t10 += v * b6;
      t11 += v * b7;
      t12 += v * b8;
      t13 += v * b9;
      t14 += v * b10;
      t15 += v * b11;
      t16 += v * b12;
      t17 += v * b13;
      t18 += v * b14;
      t19 += v * b15;
      v = a[5];
      t5 += v * b0;
      t6 += v * b1;
      t7 += v * b2;
      t8 += v * b3;
      t9 += v * b4;
      t10 += v * b5;
      t11 += v * b6;
      t12 += v * b7;
      t13 += v * b8;
      t14 += v * b9;
      t15 += v * b10;
      t16 += v * b11;
      t17 += v * b12;
      t18 += v * b13;
      t19 += v * b14;
      t20 += v * b15;
      v = a[6];
      t6 += v * b0;
      t7 += v * b1;
      t8 += v * b2;
      t9 += v * b3;
      t10 += v * b4;
      t11 += v * b5;
      t12 += v * b6;
      t13 += v * b7;
      t14 += v * b8;
      t15 += v * b9;
      t16 += v * b10;
      t17 += v * b11;
      t18 += v * b12;
      t19 += v * b13;
      t20 += v * b14;
      t21 += v * b15;
      v = a[7];
      t7 += v * b0;
      t8 += v * b1;
      t9 += v * b2;
      t10 += v * b3;
      t11 += v * b4;
      t12 += v * b5;
      t13 += v * b6;
      t14 += v * b7;
      t15 += v * b8;
      t16 += v * b9;
      t17 += v * b10;
      t18 += v * b11;
      t19 += v * b12;
      t20 += v * b13;
      t21 += v * b14;
      t22 += v * b15;
      v = a[8];
      t8 += v * b0;
      t9 += v * b1;
      t10 += v * b2;
      t11 += v * b3;
      t12 += v * b4;
      t13 += v * b5;
      t14 += v * b6;
      t15 += v * b7;
      t16 += v * b8;
      t17 += v * b9;
      t18 += v * b10;
      t19 += v * b11;
      t20 += v * b12;
      t21 += v * b13;
      t22 += v * b14;
      t23 += v * b15;
      v = a[9];
      t9 += v * b0;
      t10 += v * b1;
      t11 += v * b2;
      t12 += v * b3;
      t13 += v * b4;
      t14 += v * b5;
      t15 += v * b6;
      t16 += v * b7;
      t17 += v * b8;
      t18 += v * b9;
      t19 += v * b10;
      t20 += v * b11;
      t21 += v * b12;
      t22 += v * b13;
      t23 += v * b14;
      t24 += v * b15;
      v = a[10];
      t10 += v * b0;
      t11 += v * b1;
      t12 += v * b2;
      t13 += v * b3;
      t14 += v * b4;
      t15 += v * b5;
      t16 += v * b6;
      t17 += v * b7;
      t18 += v * b8;
      t19 += v * b9;
      t20 += v * b10;
      t21 += v * b11;
      t22 += v * b12;
      t23 += v * b13;
      t24 += v * b14;
      t25 += v * b15;
      v = a[11];
      t11 += v * b0;
      t12 += v * b1;
      t13 += v * b2;
      t14 += v * b3;
      t15 += v * b4;
      t16 += v * b5;
      t17 += v * b6;
      t18 += v * b7;
      t19 += v * b8;
      t20 += v * b9;
      t21 += v * b10;
      t22 += v * b11;
      t23 += v * b12;
      t24 += v * b13;
      t25 += v * b14;
      t26 += v * b15;
      v = a[12];
      t12 += v * b0;
      t13 += v * b1;
      t14 += v * b2;
      t15 += v * b3;
      t16 += v * b4;
      t17 += v * b5;
      t18 += v * b6;
      t19 += v * b7;
      t20 += v * b8;
      t21 += v * b9;
      t22 += v * b10;
      t23 += v * b11;
      t24 += v * b12;
      t25 += v * b13;
      t26 += v * b14;
      t27 += v * b15;
      v = a[13];
      t13 += v * b0;
      t14 += v * b1;
      t15 += v * b2;
      t16 += v * b3;
      t17 += v * b4;
      t18 += v * b5;
      t19 += v * b6;
      t20 += v * b7;
      t21 += v * b8;
      t22 += v * b9;
      t23 += v * b10;
      t24 += v * b11;
      t25 += v * b12;
      t26 += v * b13;
      t27 += v * b14;
      t28 += v * b15;
      v = a[14];
      t14 += v * b0;
      t15 += v * b1;
      t16 += v * b2;
      t17 += v * b3;
      t18 += v * b4;
      t19 += v * b5;
      t20 += v * b6;
      t21 += v * b7;
      t22 += v * b8;
      t23 += v * b9;
      t24 += v * b10;
      t25 += v * b11;
      t26 += v * b12;
      t27 += v * b13;
      t28 += v * b14;
      t29 += v * b15;
      v = a[15];
      t15 += v * b0;
      t16 += v * b1;
      t17 += v * b2;
      t18 += v * b3;
      t19 += v * b4;
      t20 += v * b5;
      t21 += v * b6;
      t22 += v * b7;
      t23 += v * b8;
      t24 += v * b9;
      t25 += v * b10;
      t26 += v * b11;
      t27 += v * b12;
      t28 += v * b13;
      t29 += v * b14;
      t30 += v * b15;
      t0 += 38 * t16;
      t1 += 38 * t17;
      t2 += 38 * t18;
      t3 += 38 * t19;
      t4 += 38 * t20;
      t5 += 38 * t21;
      t6 += 38 * t22;
      t7 += 38 * t23;
      t8 += 38 * t24;
      t9 += 38 * t25;
      t10 += 38 * t26;
      t11 += 38 * t27;
      t12 += 38 * t28;
      t13 += 38 * t29;
      t14 += 38 * t30;
      c = 1;
      v = t0 + c + 65535;
      c = Math.floor(v / 65536);
      t0 = v - c * 65536;
      v = t1 + c + 65535;
      c = Math.floor(v / 65536);
      t1 = v - c * 65536;
      v = t2 + c + 65535;
      c = Math.floor(v / 65536);
      t2 = v - c * 65536;
      v = t3 + c + 65535;
      c = Math.floor(v / 65536);
      t3 = v - c * 65536;
      v = t4 + c + 65535;
      c = Math.floor(v / 65536);
      t4 = v - c * 65536;
      v = t5 + c + 65535;
      c = Math.floor(v / 65536);
      t5 = v - c * 65536;
      v = t6 + c + 65535;
      c = Math.floor(v / 65536);
      t6 = v - c * 65536;
      v = t7 + c + 65535;
      c = Math.floor(v / 65536);
      t7 = v - c * 65536;
      v = t8 + c + 65535;
      c = Math.floor(v / 65536);
      t8 = v - c * 65536;
      v = t9 + c + 65535;
      c = Math.floor(v / 65536);
      t9 = v - c * 65536;
      v = t10 + c + 65535;
      c = Math.floor(v / 65536);
      t10 = v - c * 65536;
      v = t11 + c + 65535;
      c = Math.floor(v / 65536);
      t11 = v - c * 65536;
      v = t12 + c + 65535;
      c = Math.floor(v / 65536);
      t12 = v - c * 65536;
      v = t13 + c + 65535;
      c = Math.floor(v / 65536);
      t13 = v - c * 65536;
      v = t14 + c + 65535;
      c = Math.floor(v / 65536);
      t14 = v - c * 65536;
      v = t15 + c + 65535;
      c = Math.floor(v / 65536);
      t15 = v - c * 65536;
      t0 += c - 1 + 37 * (c - 1);
      c = 1;
      v = t0 + c + 65535;
      c = Math.floor(v / 65536);
      t0 = v - c * 65536;
      v = t1 + c + 65535;
      c = Math.floor(v / 65536);
      t1 = v - c * 65536;
      v = t2 + c + 65535;
      c = Math.floor(v / 65536);
      t2 = v - c * 65536;
      v = t3 + c + 65535;
      c = Math.floor(v / 65536);
      t3 = v - c * 65536;
      v = t4 + c + 65535;
      c = Math.floor(v / 65536);
      t4 = v - c * 65536;
      v = t5 + c + 65535;
      c = Math.floor(v / 65536);
      t5 = v - c * 65536;
      v = t6 + c + 65535;
      c = Math.floor(v / 65536);
      t6 = v - c * 65536;
      v = t7 + c + 65535;
      c = Math.floor(v / 65536);
      t7 = v - c * 65536;
      v = t8 + c + 65535;
      c = Math.floor(v / 65536);
      t8 = v - c * 65536;
      v = t9 + c + 65535;
      c = Math.floor(v / 65536);
      t9 = v - c * 65536;
      v = t10 + c + 65535;
      c = Math.floor(v / 65536);
      t10 = v - c * 65536;
      v = t11 + c + 65535;
      c = Math.floor(v / 65536);
      t11 = v - c * 65536;
      v = t12 + c + 65535;
      c = Math.floor(v / 65536);
      t12 = v - c * 65536;
      v = t13 + c + 65535;
      c = Math.floor(v / 65536);
      t13 = v - c * 65536;
      v = t14 + c + 65535;
      c = Math.floor(v / 65536);
      t14 = v - c * 65536;
      v = t15 + c + 65535;
      c = Math.floor(v / 65536);
      t15 = v - c * 65536;
      t0 += c - 1 + 37 * (c - 1);
      o[0] = t0;
      o[1] = t1;
      o[2] = t2;
      o[3] = t3;
      o[4] = t4;
      o[5] = t5;
      o[6] = t6;
      o[7] = t7;
      o[8] = t8;
      o[9] = t9;
      o[10] = t10;
      o[11] = t11;
      o[12] = t12;
      o[13] = t13;
      o[14] = t14;
      o[15] = t15;
    }
    function S(o, a) {
      M(o, a, a);
    }
    function sel25519(p, q, b) {
      var t, c = ~(b - 1);
      for (var i = 0; i < 16; i++) {
        t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
      }
    }
    function pack25519(o, n) {
      var i, j, b;
      var m = gf(), t = gf();
      for (i = 0; i < 16; i++) t[i] = n[i];
      car25519(t);
      car25519(t);
      car25519(t);
      for (j = 0; j < 2; j++) {
        m[0] = t[0] - 65517;
        for (i = 1; i < 15; i++) {
          m[i] = t[i] - 65535 - (m[i - 1] >> 16 & 1);
          m[i - 1] &= 65535;
        }
        m[15] = t[15] - 32767 - (m[14] >> 16 & 1);
        b = m[15] >> 16 & 1;
        m[14] &= 65535;
        sel25519(t, m, 1 - b);
      }
      for (i = 0; i < 16; i++) {
        o[2 * i] = t[i] & 255;
        o[2 * i + 1] = t[i] >> 8;
      }
    }
    function unpack25519(o, n) {
      var i;
      for (i = 0; i < 16; i++) o[i] = n[2 * i] + (n[2 * i + 1] << 8);
      o[15] &= 32767;
    }
    function inv25519(o, i) {
      var c = gf();
      var a;
      for (a = 0; a < 16; a++) c[a] = i[a];
      for (a = 253; a >= 0; a--) {
        S(c, c);
        if (a !== 2 && a !== 4) M(c, c, i);
      }
      for (a = 0; a < 16; a++) o[a] = c[a];
    }
    function car25519(o) {
      var i, v, c = 1;
      for (i = 0; i < 16; i++) {
        v = o[i] + c + 65535;
        c = Math.floor(v / 65536);
        o[i] = v - c * 65536;
      }
      o[0] += c - 1 + 37 * (c - 1);
    }
    module.exports = {
      gf,
      A,
      Z,
      M,
      S,
      sel25519,
      pack25519,
      unpack25519,
      inv25519,
      gf0,
      gf1,
      _9,
      _121665,
      D,
      D2,
      X,
      Y,
      I
    };
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_scalarmult.js
var require_crypto_scalarmult = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_scalarmult.js"(exports, module) {
    var { _9, _121665, gf, inv25519, pack25519, unpack25519, sel25519, A, M, Z, S } = require_ed25519();
    var crypto_scalarmult_BYTES = 32;
    var crypto_scalarmult_SCALARBYTES = 32;
    module.exports = {
      crypto_scalarmult,
      crypto_scalarmult_base,
      crypto_scalarmult_BYTES,
      crypto_scalarmult_SCALARBYTES
    };
    function crypto_scalarmult(q, n, p) {
      check(q, crypto_scalarmult_BYTES);
      check(n, crypto_scalarmult_SCALARBYTES);
      check(p, crypto_scalarmult_BYTES);
      var z = new Uint8Array(32);
      var x = new Float64Array(80), r, i;
      var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf();
      for (i = 0; i < 31; i++) z[i] = n[i];
      z[31] = n[31] & 127 | 64;
      z[0] &= 248;
      unpack25519(x, p);
      for (i = 0; i < 16; i++) {
        b[i] = x[i];
        d[i] = a[i] = c[i] = 0;
      }
      a[0] = d[0] = 1;
      for (i = 254; i >= 0; --i) {
        r = z[i >>> 3] >>> (i & 7) & 1;
        sel25519(a, b, r);
        sel25519(c, d, r);
        A(e, a, c);
        Z(a, a, c);
        A(c, b, d);
        Z(b, b, d);
        S(d, e);
        S(f, a);
        M(a, c, a);
        M(c, b, e);
        A(e, a, c);
        Z(a, a, c);
        S(b, a);
        Z(c, d, f);
        M(a, c, _121665);
        A(a, a, d);
        M(c, c, a);
        M(a, d, f);
        M(d, b, x);
        S(b, e);
        sel25519(a, b, r);
        sel25519(c, d, r);
      }
      for (i = 0; i < 16; i++) {
        x[i + 16] = a[i];
        x[i + 32] = c[i];
        x[i + 48] = b[i];
        x[i + 64] = d[i];
      }
      var x32 = x.subarray(32);
      var x16 = x.subarray(16);
      inv25519(x32, x32);
      M(x16, x16, x32);
      pack25519(q, x16);
      return 0;
    }
    function crypto_scalarmult_base(q, n) {
      return crypto_scalarmult(q, n, _9);
    }
    function check(buf, len) {
      if (!buf || len && buf.length < len) throw new Error("Argument must be a buffer" + (len ? " of length " + len : ""));
    }
  }
});

// ../../node_modules/.pnpm/blake2b-wasm@2.4.0/node_modules/blake2b-wasm/blake2b.js
var require_blake2b = __commonJS({
  "../../node_modules/.pnpm/blake2b-wasm@2.4.0/node_modules/blake2b-wasm/blake2b.js"(exports, module) {
    var __commonJS2 = (cb, mod) => function __require2() {
      return mod || (0, cb[Object.keys(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
    };
    var __toBinary = /* @__PURE__ */ (() => {
      var table = new Uint8Array(128);
      for (var i = 0; i < 64; i++)
        table[i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i * 4 - 205] = i;
      return (base64) => {
        var n = base64.length, bytes2 = new Uint8Array((n - (base64[n - 1] == "=") - (base64[n - 2] == "=")) * 3 / 4 | 0);
        for (var i2 = 0, j = 0; i2 < n; ) {
          var c0 = table[base64.charCodeAt(i2++)], c1 = table[base64.charCodeAt(i2++)];
          var c2 = table[base64.charCodeAt(i2++)], c3 = table[base64.charCodeAt(i2++)];
          bytes2[j++] = c0 << 2 | c1 >> 4;
          bytes2[j++] = c1 << 4 | c2 >> 2;
          bytes2[j++] = c2 << 6 | c3;
        }
        return bytes2;
      };
    })();
    var require_blake2b3 = __commonJS2({
      "wasm-binary:./blake2b.wat"(exports2, module2) {
        module2.exports = __toBinary("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");
      }
    });
    var bytes = require_blake2b3();
    var compiled = WebAssembly.compile(bytes);
    module.exports = async (imports) => {
      const instance = await WebAssembly.instantiate(await compiled, imports);
      return instance.exports;
    };
  }
});

// ../../node_modules/.pnpm/blake2b-wasm@2.4.0/node_modules/blake2b-wasm/index.js
var require_blake2b_wasm = __commonJS({
  "../../node_modules/.pnpm/blake2b-wasm@2.4.0/node_modules/blake2b-wasm/index.js"(exports, module) {
    var assert = require_nanoassert();
    var b4a = require_browser();
    var wasm = null;
    var wasmPromise = typeof WebAssembly !== "undefined" && require_blake2b()().then((mod) => {
      wasm = mod;
    });
    var head = 64;
    var freeList = [];
    module.exports = Blake2b;
    var BYTES_MIN = module.exports.BYTES_MIN = 16;
    var BYTES_MAX = module.exports.BYTES_MAX = 64;
    var BYTES = module.exports.BYTES = 32;
    var KEYBYTES_MIN = module.exports.KEYBYTES_MIN = 16;
    var KEYBYTES_MAX = module.exports.KEYBYTES_MAX = 64;
    var KEYBYTES = module.exports.KEYBYTES = 32;
    var SALTBYTES = module.exports.SALTBYTES = 16;
    var PERSONALBYTES = module.exports.PERSONALBYTES = 16;
    function Blake2b(digestLength, key, salt, personal, noAssert) {
      if (!(this instanceof Blake2b)) return new Blake2b(digestLength, key, salt, personal, noAssert);
      if (!wasm) throw new Error("WASM not loaded. Wait for Blake2b.ready(cb)");
      if (!digestLength) digestLength = 32;
      if (noAssert !== true) {
        assert(digestLength >= BYTES_MIN, "digestLength must be at least " + BYTES_MIN + ", was given " + digestLength);
        assert(digestLength <= BYTES_MAX, "digestLength must be at most " + BYTES_MAX + ", was given " + digestLength);
        if (key != null) {
          assert(key instanceof Uint8Array, "key must be Uint8Array or Buffer");
          assert(key.length >= KEYBYTES_MIN, "key must be at least " + KEYBYTES_MIN + ", was given " + key.length);
          assert(key.length <= KEYBYTES_MAX, "key must be at least " + KEYBYTES_MAX + ", was given " + key.length);
        }
        if (salt != null) {
          assert(salt instanceof Uint8Array, "salt must be Uint8Array or Buffer");
          assert(salt.length === SALTBYTES, "salt must be exactly " + SALTBYTES + ", was given " + salt.length);
        }
        if (personal != null) {
          assert(personal instanceof Uint8Array, "personal must be Uint8Array or Buffer");
          assert(personal.length === PERSONALBYTES, "personal must be exactly " + PERSONALBYTES + ", was given " + personal.length);
        }
      }
      if (!freeList.length) {
        freeList.push(head);
        head += 216;
      }
      this.digestLength = digestLength;
      this.finalized = false;
      this.pointer = freeList.pop();
      this._memory = new Uint8Array(wasm.memory.buffer);
      this._memory.fill(0, 0, 64);
      this._memory[0] = this.digestLength;
      this._memory[1] = key ? key.length : 0;
      this._memory[2] = 1;
      this._memory[3] = 1;
      if (salt) this._memory.set(salt, 32);
      if (personal) this._memory.set(personal, 48);
      if (this.pointer + 216 > this._memory.length) this._realloc(this.pointer + 216);
      wasm.blake2b_init(this.pointer, this.digestLength);
      if (key) {
        this.update(key);
        this._memory.fill(0, head, head + key.length);
        this._memory[this.pointer + 200] = 128;
      }
    }
    Blake2b.prototype._realloc = function(size) {
      wasm.memory.grow(Math.max(0, Math.ceil(Math.abs(size - this._memory.length) / 65536)));
      this._memory = new Uint8Array(wasm.memory.buffer);
    };
    Blake2b.prototype.update = function(input) {
      assert(this.finalized === false, "Hash instance finalized");
      assert(input instanceof Uint8Array, "input must be Uint8Array or Buffer");
      if (head + input.length > this._memory.length) this._realloc(head + input.length);
      this._memory.set(input, head);
      wasm.blake2b_update(this.pointer, head, head + input.length);
      return this;
    };
    Blake2b.prototype.digest = function(enc) {
      assert(this.finalized === false, "Hash instance finalized");
      this.finalized = true;
      freeList.push(this.pointer);
      wasm.blake2b_final(this.pointer);
      if (!enc || enc === "binary") {
        return this._memory.slice(this.pointer + 128, this.pointer + 128 + this.digestLength);
      }
      if (typeof enc === "string") {
        return b4a.toString(this._memory, enc, this.pointer + 128, this.pointer + 128 + this.digestLength);
      }
      assert(enc instanceof Uint8Array && enc.length >= this.digestLength, "input must be Uint8Array or Buffer");
      for (var i = 0; i < this.digestLength; i++) {
        enc[i] = this._memory[this.pointer + 128 + i];
      }
      return enc;
    };
    Blake2b.prototype.final = Blake2b.prototype.digest;
    Blake2b.WASM = wasm;
    Blake2b.SUPPORTED = typeof WebAssembly !== "undefined";
    Blake2b.ready = function(cb) {
      if (!cb) cb = noop;
      if (!wasmPromise) return cb(new Error("WebAssembly not supported"));
      return wasmPromise.then(() => cb(), cb);
    };
    Blake2b.prototype.ready = Blake2b.ready;
    Blake2b.prototype.getPartialHash = function() {
      return this._memory.slice(this.pointer, this.pointer + 216);
    };
    Blake2b.prototype.setPartialHash = function(ph) {
      this._memory.set(ph, this.pointer);
    };
    function noop() {
    }
  }
});

// ../../node_modules/.pnpm/blake2b@2.1.4/node_modules/blake2b/index.js
var require_blake2b2 = __commonJS({
  "../../node_modules/.pnpm/blake2b@2.1.4/node_modules/blake2b/index.js"(exports, module) {
    var assert = require_nanoassert();
    var b2wasm = require_blake2b_wasm();
    function ADD64AA(v2, a, b) {
      var o0 = v2[a] + v2[b];
      var o1 = v2[a + 1] + v2[b + 1];
      if (o0 >= 4294967296) {
        o1++;
      }
      v2[a] = o0;
      v2[a + 1] = o1;
    }
    function ADD64AC(v2, a, b0, b1) {
      var o0 = v2[a] + b0;
      if (b0 < 0) {
        o0 += 4294967296;
      }
      var o1 = v2[a + 1] + b1;
      if (o0 >= 4294967296) {
        o1++;
      }
      v2[a] = o0;
      v2[a + 1] = o1;
    }
    function B2B_GET32(arr, i) {
      return arr[i] ^ arr[i + 1] << 8 ^ arr[i + 2] << 16 ^ arr[i + 3] << 24;
    }
    function B2B_G(a, b, c, d, ix, iy) {
      var x0 = m[ix];
      var x1 = m[ix + 1];
      var y0 = m[iy];
      var y1 = m[iy + 1];
      ADD64AA(v, a, b);
      ADD64AC(v, a, x0, x1);
      var xor0 = v[d] ^ v[a];
      var xor1 = v[d + 1] ^ v[a + 1];
      v[d] = xor1;
      v[d + 1] = xor0;
      ADD64AA(v, c, d);
      xor0 = v[b] ^ v[c];
      xor1 = v[b + 1] ^ v[c + 1];
      v[b] = xor0 >>> 24 ^ xor1 << 8;
      v[b + 1] = xor1 >>> 24 ^ xor0 << 8;
      ADD64AA(v, a, b);
      ADD64AC(v, a, y0, y1);
      xor0 = v[d] ^ v[a];
      xor1 = v[d + 1] ^ v[a + 1];
      v[d] = xor0 >>> 16 ^ xor1 << 16;
      v[d + 1] = xor1 >>> 16 ^ xor0 << 16;
      ADD64AA(v, c, d);
      xor0 = v[b] ^ v[c];
      xor1 = v[b + 1] ^ v[c + 1];
      v[b] = xor1 >>> 31 ^ xor0 << 1;
      v[b + 1] = xor0 >>> 31 ^ xor1 << 1;
    }
    var BLAKE2B_IV32 = new Uint32Array([
      4089235720,
      1779033703,
      2227873595,
      3144134277,
      4271175723,
      1013904242,
      1595750129,
      2773480762,
      2917565137,
      1359893119,
      725511199,
      2600822924,
      4215389547,
      528734635,
      327033209,
      1541459225
    ]);
    var SIGMA8 = [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      14,
      10,
      4,
      8,
      9,
      15,
      13,
      6,
      1,
      12,
      0,
      2,
      11,
      7,
      5,
      3,
      11,
      8,
      12,
      0,
      5,
      2,
      15,
      13,
      10,
      14,
      3,
      6,
      7,
      1,
      9,
      4,
      7,
      9,
      3,
      1,
      13,
      12,
      11,
      14,
      2,
      6,
      5,
      10,
      4,
      0,
      15,
      8,
      9,
      0,
      5,
      7,
      2,
      4,
      10,
      15,
      14,
      1,
      11,
      12,
      6,
      8,
      3,
      13,
      2,
      12,
      6,
      10,
      0,
      11,
      8,
      3,
      4,
      13,
      7,
      5,
      15,
      14,
      1,
      9,
      12,
      5,
      1,
      15,
      14,
      13,
      4,
      10,
      0,
      7,
      6,
      3,
      9,
      2,
      8,
      11,
      13,
      11,
      7,
      14,
      12,
      1,
      3,
      9,
      5,
      0,
      15,
      4,
      8,
      6,
      2,
      10,
      6,
      15,
      14,
      9,
      11,
      3,
      0,
      8,
      12,
      2,
      13,
      7,
      1,
      4,
      10,
      5,
      10,
      2,
      8,
      4,
      7,
      6,
      1,
      5,
      15,
      11,
      9,
      14,
      3,
      12,
      13,
      0,
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      14,
      10,
      4,
      8,
      9,
      15,
      13,
      6,
      1,
      12,
      0,
      2,
      11,
      7,
      5,
      3
    ];
    var SIGMA82 = new Uint8Array(SIGMA8.map(function(x) {
      return x * 2;
    }));
    var v = new Uint32Array(32);
    var m = new Uint32Array(32);
    function blake2bCompress(ctx, last) {
      var i = 0;
      for (i = 0; i < 16; i++) {
        v[i] = ctx.h[i];
        v[i + 16] = BLAKE2B_IV32[i];
      }
      v[24] = v[24] ^ ctx.t;
      v[25] = v[25] ^ ctx.t / 4294967296;
      if (last) {
        v[28] = ~v[28];
        v[29] = ~v[29];
      }
      for (i = 0; i < 32; i++) {
        m[i] = B2B_GET32(ctx.b, 4 * i);
      }
      for (i = 0; i < 12; i++) {
        B2B_G(0, 8, 16, 24, SIGMA82[i * 16 + 0], SIGMA82[i * 16 + 1]);
        B2B_G(2, 10, 18, 26, SIGMA82[i * 16 + 2], SIGMA82[i * 16 + 3]);
        B2B_G(4, 12, 20, 28, SIGMA82[i * 16 + 4], SIGMA82[i * 16 + 5]);
        B2B_G(6, 14, 22, 30, SIGMA82[i * 16 + 6], SIGMA82[i * 16 + 7]);
        B2B_G(0, 10, 20, 30, SIGMA82[i * 16 + 8], SIGMA82[i * 16 + 9]);
        B2B_G(2, 12, 22, 24, SIGMA82[i * 16 + 10], SIGMA82[i * 16 + 11]);
        B2B_G(4, 14, 16, 26, SIGMA82[i * 16 + 12], SIGMA82[i * 16 + 13]);
        B2B_G(6, 8, 18, 28, SIGMA82[i * 16 + 14], SIGMA82[i * 16 + 15]);
      }
      for (i = 0; i < 16; i++) {
        ctx.h[i] = ctx.h[i] ^ v[i] ^ v[i + 16];
      }
    }
    var parameter_block = new Uint8Array([
      0,
      0,
      0,
      0,
      //  0: outlen, keylen, fanout, depth
      0,
      0,
      0,
      0,
      //  4: leaf length, sequential mode
      0,
      0,
      0,
      0,
      //  8: node offset
      0,
      0,
      0,
      0,
      // 12: node offset
      0,
      0,
      0,
      0,
      // 16: node depth, inner length, rfu
      0,
      0,
      0,
      0,
      // 20: rfu
      0,
      0,
      0,
      0,
      // 24: rfu
      0,
      0,
      0,
      0,
      // 28: rfu
      0,
      0,
      0,
      0,
      // 32: salt
      0,
      0,
      0,
      0,
      // 36: salt
      0,
      0,
      0,
      0,
      // 40: salt
      0,
      0,
      0,
      0,
      // 44: salt
      0,
      0,
      0,
      0,
      // 48: personal
      0,
      0,
      0,
      0,
      // 52: personal
      0,
      0,
      0,
      0,
      // 56: personal
      0,
      0,
      0,
      0
      // 60: personal
    ]);
    function Blake2b(outlen, key, salt, personal) {
      parameter_block.fill(0);
      this.b = new Uint8Array(128);
      this.h = new Uint32Array(16);
      this.t = 0;
      this.c = 0;
      this.outlen = outlen;
      parameter_block[0] = outlen;
      if (key) parameter_block[1] = key.length;
      parameter_block[2] = 1;
      parameter_block[3] = 1;
      if (salt) parameter_block.set(salt, 32);
      if (personal) parameter_block.set(personal, 48);
      for (var i = 0; i < 16; i++) {
        this.h[i] = BLAKE2B_IV32[i] ^ B2B_GET32(parameter_block, i * 4);
      }
      if (key) {
        blake2bUpdate(this, key);
        this.c = 128;
      }
    }
    Blake2b.prototype.update = function(input) {
      assert(input instanceof Uint8Array, "input must be Uint8Array or Buffer");
      blake2bUpdate(this, input);
      return this;
    };
    Blake2b.prototype.digest = function(out) {
      var buf = !out || out === "binary" || out === "hex" ? new Uint8Array(this.outlen) : out;
      assert(buf instanceof Uint8Array, 'out must be "binary", "hex", Uint8Array, or Buffer');
      assert(buf.length >= this.outlen, "out must have at least outlen bytes of space");
      blake2bFinal(this, buf);
      if (out === "hex") return hexSlice(buf);
      return buf;
    };
    Blake2b.prototype.final = Blake2b.prototype.digest;
    Blake2b.ready = function(cb) {
      b2wasm.ready(function() {
        cb();
      });
    };
    function blake2bUpdate(ctx, input) {
      for (var i = 0; i < input.length; i++) {
        if (ctx.c === 128) {
          ctx.t += ctx.c;
          blake2bCompress(ctx, false);
          ctx.c = 0;
        }
        ctx.b[ctx.c++] = input[i];
      }
    }
    function blake2bFinal(ctx, out) {
      ctx.t += ctx.c;
      while (ctx.c < 128) {
        ctx.b[ctx.c++] = 0;
      }
      blake2bCompress(ctx, true);
      for (var i = 0; i < ctx.outlen; i++) {
        out[i] = ctx.h[i >> 2] >> 8 * (i & 3);
      }
      return out;
    }
    function hexSlice(buf) {
      var str = "";
      for (var i = 0; i < buf.length; i++) str += toHex(buf[i]);
      return str;
    }
    function toHex(n) {
      if (n < 16) return "0" + n.toString(16);
      return n.toString(16);
    }
    var Proto = Blake2b;
    module.exports = function createHash(outlen, key, salt, personal, noAssert) {
      if (noAssert !== true) {
        assert(outlen >= BYTES_MIN, "outlen must be at least " + BYTES_MIN + ", was given " + outlen);
        assert(outlen <= BYTES_MAX, "outlen must be at most " + BYTES_MAX + ", was given " + outlen);
        if (key != null) {
          assert(key instanceof Uint8Array, "key must be Uint8Array or Buffer");
          assert(key.length >= KEYBYTES_MIN, "key must be at least " + KEYBYTES_MIN + ", was given " + key.length);
          assert(key.length <= KEYBYTES_MAX, "key must be at most " + KEYBYTES_MAX + ", was given " + key.length);
        }
        if (salt != null) {
          assert(salt instanceof Uint8Array, "salt must be Uint8Array or Buffer");
          assert(salt.length === SALTBYTES, "salt must be exactly " + SALTBYTES + ", was given " + salt.length);
        }
        if (personal != null) {
          assert(personal instanceof Uint8Array, "personal must be Uint8Array or Buffer");
          assert(personal.length === PERSONALBYTES, "personal must be exactly " + PERSONALBYTES + ", was given " + personal.length);
        }
      }
      return new Proto(outlen, key, salt, personal);
    };
    module.exports.ready = function(cb) {
      b2wasm.ready(function() {
        cb();
      });
    };
    module.exports.WASM_SUPPORTED = b2wasm.SUPPORTED;
    module.exports.WASM_LOADED = false;
    var BYTES_MIN = module.exports.BYTES_MIN = 16;
    var BYTES_MAX = module.exports.BYTES_MAX = 64;
    var BYTES = module.exports.BYTES = 32;
    var KEYBYTES_MIN = module.exports.KEYBYTES_MIN = 16;
    var KEYBYTES_MAX = module.exports.KEYBYTES_MAX = 64;
    var KEYBYTES = module.exports.KEYBYTES = 32;
    var SALTBYTES = module.exports.SALTBYTES = 16;
    var PERSONALBYTES = module.exports.PERSONALBYTES = 16;
    b2wasm.ready(function(err) {
      if (!err) {
        module.exports.WASM_LOADED = true;
        module.exports = b2wasm;
      }
    });
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_generichash.js
var require_crypto_generichash = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_generichash.js"(exports, module) {
    var blake2b = require_blake2b2();
    if (new Uint16Array([1])[0] !== 1) throw new Error("Big endian architecture is not supported.");
    module.exports.crypto_generichash_PRIMITIVE = "blake2b";
    module.exports.crypto_generichash_BYTES_MIN = blake2b.BYTES_MIN;
    module.exports.crypto_generichash_BYTES_MAX = blake2b.BYTES_MAX;
    module.exports.crypto_generichash_BYTES = blake2b.BYTES;
    module.exports.crypto_generichash_KEYBYTES_MIN = blake2b.KEYBYTES_MIN;
    module.exports.crypto_generichash_KEYBYTES_MAX = blake2b.KEYBYTES_MAX;
    module.exports.crypto_generichash_KEYBYTES = blake2b.KEYBYTES;
    module.exports.crypto_generichash_WASM_SUPPORTED = blake2b.WASM_SUPPORTED;
    module.exports.crypto_generichash_WASM_LOADED = false;
    module.exports.crypto_generichash = function(output, input, key) {
      blake2b(output.length, key).update(input).final(output);
    };
    module.exports.crypto_generichash_ready = blake2b.ready;
    module.exports.crypto_generichash_batch = function(output, inputArray, key) {
      var ctx = blake2b(output.length, key);
      for (var i = 0; i < inputArray.length; i++) {
        ctx.update(inputArray[i]);
      }
      ctx.final(output);
    };
    module.exports.crypto_generichash_instance = function(key, outlen) {
      if (outlen == null) outlen = module.exports.crypto_generichash_BYTES;
      return blake2b(outlen, key);
    };
    blake2b.ready(function(_) {
      module.exports.crypto_generichash_WASM_LOADED = blake2b.WASM_LOADED;
    });
  }
});

// ../../node_modules/.pnpm/xsalsa20@1.2.0/node_modules/xsalsa20/xsalsa20.js
var require_xsalsa20 = __commonJS({
  "../../node_modules/.pnpm/xsalsa20@1.2.0/node_modules/xsalsa20/xsalsa20.js"(exports, module) {
    var __commonJS2 = (cb, mod) => function __require2() {
      return mod || (0, cb[Object.keys(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
    };
    var __toBinary = /* @__PURE__ */ (() => {
      var table = new Uint8Array(128);
      for (var i = 0; i < 64; i++)
        table[i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i * 4 - 205] = i;
      return (base64) => {
        var n = base64.length, bytes2 = new Uint8Array((n - (base64[n - 1] == "=") - (base64[n - 2] == "=")) * 3 / 4 | 0);
        for (var i2 = 0, j = 0; i2 < n; ) {
          var c0 = table[base64.charCodeAt(i2++)], c1 = table[base64.charCodeAt(i2++)];
          var c2 = table[base64.charCodeAt(i2++)], c3 = table[base64.charCodeAt(i2++)];
          bytes2[j++] = c0 << 2 | c1 >> 4;
          bytes2[j++] = c1 << 4 | c2 >> 2;
          bytes2[j++] = c2 << 6 | c3;
        }
        return bytes2;
      };
    })();
    var require_xsalsa203 = __commonJS2({
      "wasm-binary:./xsalsa20.wat"(exports2, module2) {
        module2.exports = __toBinary("AGFzbQEAAAABGgNgBn9/f39/fwBgBn9/f39+fwF+YAN/f38AAwcGAAEBAgICBQUBAQroBwcoAwZtZW1vcnkCAAx4c2Fsc2EyMF94b3IAAAxjb3JlX3NhbHNhMjAABArqEQYYACAAIAEgAiADIAQgACkDACAFEAE3AwALPQBB8AAgAyAFEAMgACABIAIgA0EQaiAEQfAAEAJB8ABCADcDAEH4AEIANwMAQYABQgA3AwBBiAFCADcDAAuHBQEBfyACQQBGBEBCAA8LQdAAIAUpAwA3AwBB2AAgBUEIaikDADcDAEHgACAFQRBqKQMANwMAQegAIAVBGGopAwA3AwBBACADKQMANwMAQQggBDcDAAJAA0AgAkHAAEkNAUEQQQBB0AAQBSAAIAEpAwBBECkDAIU3AwAgAEEIaiABQQhqKQMAQRgpAwCFNwMAIABBEGogAUEQaikDAEEgKQMAhTcDACAAQRhqIAFBGGopAwBBKCkDAIU3AwAgAEEgaiABQSBqKQMAQTApAwCFNwMAIABBKGogAUEoaikDAEE4KQMAhTcDACAAQTBqIAFBMGopAwBBwAApAwCFNwMAIABBOGogAUE4aikDAEHIACkDAIU3AwBBCEEIKQMAQgF8NwMAIABBwABqIQAgAUHAAGohASACQcAAayECDAALC0EIKQMAIQQgAkEASwRAQRBBAEHQABAFAkACQAJAAkACQAJAAkACQCACQQhuDgcHBgUEAwIBAAsgAEE4aiABQThqKQMAQcgAKQMAhTcDAAsgAEEwaiABQTBqKQMAQcAAKQMAhTcDAAsgAEEoaiABQShqKQMAQTgpAwCFNwMACyAAQSBqIAFBIGopAwBBMCkDAIU3AwALIABBGGogAUEYaikDAEEoKQMAhTcDAAsgAEEQaiABQRBqKQMAQSApAwCFNwMACyAAQQhqIAFBCGopAwBBGCkDAIU3AwALIAAgASkDAEEQKQMAhTcDAAtBEEIANwMAQRhCADcDAEEgQgA3AwBBKEIANwMAQTBCADcDAEE4QgA3AwBBwABCADcDAEHIAEIANwMAQdAAQgA3AwBB2ABCADcDAEHgAEIANwMAQegAQgA3AwAgBA8LnQUBEX9B5fDBiwYhA0HuyIGZAyEIQbLaiMsHIQ1B9MqB2QYhEiACKAIAIQQgAkEEaigCACEFIAJBCGooAgAhBiACQQxqKAIAIQcgAkEQaigCACEOIAJBFGooAgAhDyACQRhqKAIAIRAgAkEcaigCACERIAEoAgAhCSABQQRqKAIAIQogAUEIaigCACELIAFBDGooAgAhDEEUIRMCQANAIBNBAEYNASAHIAMgD2pBB3dzIQcgCyAHIANqQQl3cyELIA8gCyAHakENd3MhDyADIA8gC2pBEndzIQMgDCAIIARqQQd3cyEMIBAgDCAIakEJd3MhECAEIBAgDGpBDXdzIQQgCCAEIBBqQRJ3cyEIIBEgDSAJakEHd3MhESAFIBEgDWpBCXdzIQUgCSAFIBFqQQ13cyEJIA0gCSAFakESd3MhDSAGIBIgDmpBB3dzIQYgCiAGIBJqQQl3cyEKIA4gCiAGakENd3MhDiASIA4gCmpBEndzIRIgBCADIAZqQQd3cyEEIAUgBCADakEJd3MhBSAGIAUgBGpBDXdzIQYgAyAGIAVqQRJ3cyEDIAkgCCAHakEHd3MhCSAKIAkgCGpBCXdzIQogByAKIAlqQQ13cyEHIAggByAKakESd3MhCCAOIA0gDGpBB3dzIQ4gCyAOIA1qQQl3cyELIAwgCyAOakENd3MhDCANIAwgC2pBEndzIQ0gDyASIBFqQQd3cyEPIBAgDyASakEJd3MhECARIBAgD2pBDXdzIREgEiARIBBqQRJ3cyESIBNBAmshEwwACwsgACADNgIAIABBBGogCDYCACAAQQhqIA02AgAgAEEMaiASNgIAIABBEGogCTYCACAAQRRqIAo2AgAgAEEYaiALNgIAIABBHGogDDYCAAsKACAAIAEgAhAFC90GASF/QeXwwYsGIQNB7siBmQMhCEGy2ojLByENQfTKgdkGIRIgAigCACEEIAJBBGooAgAhBSACQQhqKAIAIQYgAkEMaigCACEHIAJBEGooAgAhDiACQRRqKAIAIQ8gAkEYaigCACEQIAJBHGooAgAhESABKAIAIQkgAUEEaigCACEKIAFBCGooAgAhCyABQQxqKAIAIQwgAyETIAQhFCAFIRUgBiEWIAchFyAIIRggCSEZIAohGiALIRsgDCEcIA0hHSAOIR4gDyEfIBAhICARISEgEiEiQRQhIwJAA0AgI0EARg0BIAcgAyAPakEHd3MhByALIAcgA2pBCXdzIQsgDyALIAdqQQ13cyEPIAMgDyALakESd3MhAyAMIAggBGpBB3dzIQwgECAMIAhqQQl3cyEQIAQgECAMakENd3MhBCAIIAQgEGpBEndzIQggESANIAlqQQd3cyERIAUgESANakEJd3MhBSAJIAUgEWpBDXdzIQkgDSAJIAVqQRJ3cyENIAYgEiAOakEHd3MhBiAKIAYgEmpBCXdzIQogDiAKIAZqQQ13cyEOIBIgDiAKakESd3MhEiAEIAMgBmpBB3dzIQQgBSAEIANqQQl3cyEFIAYgBSAEakENd3MhBiADIAYgBWpBEndzIQMgCSAIIAdqQQd3cyEJIAogCSAIakEJd3MhCiAHIAogCWpBDXdzIQcgCCAHIApqQRJ3cyEIIA4gDSAMakEHd3MhDiALIA4gDWpBCXdzIQsgDCALIA5qQQ13cyEMIA0gDCALakESd3MhDSAPIBIgEWpBB3dzIQ8gECAPIBJqQQl3cyEQIBEgECAPakENd3MhESASIBEgEGpBEndzIRIgI0ECayEjDAALCyAAIAMgE2o2AgAgAEEEaiAEIBRqNgIAIABBCGogBSAVajYCACAAQQxqIAYgFmo2AgAgAEEQaiAHIBdqNgIAIABBFGogCCAYajYCACAAQRhqIAkgGWo2AgAgAEEcaiAKIBpqNgIAIABBIGogCyAbajYCACAAQSRqIAwgHGo2AgAgAEEoaiANIB1qNgIAIABBLGogDiAeajYCACAAQTBqIA8gH2o2AgAgAEE0aiAQICBqNgIAIABBOGogESAhajYCACAAQTxqIBIgImo2AgAL");
      }
    });
    var bytes = require_xsalsa203();
    var compiled = new WebAssembly.Module(bytes);
    module.exports = (imports) => {
      const instance = new WebAssembly.Instance(compiled, imports);
      return instance.exports;
    };
  }
});

// ../../node_modules/.pnpm/xsalsa20@1.2.0/node_modules/xsalsa20/index.js
var require_xsalsa202 = __commonJS({
  "../../node_modules/.pnpm/xsalsa20@1.2.0/node_modules/xsalsa20/index.js"(exports, module) {
    var xsalsa20 = typeof WebAssembly !== "undefined" && require_xsalsa20()();
    var SIGMA = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
    var head = 144;
    var top = head;
    var free = [];
    module.exports = XSalsa20;
    XSalsa20.NONCEBYTES = 24;
    XSalsa20.KEYBYTES = 32;
    XSalsa20.core_hsalsa20 = core_hsalsa20;
    XSalsa20.SIGMA = SIGMA;
    function XSalsa20(nonce, key) {
      if (!(this instanceof XSalsa20)) return new XSalsa20(nonce, key);
      if (!nonce || nonce.length < 24) throw new Error("nonce must be at least 24 bytes");
      if (!key || key.length < 32) throw new Error("key must be at least 32 bytes");
      this._xor = xsalsa20 ? new WASM(nonce, key) : new Fallback(nonce, key);
    }
    XSalsa20.prototype.update = function(input, output) {
      if (!input) throw new Error("input must be Uint8Array or Buffer");
      if (!output) output = new Uint8Array(input.length);
      if (input.length) this._xor.update(input, output);
      return output;
    };
    XSalsa20.prototype.final = XSalsa20.prototype.finalize = function() {
      this._xor.finalize();
      this._xor = null;
    };
    function WASM(nonce, key) {
      if (!free.length) {
        free.push(head);
        head += 64;
      }
      this._pointer = free.pop();
      this._nonce = this._pointer + 8;
      this._key = this._nonce + 24;
      this._overflow = 0;
      this._memory = new Uint8Array(xsalsa20.memory.buffer);
      this._memory.fill(0, this._pointer, this._pointer + 8);
      this._memory.set(nonce, this._nonce);
      this._memory.set(key, this._key);
    }
    WASM.prototype.realloc = function(size) {
      xsalsa20.memory.grow(Math.ceil(Math.abs(size - this._memory.length) / 65536));
      this._memory = new Uint8Array(xsalsa20.memory.buffer);
    };
    WASM.prototype.update = function(input, output) {
      var len = this._overflow + input.length;
      var start = head + this._overflow;
      top = head + len;
      if (top >= this._memory.length) this.realloc(top);
      this._memory.set(input, start);
      xsalsa20.xsalsa20_xor(this._pointer, head, head, len, this._nonce, this._key);
      output.set(this._memory.subarray(start, head + len));
      this._overflow = len & 63;
    };
    WASM.prototype.finalize = function() {
      this._memory.fill(0, this._pointer, this._key + 32);
      if (top > head) {
        this._memory.fill(0, head, top);
        top = 0;
      }
      free.push(this._pointer);
    };
    function Fallback(nonce, key) {
      this._s = new Uint8Array(32);
      this._z = new Uint8Array(16);
      this._overflow = 0;
      core_hsalsa20(this._s, nonce, key, SIGMA);
      for (var i = 0; i < 8; i++) this._z[i] = nonce[i + 16];
    }
    Fallback.prototype.update = function(input, output) {
      var x = new Uint8Array(64);
      var u = 0;
      var i = this._overflow;
      var b = input.length + this._overflow;
      var z = this._z;
      var mpos = -this._overflow;
      var cpos = -this._overflow;
      while (b >= 64) {
        core_salsa20(x, z, this._s, SIGMA);
        for (; i < 64; i++) output[cpos + i] = input[mpos + i] ^ x[i];
        u = 1;
        for (i = 8; i < 16; i++) {
          u += z[i] & 255 | 0;
          z[i] = u & 255;
          u >>>= 8;
        }
        b -= 64;
        cpos += 64;
        mpos += 64;
        i = 0;
      }
      if (b > 0) {
        core_salsa20(x, z, this._s, SIGMA);
        for (; i < b; i++) output[cpos + i] = input[mpos + i] ^ x[i];
      }
      this._overflow = b & 63;
    };
    Fallback.prototype.finalize = function() {
      this._s.fill(0);
      this._z.fill(0);
    };
    function core_salsa20(o, p, k, c) {
      var j0 = c[0] & 255 | (c[1] & 255) << 8 | (c[2] & 255) << 16 | (c[3] & 255) << 24, j1 = k[0] & 255 | (k[1] & 255) << 8 | (k[2] & 255) << 16 | (k[3] & 255) << 24, j2 = k[4] & 255 | (k[5] & 255) << 8 | (k[6] & 255) << 16 | (k[7] & 255) << 24, j3 = k[8] & 255 | (k[9] & 255) << 8 | (k[10] & 255) << 16 | (k[11] & 255) << 24, j4 = k[12] & 255 | (k[13] & 255) << 8 | (k[14] & 255) << 16 | (k[15] & 255) << 24, j5 = c[4] & 255 | (c[5] & 255) << 8 | (c[6] & 255) << 16 | (c[7] & 255) << 24, j6 = p[0] & 255 | (p[1] & 255) << 8 | (p[2] & 255) << 16 | (p[3] & 255) << 24, j7 = p[4] & 255 | (p[5] & 255) << 8 | (p[6] & 255) << 16 | (p[7] & 255) << 24, j8 = p[8] & 255 | (p[9] & 255) << 8 | (p[10] & 255) << 16 | (p[11] & 255) << 24, j9 = p[12] & 255 | (p[13] & 255) << 8 | (p[14] & 255) << 16 | (p[15] & 255) << 24, j10 = c[8] & 255 | (c[9] & 255) << 8 | (c[10] & 255) << 16 | (c[11] & 255) << 24, j11 = k[16] & 255 | (k[17] & 255) << 8 | (k[18] & 255) << 16 | (k[19] & 255) << 24, j12 = k[20] & 255 | (k[21] & 255) << 8 | (k[22] & 255) << 16 | (k[23] & 255) << 24, j13 = k[24] & 255 | (k[25] & 255) << 8 | (k[26] & 255) << 16 | (k[27] & 255) << 24, j14 = k[28] & 255 | (k[29] & 255) << 8 | (k[30] & 255) << 16 | (k[31] & 255) << 24, j15 = c[12] & 255 | (c[13] & 255) << 8 | (c[14] & 255) << 16 | (c[15] & 255) << 24;
      var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
      for (var i = 0; i < 20; i += 2) {
        u = x0 + x12 | 0;
        x4 ^= u << 7 | u >>> 25;
        u = x4 + x0 | 0;
        x8 ^= u << 9 | u >>> 23;
        u = x8 + x4 | 0;
        x12 ^= u << 13 | u >>> 19;
        u = x12 + x8 | 0;
        x0 ^= u << 18 | u >>> 14;
        u = x5 + x1 | 0;
        x9 ^= u << 7 | u >>> 25;
        u = x9 + x5 | 0;
        x13 ^= u << 9 | u >>> 23;
        u = x13 + x9 | 0;
        x1 ^= u << 13 | u >>> 19;
        u = x1 + x13 | 0;
        x5 ^= u << 18 | u >>> 14;
        u = x10 + x6 | 0;
        x14 ^= u << 7 | u >>> 25;
        u = x14 + x10 | 0;
        x2 ^= u << 9 | u >>> 23;
        u = x2 + x14 | 0;
        x6 ^= u << 13 | u >>> 19;
        u = x6 + x2 | 0;
        x10 ^= u << 18 | u >>> 14;
        u = x15 + x11 | 0;
        x3 ^= u << 7 | u >>> 25;
        u = x3 + x15 | 0;
        x7 ^= u << 9 | u >>> 23;
        u = x7 + x3 | 0;
        x11 ^= u << 13 | u >>> 19;
        u = x11 + x7 | 0;
        x15 ^= u << 18 | u >>> 14;
        u = x0 + x3 | 0;
        x1 ^= u << 7 | u >>> 25;
        u = x1 + x0 | 0;
        x2 ^= u << 9 | u >>> 23;
        u = x2 + x1 | 0;
        x3 ^= u << 13 | u >>> 19;
        u = x3 + x2 | 0;
        x0 ^= u << 18 | u >>> 14;
        u = x5 + x4 | 0;
        x6 ^= u << 7 | u >>> 25;
        u = x6 + x5 | 0;
        x7 ^= u << 9 | u >>> 23;
        u = x7 + x6 | 0;
        x4 ^= u << 13 | u >>> 19;
        u = x4 + x7 | 0;
        x5 ^= u << 18 | u >>> 14;
        u = x10 + x9 | 0;
        x11 ^= u << 7 | u >>> 25;
        u = x11 + x10 | 0;
        x8 ^= u << 9 | u >>> 23;
        u = x8 + x11 | 0;
        x9 ^= u << 13 | u >>> 19;
        u = x9 + x8 | 0;
        x10 ^= u << 18 | u >>> 14;
        u = x15 + x14 | 0;
        x12 ^= u << 7 | u >>> 25;
        u = x12 + x15 | 0;
        x13 ^= u << 9 | u >>> 23;
        u = x13 + x12 | 0;
        x14 ^= u << 13 | u >>> 19;
        u = x14 + x13 | 0;
        x15 ^= u << 18 | u >>> 14;
      }
      x0 = x0 + j0 | 0;
      x1 = x1 + j1 | 0;
      x2 = x2 + j2 | 0;
      x3 = x3 + j3 | 0;
      x4 = x4 + j4 | 0;
      x5 = x5 + j5 | 0;
      x6 = x6 + j6 | 0;
      x7 = x7 + j7 | 0;
      x8 = x8 + j8 | 0;
      x9 = x9 + j9 | 0;
      x10 = x10 + j10 | 0;
      x11 = x11 + j11 | 0;
      x12 = x12 + j12 | 0;
      x13 = x13 + j13 | 0;
      x14 = x14 + j14 | 0;
      x15 = x15 + j15 | 0;
      o[0] = x0 >>> 0 & 255;
      o[1] = x0 >>> 8 & 255;
      o[2] = x0 >>> 16 & 255;
      o[3] = x0 >>> 24 & 255;
      o[4] = x1 >>> 0 & 255;
      o[5] = x1 >>> 8 & 255;
      o[6] = x1 >>> 16 & 255;
      o[7] = x1 >>> 24 & 255;
      o[8] = x2 >>> 0 & 255;
      o[9] = x2 >>> 8 & 255;
      o[10] = x2 >>> 16 & 255;
      o[11] = x2 >>> 24 & 255;
      o[12] = x3 >>> 0 & 255;
      o[13] = x3 >>> 8 & 255;
      o[14] = x3 >>> 16 & 255;
      o[15] = x3 >>> 24 & 255;
      o[16] = x4 >>> 0 & 255;
      o[17] = x4 >>> 8 & 255;
      o[18] = x4 >>> 16 & 255;
      o[19] = x4 >>> 24 & 255;
      o[20] = x5 >>> 0 & 255;
      o[21] = x5 >>> 8 & 255;
      o[22] = x5 >>> 16 & 255;
      o[23] = x5 >>> 24 & 255;
      o[24] = x6 >>> 0 & 255;
      o[25] = x6 >>> 8 & 255;
      o[26] = x6 >>> 16 & 255;
      o[27] = x6 >>> 24 & 255;
      o[28] = x7 >>> 0 & 255;
      o[29] = x7 >>> 8 & 255;
      o[30] = x7 >>> 16 & 255;
      o[31] = x7 >>> 24 & 255;
      o[32] = x8 >>> 0 & 255;
      o[33] = x8 >>> 8 & 255;
      o[34] = x8 >>> 16 & 255;
      o[35] = x8 >>> 24 & 255;
      o[36] = x9 >>> 0 & 255;
      o[37] = x9 >>> 8 & 255;
      o[38] = x9 >>> 16 & 255;
      o[39] = x9 >>> 24 & 255;
      o[40] = x10 >>> 0 & 255;
      o[41] = x10 >>> 8 & 255;
      o[42] = x10 >>> 16 & 255;
      o[43] = x10 >>> 24 & 255;
      o[44] = x11 >>> 0 & 255;
      o[45] = x11 >>> 8 & 255;
      o[46] = x11 >>> 16 & 255;
      o[47] = x11 >>> 24 & 255;
      o[48] = x12 >>> 0 & 255;
      o[49] = x12 >>> 8 & 255;
      o[50] = x12 >>> 16 & 255;
      o[51] = x12 >>> 24 & 255;
      o[52] = x13 >>> 0 & 255;
      o[53] = x13 >>> 8 & 255;
      o[54] = x13 >>> 16 & 255;
      o[55] = x13 >>> 24 & 255;
      o[56] = x14 >>> 0 & 255;
      o[57] = x14 >>> 8 & 255;
      o[58] = x14 >>> 16 & 255;
      o[59] = x14 >>> 24 & 255;
      o[60] = x15 >>> 0 & 255;
      o[61] = x15 >>> 8 & 255;
      o[62] = x15 >>> 16 & 255;
      o[63] = x15 >>> 24 & 255;
    }
    function core_hsalsa20(o, p, k, c) {
      var j0 = c[0] & 255 | (c[1] & 255) << 8 | (c[2] & 255) << 16 | (c[3] & 255) << 24, j1 = k[0] & 255 | (k[1] & 255) << 8 | (k[2] & 255) << 16 | (k[3] & 255) << 24, j2 = k[4] & 255 | (k[5] & 255) << 8 | (k[6] & 255) << 16 | (k[7] & 255) << 24, j3 = k[8] & 255 | (k[9] & 255) << 8 | (k[10] & 255) << 16 | (k[11] & 255) << 24, j4 = k[12] & 255 | (k[13] & 255) << 8 | (k[14] & 255) << 16 | (k[15] & 255) << 24, j5 = c[4] & 255 | (c[5] & 255) << 8 | (c[6] & 255) << 16 | (c[7] & 255) << 24, j6 = p[0] & 255 | (p[1] & 255) << 8 | (p[2] & 255) << 16 | (p[3] & 255) << 24, j7 = p[4] & 255 | (p[5] & 255) << 8 | (p[6] & 255) << 16 | (p[7] & 255) << 24, j8 = p[8] & 255 | (p[9] & 255) << 8 | (p[10] & 255) << 16 | (p[11] & 255) << 24, j9 = p[12] & 255 | (p[13] & 255) << 8 | (p[14] & 255) << 16 | (p[15] & 255) << 24, j10 = c[8] & 255 | (c[9] & 255) << 8 | (c[10] & 255) << 16 | (c[11] & 255) << 24, j11 = k[16] & 255 | (k[17] & 255) << 8 | (k[18] & 255) << 16 | (k[19] & 255) << 24, j12 = k[20] & 255 | (k[21] & 255) << 8 | (k[22] & 255) << 16 | (k[23] & 255) << 24, j13 = k[24] & 255 | (k[25] & 255) << 8 | (k[26] & 255) << 16 | (k[27] & 255) << 24, j14 = k[28] & 255 | (k[29] & 255) << 8 | (k[30] & 255) << 16 | (k[31] & 255) << 24, j15 = c[12] & 255 | (c[13] & 255) << 8 | (c[14] & 255) << 16 | (c[15] & 255) << 24;
      var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
      for (var i = 0; i < 20; i += 2) {
        u = x0 + x12 | 0;
        x4 ^= u << 7 | u >>> 25;
        u = x4 + x0 | 0;
        x8 ^= u << 9 | u >>> 23;
        u = x8 + x4 | 0;
        x12 ^= u << 13 | u >>> 19;
        u = x12 + x8 | 0;
        x0 ^= u << 18 | u >>> 14;
        u = x5 + x1 | 0;
        x9 ^= u << 7 | u >>> 25;
        u = x9 + x5 | 0;
        x13 ^= u << 9 | u >>> 23;
        u = x13 + x9 | 0;
        x1 ^= u << 13 | u >>> 19;
        u = x1 + x13 | 0;
        x5 ^= u << 18 | u >>> 14;
        u = x10 + x6 | 0;
        x14 ^= u << 7 | u >>> 25;
        u = x14 + x10 | 0;
        x2 ^= u << 9 | u >>> 23;
        u = x2 + x14 | 0;
        x6 ^= u << 13 | u >>> 19;
        u = x6 + x2 | 0;
        x10 ^= u << 18 | u >>> 14;
        u = x15 + x11 | 0;
        x3 ^= u << 7 | u >>> 25;
        u = x3 + x15 | 0;
        x7 ^= u << 9 | u >>> 23;
        u = x7 + x3 | 0;
        x11 ^= u << 13 | u >>> 19;
        u = x11 + x7 | 0;
        x15 ^= u << 18 | u >>> 14;
        u = x0 + x3 | 0;
        x1 ^= u << 7 | u >>> 25;
        u = x1 + x0 | 0;
        x2 ^= u << 9 | u >>> 23;
        u = x2 + x1 | 0;
        x3 ^= u << 13 | u >>> 19;
        u = x3 + x2 | 0;
        x0 ^= u << 18 | u >>> 14;
        u = x5 + x4 | 0;
        x6 ^= u << 7 | u >>> 25;
        u = x6 + x5 | 0;
        x7 ^= u << 9 | u >>> 23;
        u = x7 + x6 | 0;
        x4 ^= u << 13 | u >>> 19;
        u = x4 + x7 | 0;
        x5 ^= u << 18 | u >>> 14;
        u = x10 + x9 | 0;
        x11 ^= u << 7 | u >>> 25;
        u = x11 + x10 | 0;
        x8 ^= u << 9 | u >>> 23;
        u = x8 + x11 | 0;
        x9 ^= u << 13 | u >>> 19;
        u = x9 + x8 | 0;
        x10 ^= u << 18 | u >>> 14;
        u = x15 + x14 | 0;
        x12 ^= u << 7 | u >>> 25;
        u = x12 + x15 | 0;
        x13 ^= u << 9 | u >>> 23;
        u = x13 + x12 | 0;
        x14 ^= u << 13 | u >>> 19;
        u = x14 + x13 | 0;
        x15 ^= u << 18 | u >>> 14;
      }
      o[0] = x0 >>> 0 & 255;
      o[1] = x0 >>> 8 & 255;
      o[2] = x0 >>> 16 & 255;
      o[3] = x0 >>> 24 & 255;
      o[4] = x5 >>> 0 & 255;
      o[5] = x5 >>> 8 & 255;
      o[6] = x5 >>> 16 & 255;
      o[7] = x5 >>> 24 & 255;
      o[8] = x10 >>> 0 & 255;
      o[9] = x10 >>> 8 & 255;
      o[10] = x10 >>> 16 & 255;
      o[11] = x10 >>> 24 & 255;
      o[12] = x15 >>> 0 & 255;
      o[13] = x15 >>> 8 & 255;
      o[14] = x15 >>> 16 & 255;
      o[15] = x15 >>> 24 & 255;
      o[16] = x6 >>> 0 & 255;
      o[17] = x6 >>> 8 & 255;
      o[18] = x6 >>> 16 & 255;
      o[19] = x6 >>> 24 & 255;
      o[20] = x7 >>> 0 & 255;
      o[21] = x7 >>> 8 & 255;
      o[22] = x7 >>> 16 & 255;
      o[23] = x7 >>> 24 & 255;
      o[24] = x8 >>> 0 & 255;
      o[25] = x8 >>> 8 & 255;
      o[26] = x8 >>> 16 & 255;
      o[27] = x8 >>> 24 & 255;
      o[28] = x9 >>> 0 & 255;
      o[29] = x9 >>> 8 & 255;
      o[30] = x9 >>> 16 & 255;
      o[31] = x9 >>> 24 & 255;
    }
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_stream.js
var require_crypto_stream = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_stream.js"(exports) {
    var xsalsa20 = require_xsalsa202();
    if (new Uint16Array([1])[0] !== 1) throw new Error("Big endian architecture is not supported.");
    exports.crypto_stream_KEYBYTES = 32;
    exports.crypto_stream_NONCEBYTES = 24;
    exports.crypto_stream_PRIMITIVE = "xsalsa20";
    exports.crypto_stream_xsalsa20_MESSAGEBYTES_MAX = Number.MAX_SAFE_INTEGER;
    exports.crypto_stream = function(c, nonce, key) {
      c.fill(0);
      exports.crypto_stream_xor(c, c, nonce, key);
    };
    exports.crypto_stream_xor = function(c, m, nonce, key) {
      const xor = xsalsa20(nonce, key);
      xor.update(m, c);
      xor.final();
    };
    exports.crypto_stream_xor_instance = function(nonce, key) {
      return new XOR(nonce, key);
    };
    function XOR(nonce, key) {
      this._instance = xsalsa20(nonce, key);
    }
    XOR.prototype.update = function(out, inp) {
      this._instance.update(inp, out);
    };
    XOR.prototype.final = function() {
      this._instance.finalize();
      this._instance = null;
    };
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/internal/poly1305.js
var require_poly1305 = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/internal/poly1305.js"(exports, module) {
    if (new Uint16Array([1])[0] !== 1) throw new Error("Big endian architecture is not supported.");
    var poly1305 = function(key) {
      this.buffer = new Uint8Array(16);
      this.r = new Uint16Array(10);
      this.h = new Uint16Array(10);
      this.pad = new Uint16Array(8);
      this.leftover = 0;
      this.fin = 0;
      var t0, t1, t2, t3, t4, t5, t6, t7;
      t0 = key[0] & 255 | (key[1] & 255) << 8;
      this.r[0] = t0 & 8191;
      t1 = key[2] & 255 | (key[3] & 255) << 8;
      this.r[1] = (t0 >>> 13 | t1 << 3) & 8191;
      t2 = key[4] & 255 | (key[5] & 255) << 8;
      this.r[2] = (t1 >>> 10 | t2 << 6) & 7939;
      t3 = key[6] & 255 | (key[7] & 255) << 8;
      this.r[3] = (t2 >>> 7 | t3 << 9) & 8191;
      t4 = key[8] & 255 | (key[9] & 255) << 8;
      this.r[4] = (t3 >>> 4 | t4 << 12) & 255;
      this.r[5] = t4 >>> 1 & 8190;
      t5 = key[10] & 255 | (key[11] & 255) << 8;
      this.r[6] = (t4 >>> 14 | t5 << 2) & 8191;
      t6 = key[12] & 255 | (key[13] & 255) << 8;
      this.r[7] = (t5 >>> 11 | t6 << 5) & 8065;
      t7 = key[14] & 255 | (key[15] & 255) << 8;
      this.r[8] = (t6 >>> 8 | t7 << 8) & 8191;
      this.r[9] = t7 >>> 5 & 127;
      this.pad[0] = key[16] & 255 | (key[17] & 255) << 8;
      this.pad[1] = key[18] & 255 | (key[19] & 255) << 8;
      this.pad[2] = key[20] & 255 | (key[21] & 255) << 8;
      this.pad[3] = key[22] & 255 | (key[23] & 255) << 8;
      this.pad[4] = key[24] & 255 | (key[25] & 255) << 8;
      this.pad[5] = key[26] & 255 | (key[27] & 255) << 8;
      this.pad[6] = key[28] & 255 | (key[29] & 255) << 8;
      this.pad[7] = key[30] & 255 | (key[31] & 255) << 8;
    };
    poly1305.prototype.blocks = function(m, mpos, bytes) {
      var hibit = this.fin ? 0 : 1 << 11;
      var t0, t1, t2, t3, t4, t5, t6, t7, c;
      var d0, d1, d2, d3, d4, d5, d6, d7, d8, d9;
      var h0 = this.h[0], h1 = this.h[1], h2 = this.h[2], h3 = this.h[3], h4 = this.h[4], h5 = this.h[5], h6 = this.h[6], h7 = this.h[7], h8 = this.h[8], h9 = this.h[9];
      var r0 = this.r[0], r1 = this.r[1], r2 = this.r[2], r3 = this.r[3], r4 = this.r[4], r5 = this.r[5], r6 = this.r[6], r7 = this.r[7], r8 = this.r[8], r9 = this.r[9];
      while (bytes >= 16) {
        t0 = m[mpos + 0] & 255 | (m[mpos + 1] & 255) << 8;
        h0 += t0 & 8191;
        t1 = m[mpos + 2] & 255 | (m[mpos + 3] & 255) << 8;
        h1 += (t0 >>> 13 | t1 << 3) & 8191;
        t2 = m[mpos + 4] & 255 | (m[mpos + 5] & 255) << 8;
        h2 += (t1 >>> 10 | t2 << 6) & 8191;
        t3 = m[mpos + 6] & 255 | (m[mpos + 7] & 255) << 8;
        h3 += (t2 >>> 7 | t3 << 9) & 8191;
        t4 = m[mpos + 8] & 255 | (m[mpos + 9] & 255) << 8;
        h4 += (t3 >>> 4 | t4 << 12) & 8191;
        h5 += t4 >>> 1 & 8191;
        t5 = m[mpos + 10] & 255 | (m[mpos + 11] & 255) << 8;
        h6 += (t4 >>> 14 | t5 << 2) & 8191;
        t6 = m[mpos + 12] & 255 | (m[mpos + 13] & 255) << 8;
        h7 += (t5 >>> 11 | t6 << 5) & 8191;
        t7 = m[mpos + 14] & 255 | (m[mpos + 15] & 255) << 8;
        h8 += (t6 >>> 8 | t7 << 8) & 8191;
        h9 += t7 >>> 5 | hibit;
        c = 0;
        d0 = c;
        d0 += h0 * r0;
        d0 += h1 * (5 * r9);
        d0 += h2 * (5 * r8);
        d0 += h3 * (5 * r7);
        d0 += h4 * (5 * r6);
        c = d0 >>> 13;
        d0 &= 8191;
        d0 += h5 * (5 * r5);
        d0 += h6 * (5 * r4);
        d0 += h7 * (5 * r3);
        d0 += h8 * (5 * r2);
        d0 += h9 * (5 * r1);
        c += d0 >>> 13;
        d0 &= 8191;
        d1 = c;
        d1 += h0 * r1;
        d1 += h1 * r0;
        d1 += h2 * (5 * r9);
        d1 += h3 * (5 * r8);
        d1 += h4 * (5 * r7);
        c = d1 >>> 13;
        d1 &= 8191;
        d1 += h5 * (5 * r6);
        d1 += h6 * (5 * r5);
        d1 += h7 * (5 * r4);
        d1 += h8 * (5 * r3);
        d1 += h9 * (5 * r2);
        c += d1 >>> 13;
        d1 &= 8191;
        d2 = c;
        d2 += h0 * r2;
        d2 += h1 * r1;
        d2 += h2 * r0;
        d2 += h3 * (5 * r9);
        d2 += h4 * (5 * r8);
        c = d2 >>> 13;
        d2 &= 8191;
        d2 += h5 * (5 * r7);
        d2 += h6 * (5 * r6);
        d2 += h7 * (5 * r5);
        d2 += h8 * (5 * r4);
        d2 += h9 * (5 * r3);
        c += d2 >>> 13;
        d2 &= 8191;
        d3 = c;
        d3 += h0 * r3;
        d3 += h1 * r2;
        d3 += h2 * r1;
        d3 += h3 * r0;
        d3 += h4 * (5 * r9);
        c = d3 >>> 13;
        d3 &= 8191;
        d3 += h5 * (5 * r8);
        d3 += h6 * (5 * r7);
        d3 += h7 * (5 * r6);
        d3 += h8 * (5 * r5);
        d3 += h9 * (5 * r4);
        c += d3 >>> 13;
        d3 &= 8191;
        d4 = c;
        d4 += h0 * r4;
        d4 += h1 * r3;
        d4 += h2 * r2;
        d4 += h3 * r1;
        d4 += h4 * r0;
        c = d4 >>> 13;
        d4 &= 8191;
        d4 += h5 * (5 * r9);
        d4 += h6 * (5 * r8);
        d4 += h7 * (5 * r7);
        d4 += h8 * (5 * r6);
        d4 += h9 * (5 * r5);
        c += d4 >>> 13;
        d4 &= 8191;
        d5 = c;
        d5 += h0 * r5;
        d5 += h1 * r4;
        d5 += h2 * r3;
        d5 += h3 * r2;
        d5 += h4 * r1;
        c = d5 >>> 13;
        d5 &= 8191;
        d5 += h5 * r0;
        d5 += h6 * (5 * r9);
        d5 += h7 * (5 * r8);
        d5 += h8 * (5 * r7);
        d5 += h9 * (5 * r6);
        c += d5 >>> 13;
        d5 &= 8191;
        d6 = c;
        d6 += h0 * r6;
        d6 += h1 * r5;
        d6 += h2 * r4;
        d6 += h3 * r3;
        d6 += h4 * r2;
        c = d6 >>> 13;
        d6 &= 8191;
        d6 += h5 * r1;
        d6 += h6 * r0;
        d6 += h7 * (5 * r9);
        d6 += h8 * (5 * r8);
        d6 += h9 * (5 * r7);
        c += d6 >>> 13;
        d6 &= 8191;
        d7 = c;
        d7 += h0 * r7;
        d7 += h1 * r6;
        d7 += h2 * r5;
        d7 += h3 * r4;
        d7 += h4 * r3;
        c = d7 >>> 13;
        d7 &= 8191;
        d7 += h5 * r2;
        d7 += h6 * r1;
        d7 += h7 * r0;
        d7 += h8 * (5 * r9);
        d7 += h9 * (5 * r8);
        c += d7 >>> 13;
        d7 &= 8191;
        d8 = c;
        d8 += h0 * r8;
        d8 += h1 * r7;
        d8 += h2 * r6;
        d8 += h3 * r5;
        d8 += h4 * r4;
        c = d8 >>> 13;
        d8 &= 8191;
        d8 += h5 * r3;
        d8 += h6 * r2;
        d8 += h7 * r1;
        d8 += h8 * r0;
        d8 += h9 * (5 * r9);
        c += d8 >>> 13;
        d8 &= 8191;
        d9 = c;
        d9 += h0 * r9;
        d9 += h1 * r8;
        d9 += h2 * r7;
        d9 += h3 * r6;
        d9 += h4 * r5;
        c = d9 >>> 13;
        d9 &= 8191;
        d9 += h5 * r4;
        d9 += h6 * r3;
        d9 += h7 * r2;
        d9 += h8 * r1;
        d9 += h9 * r0;
        c += d9 >>> 13;
        d9 &= 8191;
        c = (c << 2) + c | 0;
        c = c + d0 | 0;
        d0 = c & 8191;
        c = c >>> 13;
        d1 += c;
        h0 = d0;
        h1 = d1;
        h2 = d2;
        h3 = d3;
        h4 = d4;
        h5 = d5;
        h6 = d6;
        h7 = d7;
        h8 = d8;
        h9 = d9;
        mpos += 16;
        bytes -= 16;
      }
      this.h[0] = h0;
      this.h[1] = h1;
      this.h[2] = h2;
      this.h[3] = h3;
      this.h[4] = h4;
      this.h[5] = h5;
      this.h[6] = h6;
      this.h[7] = h7;
      this.h[8] = h8;
      this.h[9] = h9;
    };
    poly1305.prototype.finish = function(mac, macpos) {
      var g = new Uint16Array(10);
      var c, mask, f, i;
      if (this.leftover) {
        i = this.leftover;
        this.buffer[i++] = 1;
        for (; i < 16; i++) this.buffer[i] = 0;
        this.fin = 1;
        this.blocks(this.buffer, 0, 16);
      }
      c = this.h[1] >>> 13;
      this.h[1] &= 8191;
      for (i = 2; i < 10; i++) {
        this.h[i] += c;
        c = this.h[i] >>> 13;
        this.h[i] &= 8191;
      }
      this.h[0] += c * 5;
      c = this.h[0] >>> 13;
      this.h[0] &= 8191;
      this.h[1] += c;
      c = this.h[1] >>> 13;
      this.h[1] &= 8191;
      this.h[2] += c;
      g[0] = this.h[0] + 5;
      c = g[0] >>> 13;
      g[0] &= 8191;
      for (i = 1; i < 10; i++) {
        g[i] = this.h[i] + c;
        c = g[i] >>> 13;
        g[i] &= 8191;
      }
      g[9] -= 1 << 13;
      mask = (c ^ 1) - 1;
      for (i = 0; i < 10; i++) g[i] &= mask;
      mask = ~mask;
      for (i = 0; i < 10; i++) this.h[i] = this.h[i] & mask | g[i];
      this.h[0] = (this.h[0] | this.h[1] << 13) & 65535;
      this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 65535;
      this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 65535;
      this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 65535;
      this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 65535;
      this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 65535;
      this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 65535;
      this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 65535;
      f = this.h[0] + this.pad[0];
      this.h[0] = f & 65535;
      for (i = 1; i < 8; i++) {
        f = (this.h[i] + this.pad[i] | 0) + (f >>> 16) | 0;
        this.h[i] = f & 65535;
      }
      mac[macpos + 0] = this.h[0] >>> 0 & 255;
      mac[macpos + 1] = this.h[0] >>> 8 & 255;
      mac[macpos + 2] = this.h[1] >>> 0 & 255;
      mac[macpos + 3] = this.h[1] >>> 8 & 255;
      mac[macpos + 4] = this.h[2] >>> 0 & 255;
      mac[macpos + 5] = this.h[2] >>> 8 & 255;
      mac[macpos + 6] = this.h[3] >>> 0 & 255;
      mac[macpos + 7] = this.h[3] >>> 8 & 255;
      mac[macpos + 8] = this.h[4] >>> 0 & 255;
      mac[macpos + 9] = this.h[4] >>> 8 & 255;
      mac[macpos + 10] = this.h[5] >>> 0 & 255;
      mac[macpos + 11] = this.h[5] >>> 8 & 255;
      mac[macpos + 12] = this.h[6] >>> 0 & 255;
      mac[macpos + 13] = this.h[6] >>> 8 & 255;
      mac[macpos + 14] = this.h[7] >>> 0 & 255;
      mac[macpos + 15] = this.h[7] >>> 8 & 255;
    };
    poly1305.prototype.update = function(m, mpos, bytes) {
      var i, want;
      if (this.leftover) {
        want = 16 - this.leftover;
        if (want > bytes)
          want = bytes;
        for (i = 0; i < want; i++)
          this.buffer[this.leftover + i] = m[mpos + i];
        bytes -= want;
        mpos += want;
        this.leftover += want;
        if (this.leftover < 16)
          return;
        this.blocks(this.buffer, 0, 16);
        this.leftover = 0;
      }
      if (bytes >= 16) {
        want = bytes - bytes % 16;
        this.blocks(m, mpos, want);
        mpos += want;
        bytes -= want;
      }
      if (bytes) {
        for (i = 0; i < bytes; i++)
          this.buffer[this.leftover + i] = m[mpos + i];
        this.leftover += bytes;
      }
    };
    module.exports = poly1305;
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_onetimeauth.js
var require_crypto_onetimeauth = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_onetimeauth.js"(exports, module) {
    var assert = require_nanoassert();
    var Poly1305 = require_poly1305();
    var { crypto_verify_16 } = require_crypto_verify();
    var crypto_onetimeauth_BYTES = 16;
    var crypto_onetimeauth_KEYBYTES = 32;
    var crypto_onetimeauth_PRIMITIVE = "poly1305";
    module.exports = {
      crypto_onetimeauth,
      crypto_onetimeauth_verify,
      crypto_onetimeauth_BYTES,
      crypto_onetimeauth_KEYBYTES,
      crypto_onetimeauth_PRIMITIVE
    };
    function crypto_onetimeauth(mac, msg, key) {
      assert(mac.byteLength === crypto_onetimeauth_BYTES, "mac must be 'crypto_onetimeauth_BYTES' bytes");
      assert(msg.byteLength != null, "msg must be buffer");
      assert(key.byteLength === crypto_onetimeauth_KEYBYTES, "key must be 'crypto_onetimeauth_KEYBYTES' bytes");
      var s = new Poly1305(key);
      s.update(msg, 0, msg.byteLength);
      s.finish(mac, 0);
    }
    function crypto_onetimeauth_verify(mac, msg, key) {
      assert(mac.byteLength === crypto_onetimeauth_BYTES, "mac must be 'crypto_onetimeauth_BYTES' bytes");
      assert(msg.byteLength != null, "msg must be buffer");
      assert(key.byteLength === crypto_onetimeauth_KEYBYTES, "key must be 'crypto_onetimeauth_KEYBYTES' bytes");
      var tmp = new Uint8Array(16);
      crypto_onetimeauth(tmp, msg, key);
      return crypto_verify_16(mac, 0, tmp, 0);
    }
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_secretbox.js
var require_crypto_secretbox = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_secretbox.js"(exports, module) {
    var assert = require_nanoassert();
    var { crypto_stream, crypto_stream_xor } = require_crypto_stream();
    var { crypto_onetimeauth, crypto_onetimeauth_verify, crypto_onetimeauth_BYTES, crypto_onetimeauth_KEYBYTES } = require_crypto_onetimeauth();
    var crypto_secretbox_KEYBYTES = 32;
    var crypto_secretbox_NONCEBYTES = 24;
    var crypto_secretbox_ZEROBYTES = 32;
    var crypto_secretbox_BOXZEROBYTES = 16;
    var crypto_secretbox_MACBYTES = 16;
    module.exports = {
      crypto_secretbox,
      crypto_secretbox_open,
      crypto_secretbox_detached,
      crypto_secretbox_open_detached,
      crypto_secretbox_easy,
      crypto_secretbox_open_easy,
      crypto_secretbox_KEYBYTES,
      crypto_secretbox_NONCEBYTES,
      crypto_secretbox_ZEROBYTES,
      crypto_secretbox_BOXZEROBYTES,
      crypto_secretbox_MACBYTES
    };
    function crypto_secretbox(c, m, n, k) {
      assert(c.byteLength === m.byteLength, "c must be 'm.byteLength' bytes");
      const mlen = m.byteLength;
      assert(mlen >= crypto_secretbox_ZEROBYTES, "mlen must be at least 'crypto_secretbox_ZEROBYTES'");
      assert(n.byteLength === crypto_secretbox_NONCEBYTES, "n must be 'crypto_secretbox_NONCEBYTES' bytes");
      assert(k.byteLength === crypto_secretbox_KEYBYTES, "k must be 'crypto_secretbox_KEYBYTES' bytes");
      crypto_stream_xor(c, m, n, k);
      crypto_onetimeauth(
        c.subarray(crypto_secretbox_BOXZEROBYTES, crypto_secretbox_BOXZEROBYTES + crypto_onetimeauth_BYTES),
        c.subarray(crypto_secretbox_BOXZEROBYTES + crypto_onetimeauth_BYTES, c.byteLength),
        c.subarray(0, crypto_onetimeauth_KEYBYTES)
      );
      c.fill(0, 0, crypto_secretbox_BOXZEROBYTES);
    }
    function crypto_secretbox_open(m, c, n, k) {
      assert(c.byteLength === m.byteLength, "c must be 'm.byteLength' bytes");
      const mlen = m.byteLength;
      assert(mlen >= crypto_secretbox_ZEROBYTES, "mlen must be at least 'crypto_secretbox_ZEROBYTES'");
      assert(n.byteLength === crypto_secretbox_NONCEBYTES, "n must be 'crypto_secretbox_NONCEBYTES' bytes");
      assert(k.byteLength === crypto_secretbox_KEYBYTES, "k must be 'crypto_secretbox_KEYBYTES' bytes");
      const x = new Uint8Array(crypto_onetimeauth_KEYBYTES);
      crypto_stream(x, n, k);
      const validMac = crypto_onetimeauth_verify(
        c.subarray(crypto_secretbox_BOXZEROBYTES, crypto_secretbox_BOXZEROBYTES + crypto_onetimeauth_BYTES),
        c.subarray(crypto_secretbox_BOXZEROBYTES + crypto_onetimeauth_BYTES, c.byteLength),
        x
      );
      if (validMac === false) return false;
      crypto_stream_xor(m, c, n, k);
      m.fill(0, 0, 32);
      return true;
    }
    function crypto_secretbox_detached(o, mac, msg, n, k) {
      assert(o.byteLength === msg.byteLength, "o must be 'msg.byteLength' bytes");
      assert(mac.byteLength === crypto_secretbox_MACBYTES, "mac must be 'crypto_secretbox_MACBYTES' bytes");
      assert(n.byteLength === crypto_secretbox_NONCEBYTES, "n must be 'crypto_secretbox_NONCEBYTES' bytes");
      assert(k.byteLength === crypto_secretbox_KEYBYTES, "k must be 'crypto_secretbox_KEYBYTES' bytes");
      const tmp = new Uint8Array(msg.byteLength + mac.byteLength);
      crypto_secretbox_easy(tmp, msg, n, k);
      mac.set(tmp.subarray(0, mac.byteLength));
      o.set(tmp.subarray(mac.byteLength));
      return true;
    }
    function crypto_secretbox_open_detached(msg, o, mac, n, k) {
      assert(o.byteLength === msg.byteLength, "o must be 'msg.byteLength' bytes");
      assert(mac.byteLength === crypto_secretbox_MACBYTES, "mac must be 'crypto_secretbox_MACBYTES' bytes");
      assert(n.byteLength === crypto_secretbox_NONCEBYTES, "n must be 'crypto_secretbox_NONCEBYTES' bytes");
      assert(k.byteLength === crypto_secretbox_KEYBYTES, "k must be 'crypto_secretbox_KEYBYTES' bytes");
      const tmp = new Uint8Array(o.byteLength + mac.byteLength);
      tmp.set(mac);
      tmp.set(o, mac.byteLength);
      return crypto_secretbox_open_easy(msg, tmp, n, k);
    }
    function crypto_secretbox_easy(o, msg, n, k) {
      assert(o.byteLength === msg.byteLength + crypto_secretbox_MACBYTES, "o must be 'msg.byteLength + crypto_secretbox_MACBYTES' bytes");
      assert(n.byteLength === crypto_secretbox_NONCEBYTES, "n must be 'crypto_secretbox_NONCEBYTES' bytes");
      assert(k.byteLength === crypto_secretbox_KEYBYTES, "k must be 'crypto_secretbox_KEYBYTES' bytes");
      const m = new Uint8Array(crypto_secretbox_ZEROBYTES + msg.byteLength);
      const c = new Uint8Array(m.byteLength);
      m.set(msg, crypto_secretbox_ZEROBYTES);
      crypto_secretbox(c, m, n, k);
      o.set(c.subarray(crypto_secretbox_BOXZEROBYTES));
    }
    function crypto_secretbox_open_easy(msg, box, n, k) {
      assert(box.byteLength === msg.byteLength + crypto_secretbox_MACBYTES, "box must be 'msg.byteLength + crypto_secretbox_MACBYTES' bytes");
      assert(n.byteLength === crypto_secretbox_NONCEBYTES, "n must be 'crypto_secretbox_NONCEBYTES' bytes");
      assert(k.byteLength === crypto_secretbox_KEYBYTES, "k must be 'crypto_secretbox_KEYBYTES' bytes");
      const c = new Uint8Array(crypto_secretbox_BOXZEROBYTES + box.byteLength);
      const m = new Uint8Array(c.byteLength);
      c.set(box, crypto_secretbox_BOXZEROBYTES);
      if (crypto_secretbox_open(m, c, n, k) === false) return false;
      msg.set(m.subarray(crypto_secretbox_ZEROBYTES));
      return true;
    }
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_box.js
var require_crypto_box = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_box.js"(exports, module) {
    var { crypto_hash_sha512 } = require_crypto_hash();
    var { crypto_scalarmult, crypto_scalarmult_base } = require_crypto_scalarmult();
    var { randombytes } = require_randombytes();
    var { crypto_generichash_batch } = require_crypto_generichash();
    var { crypto_stream_xsalsa20_MESSAGEBYTES_MAX } = require_crypto_stream();
    var {
      crypto_secretbox_open_easy,
      crypto_secretbox_easy,
      crypto_secretbox_detached,
      crypto_secretbox_open_detached
    } = require_crypto_secretbox();
    var xsalsa20 = require_xsalsa202();
    var assert = require_nanoassert();
    var crypto_box_PUBLICKEYBYTES = 32;
    var crypto_box_SECRETKEYBYTES = 32;
    var crypto_box_NONCEBYTES = 24;
    var crypto_box_ZEROBYTES = 32;
    var crypto_box_BOXZEROBYTES = 16;
    var crypto_box_SEALBYTES = 48;
    var crypto_box_SEEDBYTES = 32;
    var crypto_box_BEFORENMBYTES = 32;
    var crypto_box_MACBYTES = 16;
    var crypto_box_curve25519xsalsa20poly1305_MACBYTES = 16;
    var crypto_box_MESSAGEBYTES_MAX = crypto_stream_xsalsa20_MESSAGEBYTES_MAX - crypto_box_curve25519xsalsa20poly1305_MACBYTES;
    module.exports = {
      crypto_box_easy,
      crypto_box_open_easy,
      crypto_box_keypair,
      crypto_box_seed_keypair,
      crypto_box_seal,
      crypto_box_seal_open,
      crypto_box_PUBLICKEYBYTES,
      crypto_box_SECRETKEYBYTES,
      crypto_box_NONCEBYTES,
      crypto_box_ZEROBYTES,
      crypto_box_BOXZEROBYTES,
      crypto_box_SEALBYTES,
      crypto_box_SEEDBYTES,
      crypto_box_BEFORENMBYTES,
      crypto_box_MACBYTES
    };
    function crypto_box_keypair(pk, sk) {
      check(pk, crypto_box_PUBLICKEYBYTES);
      check(sk, crypto_box_SECRETKEYBYTES);
      randombytes(sk, 32);
      return crypto_scalarmult_base(pk, sk);
    }
    function crypto_box_seed_keypair(pk, sk, seed) {
      assert(pk.byteLength === crypto_box_PUBLICKEYBYTES, "pk should be 'crypto_box_PUBLICKEYBYTES' bytes");
      assert(sk.byteLength === crypto_box_SECRETKEYBYTES, "sk should be 'crypto_box_SECRETKEYBYTES' bytes");
      assert(sk.byteLength === crypto_box_SEEDBYTES, "sk should be 'crypto_box_SEEDBYTES' bytes");
      const hash = new Uint8Array(64);
      crypto_hash_sha512(hash, seed, 32);
      sk.set(hash.subarray(0, 32));
      hash.fill(0);
      return crypto_scalarmult_base(pk, sk);
    }
    function crypto_box_seal(c, m, pk) {
      check(c, crypto_box_SEALBYTES + m.length);
      check(pk, crypto_box_PUBLICKEYBYTES);
      var epk = c.subarray(0, crypto_box_PUBLICKEYBYTES);
      var esk = new Uint8Array(crypto_box_SECRETKEYBYTES);
      crypto_box_keypair(epk, esk);
      var n = new Uint8Array(crypto_box_NONCEBYTES);
      crypto_generichash_batch(n, [epk, pk]);
      var s = new Uint8Array(crypto_box_PUBLICKEYBYTES);
      crypto_scalarmult(s, esk, pk);
      var k = new Uint8Array(crypto_box_BEFORENMBYTES);
      var zero = new Uint8Array(16);
      xsalsa20.core_hsalsa20(k, zero, s, xsalsa20.SIGMA);
      crypto_secretbox_easy(c.subarray(epk.length), m, n, k);
      cleanup(esk);
    }
    function crypto_box_seal_open(m, c, pk, sk) {
      check(c, crypto_box_SEALBYTES);
      check(m, c.length - crypto_box_SEALBYTES);
      check(pk, crypto_box_PUBLICKEYBYTES);
      check(sk, crypto_box_SECRETKEYBYTES);
      var epk = c.subarray(0, crypto_box_PUBLICKEYBYTES);
      var n = new Uint8Array(crypto_box_NONCEBYTES);
      crypto_generichash_batch(n, [epk, pk]);
      var s = new Uint8Array(crypto_box_PUBLICKEYBYTES);
      crypto_scalarmult(s, sk, epk);
      var k = new Uint8Array(crypto_box_BEFORENMBYTES);
      var zero = new Uint8Array(16);
      xsalsa20.core_hsalsa20(k, zero, s, xsalsa20.SIGMA);
      return crypto_secretbox_open_easy(m, c.subarray(epk.length), n, k);
    }
    function crypto_box_beforenm(k, pk, sk) {
      const zero = new Uint8Array(16);
      const s = new Uint8Array(32);
      assert(crypto_scalarmult(s, sk, pk) === 0);
      xsalsa20.core_hsalsa20(k, zero, s, xsalsa20.SIGMA);
      return true;
    }
    function crypto_box_detached_afternm(c, mac, m, n, k) {
      return crypto_secretbox_detached(c, mac, m, n, k);
    }
    function crypto_box_detached(c, mac, m, n, pk, sk) {
      check(mac, crypto_box_MACBYTES);
      check(n, crypto_box_NONCEBYTES);
      check(pk, crypto_box_PUBLICKEYBYTES);
      check(sk, crypto_box_SECRETKEYBYTES);
      const k = new Uint8Array(crypto_box_BEFORENMBYTES);
      assert(crypto_box_beforenm(k, pk, sk));
      const ret = crypto_box_detached_afternm(c, mac, m, n, k);
      cleanup(k);
      return ret;
    }
    function crypto_box_easy(c, m, n, pk, sk) {
      assert(
        c.length >= m.length + crypto_box_MACBYTES,
        "c should be at least 'm.length + crypto_box_MACBYTES' bytes"
      );
      assert(
        m.length <= crypto_box_MESSAGEBYTES_MAX,
        "m should be at most 'crypto_box_MESSAGEBYTES_MAX' bytes"
      );
      return crypto_box_detached(
        c.subarray(crypto_box_MACBYTES, m.length + crypto_box_MACBYTES),
        c.subarray(0, crypto_box_MACBYTES),
        m,
        n,
        pk,
        sk
      );
    }
    function crypto_box_open_detached_afternm(m, c, mac, n, k) {
      return crypto_secretbox_open_detached(m, c, mac, n, k);
    }
    function crypto_box_open_detached(m, c, mac, n, pk, sk) {
      const k = new Uint8Array(crypto_box_BEFORENMBYTES);
      assert(crypto_box_beforenm(k, pk, sk));
      const ret = crypto_box_open_detached_afternm(m, c, mac, n, k);
      cleanup(k);
      return ret;
    }
    function crypto_box_open_easy(m, c, n, pk, sk) {
      assert(
        c.length >= m.length + crypto_box_MACBYTES,
        "c should be at least 'm.length + crypto_box_MACBYTES' bytes"
      );
      return crypto_box_open_detached(
        m,
        c.subarray(crypto_box_MACBYTES, m.length + crypto_box_MACBYTES),
        c.subarray(0, crypto_box_MACBYTES),
        n,
        pk,
        sk
      );
    }
    function check(buf, len) {
      if (!buf || len && buf.length < len) throw new Error("Argument must be a buffer" + (len ? " of length " + len : ""));
    }
    function cleanup(arr) {
      for (let i = 0; i < arr.length; i++) arr[i] = 0;
    }
  }
});

// ../../node_modules/.pnpm/sha256-universal@1.2.1/node_modules/sha256-universal/sha256.js
var require_sha256 = __commonJS({
  "../../node_modules/.pnpm/sha256-universal@1.2.1/node_modules/sha256-universal/sha256.js"(exports, module) {
    var assert = require_nanoassert();
    var b4a = require_browser();
    module.exports = Sha256;
    var SHA256_BYTES = module.exports.SHA256_BYTES = 32;
    var BLOCKSIZE = 64;
    var K = [
      1116352408,
      1899447441,
      3049323471,
      3921009573,
      961987163,
      1508970993,
      2453635748,
      2870763221,
      3624381080,
      310598401,
      607225278,
      1426881987,
      1925078388,
      2162078206,
      2614888103,
      3248222580,
      3835390401,
      4022224774,
      264347078,
      604807628,
      770255983,
      1249150122,
      1555081692,
      1996064986,
      2554220882,
      2821834349,
      2952996808,
      3210313671,
      3336571891,
      3584528711,
      113926993,
      338241895,
      666307205,
      773529912,
      1294757372,
      1396182291,
      1695183700,
      1986661051,
      2177026350,
      2456956037,
      2730485921,
      2820302411,
      3259730800,
      3345764771,
      3516065817,
      3600352804,
      4094571909,
      275423344,
      430227734,
      506948616,
      659060556,
      883997877,
      958139571,
      1322822218,
      1537002063,
      1747873779,
      1955562222,
      2024104815,
      2227730452,
      2361852424,
      2428436474,
      2756734187,
      3204031479,
      3329325298
    ];
    function expand(a, b, c, d) {
      var b_ = ((a >>> 17 | a << 15) ^ (a >>> 19 | a << 13) ^ a >>> 10) + b;
      var d_ = ((c >>> 7 | c << 25) ^ (c >>> 18 | c << 14) ^ c >>> 3) + d;
      return b_ + d_ << 0;
    }
    function compress(state, words) {
      var ch, maj, s0, s1, T1, T2;
      var [a, b, c, d, e, f, g, h] = state;
      const w = new Uint32Array(64);
      for (let i = 0; i < 16; i++) w[i] = bswap(words[i]);
      for (let i = 16; i < 64; i++) w[i] = expand(w[i - 2], w[i - 7], w[i - 15], w[i - 16]);
      for (let i = 0; i < 64; i += 4) round(i);
      state[0] = state[0] + a;
      state[1] = state[1] + b;
      state[2] = state[2] + c;
      state[3] = state[3] + d;
      state[4] = state[4] + e;
      state[5] = state[5] + f;
      state[6] = state[6] + g;
      state[7] = state[7] + h;
      function round(n) {
        ch = e & f ^ ~e & g;
        maj = a & b ^ a & c ^ b & c;
        s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
        s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
        T1 = h + ch + s1 + w[n] + K[n];
        T2 = s0 + maj;
        h = d + T1;
        d = T1 + T2;
        ch = h & e ^ ~h & f;
        maj = d & a ^ d & b ^ a & b;
        s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
        s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
        T1 = g + ch + s1 + w[n + 1] + K[n + 1];
        T2 = s0 + maj;
        g = c + T1;
        c = T1 + T2;
        ch = g & h ^ ~g & e;
        maj = c & d ^ c & a ^ d & a;
        s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
        s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
        T1 = f + ch + s1 + w[n + 2] + K[n + 2];
        T2 = s0 + maj;
        f = b + T1;
        b = T1 + T2;
        ch = f & g ^ ~f & h;
        maj = b & c ^ b & d ^ c & d;
        s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
        s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
        T1 = e + ch + s1 + w[n + 3] + K[n + 3];
        T2 = s0 + maj;
        e = a + T1;
        a = T1 + T2;
      }
    }
    function Sha256() {
      if (!(this instanceof Sha256)) return new Sha256();
      this.buffer = new ArrayBuffer(64);
      this.bytesRead = 0;
      this.pos = 0;
      this.digestLength = SHA256_BYTES;
      this.finalised = false;
      this.load = new Uint8Array(this.buffer);
      this.words = new Uint32Array(this.buffer);
      this.state = new Uint32Array([
        1779033703,
        3144134277,
        1013904242,
        2773480762,
        1359893119,
        2600822924,
        528734635,
        1541459225
      ]);
      return this;
    }
    Sha256.prototype.update = function(input, enc) {
      assert(this.finalised === false, "Hash instance finalised");
      var [inputBuf, len] = formatInput(input, enc);
      var i = 0;
      this.bytesRead += len;
      while (len > 0) {
        this.load.set(inputBuf.subarray(i, i + BLOCKSIZE - this.pos), this.pos);
        i += BLOCKSIZE - this.pos;
        len -= BLOCKSIZE - this.pos;
        if (len < 0) break;
        this.pos = 0;
        compress(this.state, this.words);
      }
      this.pos = this.bytesRead & 63;
      this.load.fill(0, this.pos);
      return this;
    };
    Sha256.prototype.digest = function(enc, offset = 0) {
      assert(this.finalised === false, "Hash instance finalised");
      this.finalised = true;
      this.load.fill(0, this.pos);
      this.load[this.pos] = 128;
      if (this.pos > 55) {
        compress(this.state, this.words);
        this.words.fill(0);
        this.pos = 0;
      }
      const view = new DataView(this.buffer);
      view.setUint32(56, this.bytesRead / 2 ** 29);
      view.setUint32(60, this.bytesRead << 3);
      compress(this.state, this.words);
      const resultBuf = new Uint8Array(this.state.map(bswap).buffer);
      if (!enc) {
        return new Uint8Array(resultBuf);
      }
      if (typeof enc === "string") {
        return b4a.toString(resultBuf, enc);
      }
      assert(enc instanceof Uint8Array, "input must be Uint8Array or Buffer");
      assert(enc.byteLength >= this.digestLength + offset, "input not large enough for digest");
      for (let i = 0; i < this.digestLength; i++) {
        enc[i + offset] = resultBuf[i];
      }
      return enc;
    };
    function HMAC(key) {
      if (!(this instanceof HMAC)) return new HMAC(key);
      this.pad = b4a.alloc(64);
      this.inner = Sha256();
      this.outer = Sha256();
      const keyhash = b4a.alloc(32);
      if (key.byteLength > 64) {
        Sha256().update(key).digest(keyhash);
        key = keyhash;
      }
      this.pad.fill(54);
      for (let i = 0; i < key.byteLength; i++) {
        this.pad[i] ^= key[i];
      }
      this.inner.update(this.pad);
      this.pad.fill(92);
      for (let i = 0; i < key.byteLength; i++) {
        this.pad[i] ^= key[i];
      }
      this.outer.update(this.pad);
      this.pad.fill(0);
      keyhash.fill(0);
    }
    HMAC.prototype.update = function(input, enc) {
      this.inner.update(input, enc);
      return this;
    };
    HMAC.prototype.digest = function(enc, offset = 0) {
      this.outer.update(this.inner.digest());
      return this.outer.digest(enc, offset);
    };
    Sha256.HMAC = HMAC;
    function formatInput(input, enc) {
      var result = b4a.from(input, enc);
      return [result, result.byteLength];
    }
    function bswap(a) {
      var r = (a & 16711935) >>> 8 | (a & 16711935) << 24;
      var l = (a & 4278255360) << 8 | (a & 4278255360) >>> 24;
      return r | l;
    }
  }
});

// ../../node_modules/.pnpm/sha256-wasm@2.2.2/node_modules/sha256-wasm/sha256.js
var require_sha2562 = __commonJS({
  "../../node_modules/.pnpm/sha256-wasm@2.2.2/node_modules/sha256-wasm/sha256.js"(exports, module) {
    var __commonJS2 = (cb, mod) => function __require2() {
      return mod || (0, cb[Object.keys(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
    };
    var __toBinary = /* @__PURE__ */ (() => {
      var table = new Uint8Array(128);
      for (var i = 0; i < 64; i++)
        table[i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i * 4 - 205] = i;
      return (base64) => {
        var n = base64.length, bytes2 = new Uint8Array((n - (base64[n - 1] == "=") - (base64[n - 2] == "=")) * 3 / 4 | 0);
        for (var i2 = 0, j = 0; i2 < n; ) {
          var c0 = table[base64.charCodeAt(i2++)], c1 = table[base64.charCodeAt(i2++)];
          var c2 = table[base64.charCodeAt(i2++)], c3 = table[base64.charCodeAt(i2++)];
          bytes2[j++] = c0 << 2 | c1 >> 4;
          bytes2[j++] = c1 << 4 | c2 >> 2;
          bytes2[j++] = c2 << 6 | c3;
        }
        return bytes2;
      };
    })();
    var require_sha2563 = __commonJS2({
      "wasm-binary:./sha256.wat"(exports2, module2) {
        module2.exports = __toBinary("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");
      }
    });
    var bytes = require_sha2563();
    var compiled = new WebAssembly.Module(bytes);
    module.exports = (imports) => {
      const instance = new WebAssembly.Instance(compiled, imports);
      return instance.exports;
    };
  }
});

// ../../node_modules/.pnpm/sha256-wasm@2.2.2/node_modules/sha256-wasm/index.js
var require_sha256_wasm = __commonJS({
  "../../node_modules/.pnpm/sha256-wasm@2.2.2/node_modules/sha256-wasm/index.js"(exports, module) {
    var assert = require_nanoassert();
    var b4a = require_browser();
    var wasm = typeof WebAssembly !== "undefined" && require_sha2562()({
      imports: {
        debug: {
          log(...args) {
            console.log(...args.map((int) => (int >>> 0).toString(16).padStart(8, "0")));
          },
          log_tee(arg) {
            console.log((arg >>> 0).toString(16).padStart(8, "0"));
            return arg;
          }
        }
      }
    });
    var head = 0;
    var freeList = [];
    module.exports = Sha256;
    var SHA256_BYTES = module.exports.SHA256_BYTES = 32;
    var INPUT_OFFSET = 40;
    var STATEBYTES = 108;
    var BLOCKSIZE = 64;
    function Sha256() {
      if (!(this instanceof Sha256)) return new Sha256();
      if (!wasm) throw new Error("WASM not loaded. Wait for Sha256.ready(cb)");
      if (!freeList.length) {
        freeList.push(head);
        head += STATEBYTES;
      }
      this.finalized = false;
      this.digestLength = SHA256_BYTES;
      this.pointer = freeList.pop();
      this.pos = 0;
      this._memory = new Uint8Array(wasm.memory.buffer);
      this._memory.fill(0, this.pointer, this.pointer + STATEBYTES);
      if (this.pointer + this.digestLength > this._memory.length) this._realloc(this.pointer + STATEBYTES);
    }
    Sha256.prototype._realloc = function(size) {
      wasm.memory.grow(Math.max(0, Math.ceil(Math.abs(size - this._memory.length) / 65536)));
      this._memory = new Uint8Array(wasm.memory.buffer);
    };
    Sha256.prototype.update = function(input, enc) {
      assert(this.finalized === false, "Hash instance finalized");
      if (head % 4 !== 0) head += 4 - head % 4;
      assert(head % 4 === 0, "input shoud be aligned for int32");
      const [inputBuf, length] = formatInput(input, enc);
      assert(inputBuf instanceof Uint8Array, "input must be Uint8Array or Buffer");
      if (head + length > this._memory.length) this._realloc(head + input.length);
      this._memory.fill(0, head, head + roundUp(length, BLOCKSIZE) - BLOCKSIZE);
      this._memory.set(inputBuf.subarray(0, BLOCKSIZE - this.pos), this.pointer + INPUT_OFFSET + this.pos);
      this._memory.set(inputBuf.subarray(BLOCKSIZE - this.pos), head);
      this.pos = this.pos + length & 63;
      wasm.sha256(this.pointer, head, length, 0);
      return this;
    };
    Sha256.prototype.digest = function(enc, offset = 0) {
      assert(this.finalized === false, "Hash instance finalized");
      this.finalized = true;
      freeList.push(this.pointer);
      const paddingStart = this.pointer + INPUT_OFFSET + this.pos;
      this._memory.fill(0, paddingStart, this.pointer + INPUT_OFFSET + BLOCKSIZE);
      wasm.sha256(this.pointer, head, 0, 1);
      const resultBuf = this._memory.subarray(this.pointer, this.pointer + this.digestLength);
      if (!enc) {
        return resultBuf;
      }
      if (typeof enc === "string") {
        return b4a.toString(resultBuf, enc);
      }
      assert(enc instanceof Uint8Array, "output must be Uint8Array or Buffer");
      assert(
        enc.byteLength >= this.digestLength + offset,
        "output must have at least 'SHA256_BYTES' bytes remaining"
      );
      for (let i = 0; i < this.digestLength; i++) {
        enc[i + offset] = resultBuf[i];
      }
      return enc;
    };
    Sha256.WASM = wasm;
    Sha256.WASM_SUPPORTED = typeof WebAssembly !== "undefined";
    Sha256.ready = function(cb) {
      if (!cb) cb = noop;
      if (!wasm) return cb(new Error("WebAssembly not supported"));
      cb();
      return Promise.resolve();
    };
    Sha256.prototype.ready = Sha256.ready;
    function HMAC(key) {
      if (!(this instanceof HMAC)) return new HMAC(key);
      this.pad = b4a.alloc(64);
      this.inner = Sha256();
      this.outer = Sha256();
      const keyhash = b4a.alloc(32);
      if (key.byteLength > 64) {
        Sha256().update(key).digest(keyhash);
        key = keyhash;
      }
      this.pad.fill(54);
      for (let i = 0; i < key.byteLength; i++) {
        this.pad[i] ^= key[i];
      }
      this.inner.update(this.pad);
      this.pad.fill(92);
      for (let i = 0; i < key.byteLength; i++) {
        this.pad[i] ^= key[i];
      }
      this.outer.update(this.pad);
      this.pad.fill(0);
      keyhash.fill(0);
    }
    HMAC.prototype.update = function(input, enc) {
      this.inner.update(input, enc);
      return this;
    };
    HMAC.prototype.digest = function(enc, offset = 0) {
      this.outer.update(this.inner.digest());
      return this.outer.digest(enc, offset);
    };
    Sha256.HMAC = HMAC;
    function noop() {
    }
    function formatInput(input, enc) {
      var result = b4a.from(input, enc);
      return [result, result.byteLength];
    }
    function roundUp(n, base) {
      return n + base - 1 & -base;
    }
  }
});

// ../../node_modules/.pnpm/sha256-universal@1.2.1/node_modules/sha256-universal/index.js
var require_sha256_universal = __commonJS({
  "../../node_modules/.pnpm/sha256-universal@1.2.1/node_modules/sha256-universal/index.js"(exports, module) {
    var js = require_sha256();
    var wasm = require_sha256_wasm();
    var Proto = js;
    module.exports = function() {
      return new Proto();
    };
    module.exports.ready = function(cb) {
      wasm.ready(function() {
        cb();
      });
    };
    module.exports.WASM_SUPPORTED = wasm.WASM_SUPPORTED;
    module.exports.WASM_LOADED = false;
    var SHA256_BYTES = module.exports.SHA256_BYTES = 32;
    wasm.ready(function(err) {
      if (!err) {
        module.exports.WASM_LOADED = true;
        module.exports = Proto = wasm;
      }
    });
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_hash_sha256.js
var require_crypto_hash_sha256 = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_hash_sha256.js"(exports, module) {
    var sha256 = require_sha256_universal();
    var assert = require_nanoassert();
    if (new Uint16Array([1])[0] !== 1) throw new Error("Big endian architecture is not supported.");
    var crypto_hash_sha256_BYTES = 32;
    function crypto_hash_sha256(out, m, n) {
      assert(out.byteLength === crypto_hash_sha256_BYTES, "out must be 'crypto_hash_sha256_BYTES' bytes long");
      sha256().update(m.subarray(0, n)).digest(out);
      return 0;
    }
    module.exports = {
      crypto_hash_sha256,
      crypto_hash_sha256_BYTES
    };
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_kdf.js
var require_crypto_kdf = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_kdf.js"(exports, module) {
    var assert = require_nanoassert();
    var randombytes_buf = require_randombytes().randombytes_buf;
    var blake2b = require_blake2b2();
    module.exports.crypto_kdf_PRIMITIVE = "blake2b";
    module.exports.crypto_kdf_BYTES_MIN = 16;
    module.exports.crypto_kdf_BYTES_MAX = 64;
    module.exports.crypto_kdf_CONTEXTBYTES = 8;
    module.exports.crypto_kdf_KEYBYTES = 32;
    function STORE64_LE(dest, int) {
      var mul = 1;
      var i = 0;
      dest[0] = int & 255;
      while (++i < 8 && (mul *= 256)) {
        dest[i] = int / mul & 255;
      }
    }
    module.exports.crypto_kdf_derive_from_key = function crypto_kdf_derive_from_key(subkey, subkey_id, ctx, key) {
      assert(subkey.length >= module.exports.crypto_kdf_BYTES_MIN, "subkey must be at least crypto_kdf_BYTES_MIN");
      assert(subkey_id >= 0 && subkey_id <= 9007199254740991, "subkey_id must be safe integer");
      assert(ctx.length >= module.exports.crypto_kdf_CONTEXTBYTES, "context must be at least crypto_kdf_CONTEXTBYTES");
      var ctx_padded = new Uint8Array(blake2b.PERSONALBYTES);
      var salt = new Uint8Array(blake2b.SALTBYTES);
      ctx_padded.set(ctx, 0, module.exports.crypto_kdf_CONTEXTBYTES);
      STORE64_LE(salt, subkey_id);
      var outlen = Math.min(subkey.length, module.exports.crypto_kdf_BYTES_MAX);
      blake2b(outlen, key.subarray(0, module.exports.crypto_kdf_KEYBYTES), salt, ctx_padded, true).final(subkey);
    };
    module.exports.crypto_kdf_keygen = function crypto_kdf_keygen(out) {
      assert(out.length >= module.exports.crypto_kdf_KEYBYTES, "out.length must be crypto_kdf_KEYBYTES");
      randombytes_buf(out.subarray(0, module.exports.crypto_kdf_KEYBYTES));
    };
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_kx.js
var require_crypto_kx = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_kx.js"(exports, module) {
    var { crypto_scalarmult_base } = require_crypto_scalarmult();
    var { crypto_generichash } = require_crypto_generichash();
    var { randombytes_buf } = require_randombytes();
    var assert = require_nanoassert();
    var crypto_kx_SEEDBYTES = 32;
    var crypto_kx_PUBLICKEYBYTES = 32;
    var crypto_kx_SECRETKEYBYTES = 32;
    function crypto_kx_keypair(pk, sk) {
      assert(pk.byteLength === crypto_kx_PUBLICKEYBYTES, "pk must be 'crypto_kx_PUBLICKEYBYTES' bytes");
      assert(sk.byteLength === crypto_kx_SECRETKEYBYTES, "sk must be 'crypto_kx_SECRETKEYBYTES' bytes");
      randombytes_buf(sk, crypto_kx_SECRETKEYBYTES);
      return crypto_scalarmult_base(pk, sk);
    }
    function crypto_kx_seed_keypair(pk, sk, seed) {
      assert(pk.byteLength === crypto_kx_PUBLICKEYBYTES, "pk must be 'crypto_kx_PUBLICKEYBYTES' bytes");
      assert(sk.byteLength === crypto_kx_SECRETKEYBYTES, "sk must be 'crypto_kx_SECRETKEYBYTES' bytes");
      assert(seed.byteLength === crypto_kx_SEEDBYTES, "seed must be 'crypto_kx_SEEDBYTES' bytes");
      crypto_generichash(sk, seed);
      return crypto_scalarmult_base(pk, sk);
    }
    module.exports = {
      crypto_kx_keypair,
      crypto_kx_seed_keypair,
      crypto_kx_SEEDBYTES,
      crypto_kx_SECRETKEYBYTES,
      crypto_kx_PUBLICKEYBYTES
    };
  }
});

// ../../node_modules/.pnpm/chacha20-universal@1.0.4/node_modules/chacha20-universal/index.js
var require_chacha20_universal = __commonJS({
  "../../node_modules/.pnpm/chacha20-universal@1.0.4/node_modules/chacha20-universal/index.js"(exports, module) {
    var assert = require_nanoassert();
    module.exports = Chacha20;
    var constant = [1634760805, 857760878, 2036477234, 1797285236];
    function Chacha20(nonce, key, counter) {
      assert(key.byteLength === 32);
      assert(nonce.byteLength === 8 || nonce.byteLength === 12);
      const n = new Uint32Array(nonce.buffer, nonce.byteOffset, nonce.byteLength / 4);
      const k = new Uint32Array(key.buffer, key.byteOffset, key.byteLength / 4);
      if (!counter) counter = 0;
      assert(counter < Number.MAX_SAFE_INTEGER);
      this.finalized = false;
      this.pos = 0;
      this.state = new Uint32Array(16);
      for (let i = 0; i < 4; i++) this.state[i] = constant[i];
      for (let i = 0; i < 8; i++) this.state[4 + i] = k[i];
      this.state[12] = counter & 4294967295;
      if (n.byteLength === 8) {
        this.state[13] = (counter && 18446744069414584e3) >> 32;
        this.state[14] = n[0];
        this.state[15] = n[1];
      } else {
        this.state[13] = n[0];
        this.state[14] = n[1];
        this.state[15] = n[2];
      }
      return this;
    }
    Chacha20.prototype.update = function(output, input) {
      assert(!this.finalized, "cipher finalized.");
      assert(
        output.byteLength >= input.byteLength,
        "output cannot be shorter than input."
      );
      let len = input.length;
      let offset = this.pos % 64;
      this.pos += len;
      let j = 0;
      let keyStream = chacha20Block(this.state);
      while (offset > 0 && len > 0) {
        output[j] = input[j++] ^ keyStream[offset];
        offset = offset + 1 & 63;
        if (!offset) this.state[12]++;
        len--;
      }
      while (len > 0) {
        keyStream = chacha20Block(this.state);
        if (len < 64) {
          for (let i = 0; i < len; i++) {
            output[j] = input[j++] ^ keyStream[offset++];
            offset &= 63;
          }
          return;
        }
        for (; offset < 64; ) {
          output[j] = input[j++] ^ keyStream[offset++];
        }
        this.state[12]++;
        offset = 0;
        len -= 64;
      }
    };
    Chacha20.prototype.final = function() {
      this.state.fill(0);
      this.pos = 0;
      this.finalized = true;
    };
    function chacha20Block(state) {
      const ws = new Uint32Array(16);
      for (let i = 16; i--; ) ws[i] = state[i];
      for (let i = 0; i < 20; i += 2) {
        QR(ws, 0, 4, 8, 12);
        QR(ws, 1, 5, 9, 13);
        QR(ws, 2, 6, 10, 14);
        QR(ws, 3, 7, 11, 15);
        QR(ws, 0, 5, 10, 15);
        QR(ws, 1, 6, 11, 12);
        QR(ws, 2, 7, 8, 13);
        QR(ws, 3, 4, 9, 14);
      }
      for (let i = 0; i < 16; i++) {
        ws[i] += state[i];
      }
      return new Uint8Array(ws.buffer, ws.byteOffset, ws.byteLength);
    }
    function rotl(a, b) {
      return a << b | a >>> 32 - b;
    }
    function QR(obj, a, b, c, d) {
      obj[a] += obj[b];
      obj[d] ^= obj[a];
      obj[d] = rotl(obj[d], 16);
      obj[c] += obj[d];
      obj[b] ^= obj[c];
      obj[b] = rotl(obj[b], 12);
      obj[a] += obj[b];
      obj[d] ^= obj[a];
      obj[d] = rotl(obj[d], 8);
      obj[c] += obj[d];
      obj[b] ^= obj[c];
      obj[b] = rotl(obj[b], 7);
    }
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_stream_chacha20.js
var require_crypto_stream_chacha20 = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_stream_chacha20.js"(exports) {
    var assert = require_nanoassert();
    var Chacha20 = require_chacha20_universal();
    if (new Uint16Array([1])[0] !== 1) throw new Error("Big endian architecture is not supported.");
    exports.crypto_stream_chacha20_KEYBYTES = 32;
    exports.crypto_stream_chacha20_NONCEBYTES = 8;
    exports.crypto_stream_chacha20_MESSAGEBYTES_MAX = Number.MAX_SAFE_INTEGER;
    exports.crypto_stream_chacha20_ietf_KEYBYTES = 32;
    exports.crypto_stream_chacha20_ietf_NONCEBYTES = 12;
    exports.crypto_stream_chacha20_ietf_MESSAGEBYTES_MAX = 2 ** 32;
    exports.crypto_stream_chacha20 = function(c, n, k) {
      c.fill(0);
      exports.crypto_stream_chacha20_xor(c, c, n, k);
    };
    exports.crypto_stream_chacha20_xor = function(c, m, n, k) {
      assert(
        n.byteLength === exports.crypto_stream_chacha20_NONCEBYTES,
        "n should be crypto_stream_chacha20_NONCEBYTES"
      );
      assert(
        k.byteLength === exports.crypto_stream_chacha20_KEYBYTES,
        "k should be crypto_stream_chacha20_KEYBYTES"
      );
      const xor = new Chacha20(n, k);
      xor.update(c, m);
      xor.final();
    };
    exports.crypto_stream_chacha20_xor_ic = function(c, m, n, ic, k) {
      assert(
        n.byteLength === exports.crypto_stream_chacha20_NONCEBYTES,
        "n should be crypto_stream_chacha20_NONCEBYTES"
      );
      assert(
        k.byteLength === exports.crypto_stream_chacha20_KEYBYTES,
        "k should be crypto_stream_chacha20_KEYBYTES"
      );
      const xor = new Chacha20(n, k, ic);
      xor.update(c, m);
      xor.final();
    };
    exports.crypto_stream_chacha20_xor_instance = function(n, k) {
      assert(
        n.byteLength === exports.crypto_stream_chacha20_NONCEBYTES,
        "n should be crypto_stream_chacha20_NONCEBYTES"
      );
      assert(
        k.byteLength === exports.crypto_stream_chacha20_KEYBYTES,
        "k should be crypto_stream_chacha20_KEYBYTES"
      );
      return new Chacha20(n, k);
    };
    exports.crypto_stream_chacha20_ietf = function(c, n, k) {
      c.fill(0);
      exports.crypto_stream_chacha20_ietf_xor(c, c, n, k);
    };
    exports.crypto_stream_chacha20_ietf_xor = function(c, m, n, k) {
      assert(
        n.byteLength === exports.crypto_stream_chacha20_ietf_NONCEBYTES,
        "n should be crypto_stream_chacha20_ietf_NONCEBYTES"
      );
      assert(
        k.byteLength === exports.crypto_stream_chacha20_ietf_KEYBYTES,
        "k should be crypto_stream_chacha20_ietf_KEYBYTES"
      );
      const xor = new Chacha20(n, k);
      xor.update(c, m);
      xor.final();
    };
    exports.crypto_stream_chacha20_ietf_xor_ic = function(c, m, n, ic, k) {
      assert(
        n.byteLength === exports.crypto_stream_chacha20_ietf_NONCEBYTES,
        "n should be crypto_stream_chacha20_ietf_NONCEBYTES"
      );
      assert(
        k.byteLength === exports.crypto_stream_chacha20_ietf_KEYBYTES,
        "k should be crypto_stream_chacha20_ietf_KEYBYTES"
      );
      const xor = new Chacha20(n, k, ic);
      xor.update(c, m);
      xor.final();
    };
    exports.crypto_stream_chacha20_ietf_xor_instance = function(n, k) {
      assert(
        n.byteLength === exports.crypto_stream_chacha20_ietf_NONCEBYTES,
        "n should be crypto_stream_chacha20_ietf_NONCEBYTES"
      );
      assert(
        k.byteLength === exports.crypto_stream_chacha20_ietf_KEYBYTES,
        "k should be crypto_stream_chacha20_ietf_KEYBYTES"
      );
      return new Chacha20(n, k);
    };
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_aead.js
var require_crypto_aead = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_aead.js"(exports, module) {
    var { crypto_stream_chacha20_ietf, crypto_stream_chacha20_ietf_xor_ic } = require_crypto_stream_chacha20();
    var { crypto_verify_16 } = require_crypto_verify();
    var Poly1305 = require_poly1305();
    var assert = require_nanoassert();
    var crypto_aead_chacha20poly1305_ietf_KEYBYTES = 32;
    var crypto_aead_chacha20poly1305_ietf_NSECBYTES = 0;
    var crypto_aead_chacha20poly1305_ietf_NPUBBYTES = 12;
    var crypto_aead_chacha20poly1305_ietf_ABYTES = 16;
    var crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX = Number.MAX_SAFE_INTEGER;
    var _pad0 = new Uint8Array(16);
    function crypto_aead_chacha20poly1305_ietf_encrypt(c, m, ad, nsec, npub, k) {
      if (ad === null) return crypto_aead_chacha20poly1305_ietf_encrypt(c, m, new Uint8Array(0), nsec, npub, k);
      assert(
        c.byteLength === m.byteLength + crypto_aead_chacha20poly1305_ietf_ABYTES,
        "ciphertext should be 'crypto_aead_chacha20poly1305_ietf_ABYTES' longer than message"
      );
      assert(
        npub.byteLength === crypto_aead_chacha20poly1305_ietf_NPUBBYTES,
        "npub should be 'crypto_aead_chacha20poly1305_ietf_NPUBBYTES' long"
      );
      assert(
        k.byteLength === crypto_aead_chacha20poly1305_ietf_KEYBYTES,
        "k should be 'crypto_aead_chacha20poly1305_ietf_KEYBYTES' long"
      );
      assert(m.byteLength <= crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX, "message is too large");
      const ret = crypto_aead_chacha20poly1305_ietf_encrypt_detached(
        c.subarray(0, m.byteLength),
        c.subarray(m.byteLength),
        m,
        ad,
        nsec,
        npub,
        k
      );
      return m.byteLength + ret;
    }
    function crypto_aead_chacha20poly1305_ietf_encrypt_detached(c, mac, m, ad, nsec, npub, k) {
      if (ad === null) return crypto_aead_chacha20poly1305_ietf_encrypt_detached(c, mac, m, new Uint8Array(0), nsec, npub, k);
      assert(c.byteLength === m.byteLength, "ciphertext should be same length than message");
      assert(
        npub.byteLength === crypto_aead_chacha20poly1305_ietf_NPUBBYTES,
        "npub should be 'crypto_aead_chacha20poly1305_ietf_NPUBBYTES' long"
      );
      assert(
        k.byteLength === crypto_aead_chacha20poly1305_ietf_KEYBYTES,
        "k should be 'crypto_aead_chacha20poly1305_ietf_KEYBYTES' long"
      );
      assert(m.byteLength <= crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX, "message is too large");
      assert(
        mac.byteLength <= crypto_aead_chacha20poly1305_ietf_ABYTES,
        "mac should be 'crypto_aead_chacha20poly1305_ietf_ABYTES' long"
      );
      const block0 = new Uint8Array(64);
      var slen = new Uint8Array(8);
      crypto_stream_chacha20_ietf(block0, npub, k);
      const poly = new Poly1305(block0);
      block0.fill(0);
      poly.update(ad, 0, ad.byteLength);
      poly.update(_pad0, 0, 16 - ad.byteLength & 15);
      crypto_stream_chacha20_ietf_xor_ic(c, m, npub, 1, k);
      poly.update(c, 0, m.byteLength);
      poly.update(_pad0, 0, 16 - m.byteLength & 15);
      write64LE(slen, 0, ad.byteLength);
      poly.update(slen, 0, slen.byteLength);
      write64LE(slen, 0, m.byteLength);
      poly.update(slen, 0, slen.byteLength);
      poly.finish(mac, 0);
      slen.fill(0);
      return crypto_aead_chacha20poly1305_ietf_ABYTES;
    }
    function crypto_aead_chacha20poly1305_ietf_decrypt(m, nsec, c, ad, npub, k) {
      if (ad === null) return crypto_aead_chacha20poly1305_ietf_decrypt(m, nsec, c, new Uint8Array(0), npub, k);
      assert(
        m.byteLength === c.byteLength - crypto_aead_chacha20poly1305_ietf_ABYTES,
        "message should be 'crypto_aead_chacha20poly1305_ietf_ABYTES' shorter than ciphertext"
      );
      assert(
        npub.byteLength === crypto_aead_chacha20poly1305_ietf_NPUBBYTES,
        "npub should be 'crypto_aead_chacha20poly1305_ietf_NPUBBYTES' long"
      );
      assert(
        k.byteLength === crypto_aead_chacha20poly1305_ietf_KEYBYTES,
        "k should be 'crypto_aead_chacha20poly1305_ietf_KEYBYTES' long"
      );
      assert(m.byteLength <= crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX, "message is too large");
      if (c.byteLength < crypto_aead_chacha20poly1305_ietf_ABYTES) throw new Error("could not verify data");
      crypto_aead_chacha20poly1305_ietf_decrypt_detached(
        m,
        nsec,
        c.subarray(0, c.byteLength - crypto_aead_chacha20poly1305_ietf_ABYTES),
        c.subarray(c.byteLength - crypto_aead_chacha20poly1305_ietf_ABYTES),
        ad,
        npub,
        k
      );
      return c.byteLength - crypto_aead_chacha20poly1305_ietf_ABYTES;
    }
    function crypto_aead_chacha20poly1305_ietf_decrypt_detached(m, nsec, c, mac, ad, npub, k) {
      if (ad === null) return crypto_aead_chacha20poly1305_ietf_decrypt_detached(m, nsec, c, mac, new Uint8Array(0), npub, k);
      assert(c.byteLength === m.byteLength, "message should be same length than ciphertext");
      assert(
        npub.byteLength === crypto_aead_chacha20poly1305_ietf_NPUBBYTES,
        "npub should be 'crypto_aead_chacha20poly1305_ietf_NPUBBYTES' long"
      );
      assert(
        k.byteLength === crypto_aead_chacha20poly1305_ietf_KEYBYTES,
        "k should be 'crypto_aead_chacha20poly1305_ietf_KEYBYTES' long"
      );
      assert(m.byteLength <= crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX, "message is too large");
      assert(
        mac.byteLength <= crypto_aead_chacha20poly1305_ietf_ABYTES,
        "mac should be 'crypto_aead_chacha20poly1305_ietf_ABYTES' long"
      );
      const block0 = new Uint8Array(64);
      const slen = new Uint8Array(8);
      const computed_mac = new Uint8Array(crypto_aead_chacha20poly1305_ietf_ABYTES);
      crypto_stream_chacha20_ietf(block0, npub, k);
      const poly = new Poly1305(block0);
      block0.fill(0);
      poly.update(ad, 0, ad.byteLength);
      poly.update(_pad0, 0, 16 - ad.byteLength & 15);
      const mlen = c.byteLength;
      poly.update(c, 0, mlen);
      poly.update(_pad0, 0, 16 - mlen & 15);
      write64LE(slen, 0, ad.byteLength);
      poly.update(slen, 0, slen.byteLength);
      write64LE(slen, 0, mlen);
      poly.update(slen, 0, slen.byteLength);
      poly.finish(computed_mac, 0);
      assert(computed_mac.byteLength === 16);
      const ret = crypto_verify_16(computed_mac, 0, mac, 0);
      computed_mac.fill(0);
      slen.fill(0);
      if (!ret) {
        m.fill(0);
        throw new Error("could not verify data");
      }
      crypto_stream_chacha20_ietf_xor_ic(m, c, npub, 1, k);
    }
    function write64LE(buf, offset, int) {
      buf.fill(0, 0, 8);
      const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
      view.setUint32(offset, int & 4294967295, true);
      view.setUint32(offset + 4, int / 2 ** 32 & 4294967295, true);
    }
    module.exports = {
      crypto_aead_chacha20poly1305_ietf_encrypt,
      crypto_aead_chacha20poly1305_ietf_encrypt_detached,
      crypto_aead_chacha20poly1305_ietf_decrypt,
      crypto_aead_chacha20poly1305_ietf_decrypt_detached,
      crypto_aead_chacha20poly1305_ietf_ABYTES,
      crypto_aead_chacha20poly1305_ietf_KEYBYTES,
      crypto_aead_chacha20poly1305_ietf_NPUBBYTES,
      crypto_aead_chacha20poly1305_ietf_NSECBYTES,
      crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX
    };
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/internal/hchacha20.js
var require_hchacha20 = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/internal/hchacha20.js"(exports, module) {
    var { sodium_malloc } = require_memory();
    var assert = require_nanoassert();
    if (new Uint16Array([1])[0] !== 1) throw new Error("Big endian architecture is not supported.");
    var crypto_core_hchacha20_OUTPUTBYTES = 32;
    var crypto_core_hchacha20_INPUTBYTES = 16;
    var crypto_core_hchacha20_KEYBYTES = 32;
    var crypto_core_hchacha20_CONSTBYTES = 16;
    function ROTL32(x, b) {
      x &= 4294967295;
      b &= 4294967295;
      return x << b | x >>> 32 - b;
    }
    function LOAD32_LE(src, offset) {
      assert(src instanceof Uint8Array, "src not byte array");
      let w = src[offset];
      w |= src[offset + 1] << 8;
      w |= src[offset + 2] << 16;
      w |= src[offset + 3] << 24;
      return w;
    }
    function STORE32_LE(dest, int, offset) {
      assert(dest instanceof Uint8Array, "dest not byte array");
      var mul = 1;
      var i = 0;
      dest[offset] = int & 255;
      while (++i < 4 && (mul *= 256)) {
        dest[offset + i] = int / mul & 255;
      }
    }
    function QUARTERROUND(l, A, B, C, D) {
      l[A] += l[B];
      l[D] = ROTL32(l[D] ^ l[A], 16);
      l[C] += l[D];
      l[B] = ROTL32(l[B] ^ l[C], 12);
      l[A] += l[B];
      l[D] = ROTL32(l[D] ^ l[A], 8);
      l[C] += l[D];
      l[B] = ROTL32(l[B] ^ l[C], 7);
    }
    function crypto_core_hchacha20(out, _in, k, c) {
      assert(out instanceof Uint8Array && out.length === 32, "out is not an array of 32 bytes");
      assert(k instanceof Uint8Array && k.length === 32, "k is not an array of 32 bytes");
      assert(c === null || c instanceof Uint8Array && c.length === 16, "c is not null or an array of 16 bytes");
      let i = 0;
      const x = new Uint32Array(16);
      if (!c) {
        x[0] = 1634760805;
        x[1] = 857760878;
        x[2] = 2036477234;
        x[3] = 1797285236;
      } else {
        x[0] = LOAD32_LE(c, 0);
        x[1] = LOAD32_LE(c, 4);
        x[2] = LOAD32_LE(c, 8);
        x[3] = LOAD32_LE(c, 12);
      }
      x[4] = LOAD32_LE(k, 0);
      x[5] = LOAD32_LE(k, 4);
      x[6] = LOAD32_LE(k, 8);
      x[7] = LOAD32_LE(k, 12);
      x[8] = LOAD32_LE(k, 16);
      x[9] = LOAD32_LE(k, 20);
      x[10] = LOAD32_LE(k, 24);
      x[11] = LOAD32_LE(k, 28);
      x[12] = LOAD32_LE(_in, 0);
      x[13] = LOAD32_LE(_in, 4);
      x[14] = LOAD32_LE(_in, 8);
      x[15] = LOAD32_LE(_in, 12);
      for (i = 0; i < 10; i++) {
        QUARTERROUND(x, 0, 4, 8, 12);
        QUARTERROUND(x, 1, 5, 9, 13);
        QUARTERROUND(x, 2, 6, 10, 14);
        QUARTERROUND(x, 3, 7, 11, 15);
        QUARTERROUND(x, 0, 5, 10, 15);
        QUARTERROUND(x, 1, 6, 11, 12);
        QUARTERROUND(x, 2, 7, 8, 13);
        QUARTERROUND(x, 3, 4, 9, 14);
      }
      STORE32_LE(out, x[0], 0);
      STORE32_LE(out, x[1], 4);
      STORE32_LE(out, x[2], 8);
      STORE32_LE(out, x[3], 12);
      STORE32_LE(out, x[12], 16);
      STORE32_LE(out, x[13], 20);
      STORE32_LE(out, x[14], 24);
      STORE32_LE(out, x[15], 28);
      return 0;
    }
    function crypto_core_hchacha20_outputbytes() {
      return crypto_core_hchacha20_OUTPUTBYTES;
    }
    function crypto_core_hchacha20_inputbytes() {
      return crypto_core_hchacha20_INPUTBYTES;
    }
    function crypto_core_hchacha20_keybytes() {
      return crypto_core_hchacha20_KEYBYTES;
    }
    function crypto_core_hchacha20_constbytes() {
      return crypto_core_hchacha20_CONSTBYTES;
    }
    module.exports = {
      crypto_core_hchacha20_INPUTBYTES,
      LOAD32_LE,
      STORE32_LE,
      QUARTERROUND,
      crypto_core_hchacha20,
      crypto_core_hchacha20_outputbytes,
      crypto_core_hchacha20_inputbytes,
      crypto_core_hchacha20_keybytes,
      crypto_core_hchacha20_constbytes
    };
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_secretstream.js
var require_crypto_secretstream = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_secretstream.js"(exports, module) {
    var assert = require_nanoassert();
    var { randombytes_buf } = require_randombytes();
    var {
      crypto_stream_chacha20_ietf,
      crypto_stream_chacha20_ietf_xor,
      crypto_stream_chacha20_ietf_xor_ic,
      crypto_stream_chacha20_ietf_KEYBYTES
    } = require_crypto_stream_chacha20();
    var { crypto_core_hchacha20, crypto_core_hchacha20_INPUTBYTES } = require_hchacha20();
    var Poly1305 = require_poly1305();
    var { sodium_increment, sodium_is_zero, sodium_memcmp } = require_helpers();
    var crypto_onetimeauth_poly1305_BYTES = 16;
    var crypto_secretstream_xchacha20poly1305_COUNTERBYTES = 4;
    var crypto_secretstream_xchacha20poly1305_INONCEBYTES = 8;
    var crypto_aead_xchacha20poly1305_ietf_KEYBYTES = 32;
    var crypto_secretstream_xchacha20poly1305_KEYBYTES = crypto_aead_xchacha20poly1305_ietf_KEYBYTES;
    var crypto_aead_xchacha20poly1305_ietf_NPUBBYTES = 24;
    var crypto_secretstream_xchacha20poly1305_HEADERBYTES = crypto_aead_xchacha20poly1305_ietf_NPUBBYTES;
    var crypto_aead_xchacha20poly1305_ietf_ABYTES = 16;
    var crypto_secretstream_xchacha20poly1305_ABYTES = 1 + crypto_aead_xchacha20poly1305_ietf_ABYTES;
    var crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX = Number.MAX_SAFE_INTEGER;
    var crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX = Number.MAX_SAFE_INTEGER;
    var crypto_secretstream_xchacha20poly1305_TAGBYTES = 1;
    var crypto_secretstream_xchacha20poly1305_TAG_MESSAGE = new Uint8Array([0]);
    var crypto_secretstream_xchacha20poly1305_TAG_PUSH = new Uint8Array([1]);
    var crypto_secretstream_xchacha20poly1305_TAG_REKEY = new Uint8Array([2]);
    var crypto_secretstream_xchacha20poly1305_TAG_FINAL = new Uint8Array([crypto_secretstream_xchacha20poly1305_TAG_PUSH | crypto_secretstream_xchacha20poly1305_TAG_REKEY]);
    var crypto_secretstream_xchacha20poly1305_STATEBYTES = crypto_secretstream_xchacha20poly1305_KEYBYTES + crypto_secretstream_xchacha20poly1305_INONCEBYTES + crypto_secretstream_xchacha20poly1305_COUNTERBYTES + 8;
    var KEY_OFFSET = 0;
    var NONCE_OFFSET = crypto_secretstream_xchacha20poly1305_KEYBYTES;
    var PAD_OFFSET = NONCE_OFFSET + crypto_secretstream_xchacha20poly1305_INONCEBYTES + crypto_secretstream_xchacha20poly1305_COUNTERBYTES;
    var _pad0 = new Uint8Array(16);
    function STORE64_LE(dest, int) {
      let mul = 1;
      let i = 0;
      dest[0] = int & 255;
      while (++i < 8 && (mul *= 256)) {
        dest[i] = int / mul & 255;
      }
    }
    function crypto_secretstream_xchacha20poly1305_counter_reset(state) {
      assert(
        state.byteLength === crypto_secretstream_xchacha20poly1305_STATEBYTES,
        "state is should be crypto_secretstream_xchacha20poly1305_STATEBYTES long"
      );
      const nonce = state.subarray(NONCE_OFFSET, PAD_OFFSET);
      for (let i = 0; i < crypto_secretstream_xchacha20poly1305_COUNTERBYTES; i++) {
        nonce[i] = 0;
      }
      nonce[0] = 1;
    }
    function crypto_secretstream_xchacha20poly1305_keygen(k) {
      assert(k.length === crypto_secretstream_xchacha20poly1305_KEYBYTES);
      randombytes_buf(k);
    }
    function crypto_secretstream_xchacha20poly1305_init_push(state, out, key) {
      assert(
        state.byteLength === crypto_secretstream_xchacha20poly1305_STATEBYTES,
        "state is should be crypto_secretstream_xchacha20poly1305_STATEBYTES long"
      );
      assert(out instanceof Uint8Array && out.length === crypto_secretstream_xchacha20poly1305_HEADERBYTES, "out not byte array of length crypto_secretstream_xchacha20poly1305_HEADERBYTES");
      assert(key instanceof Uint8Array && key.length === crypto_secretstream_xchacha20poly1305_KEYBYTES, "key not byte array of length crypto_secretstream_xchacha20poly1305_KEYBYTES");
      const k = state.subarray(KEY_OFFSET, NONCE_OFFSET);
      const nonce = state.subarray(NONCE_OFFSET, PAD_OFFSET);
      const pad = state.subarray(PAD_OFFSET);
      randombytes_buf(out, crypto_secretstream_xchacha20poly1305_HEADERBYTES);
      crypto_core_hchacha20(k, out, key, null);
      crypto_secretstream_xchacha20poly1305_counter_reset(state);
      for (let i = 0; i < crypto_secretstream_xchacha20poly1305_INONCEBYTES; i++) {
        nonce[i + crypto_secretstream_xchacha20poly1305_COUNTERBYTES] = out[i + crypto_core_hchacha20_INPUTBYTES];
      }
      pad.fill(0);
    }
    function crypto_secretstream_xchacha20poly1305_init_pull(state, _in, key) {
      assert(
        state.byteLength === crypto_secretstream_xchacha20poly1305_STATEBYTES,
        "state is should be crypto_secretstream_xchacha20poly1305_STATEBYTES long"
      );
      assert(
        _in instanceof Uint8Array && _in.length === crypto_secretstream_xchacha20poly1305_HEADERBYTES,
        "_in not byte array of length crypto_secretstream_xchacha20poly1305_HEADERBYTES"
      );
      assert(
        key instanceof Uint8Array && key.length === crypto_secretstream_xchacha20poly1305_KEYBYTES,
        "key not byte array of length crypto_secretstream_xchacha20poly1305_KEYBYTES"
      );
      const k = state.subarray(KEY_OFFSET, NONCE_OFFSET);
      const nonce = state.subarray(NONCE_OFFSET, PAD_OFFSET);
      const pad = state.subarray(PAD_OFFSET);
      crypto_core_hchacha20(k, _in, key, null);
      crypto_secretstream_xchacha20poly1305_counter_reset(state);
      for (let i = 0; i < crypto_secretstream_xchacha20poly1305_INONCEBYTES; i++) {
        nonce[i + crypto_secretstream_xchacha20poly1305_COUNTERBYTES] = _in[i + crypto_core_hchacha20_INPUTBYTES];
      }
      pad.fill(0);
    }
    function crypto_secretstream_xchacha20poly1305_rekey(state) {
      assert(
        state.byteLength === crypto_secretstream_xchacha20poly1305_STATEBYTES,
        "state is should be crypto_secretstream_xchacha20poly1305_STATEBYTES long"
      );
      const k = state.subarray(KEY_OFFSET, NONCE_OFFSET);
      const nonce = state.subarray(NONCE_OFFSET, PAD_OFFSET);
      const new_key_and_inonce = new Uint8Array(
        crypto_stream_chacha20_ietf_KEYBYTES + crypto_secretstream_xchacha20poly1305_INONCEBYTES
      );
      let i;
      for (i = 0; i < crypto_stream_chacha20_ietf_KEYBYTES; i++) {
        new_key_and_inonce[i] = k[i];
      }
      for (i = 0; i < crypto_secretstream_xchacha20poly1305_INONCEBYTES; i++) {
        new_key_and_inonce[crypto_stream_chacha20_ietf_KEYBYTES + i] = nonce[crypto_secretstream_xchacha20poly1305_COUNTERBYTES + i];
      }
      crypto_stream_chacha20_ietf_xor(new_key_and_inonce, new_key_and_inonce, nonce, k);
      for (i = 0; i < crypto_stream_chacha20_ietf_KEYBYTES; i++) {
        k[i] = new_key_and_inonce[i];
      }
      for (i = 0; i < crypto_secretstream_xchacha20poly1305_INONCEBYTES; i++) {
        nonce[crypto_secretstream_xchacha20poly1305_COUNTERBYTES + i] = new_key_and_inonce[crypto_stream_chacha20_ietf_KEYBYTES + i];
      }
      crypto_secretstream_xchacha20poly1305_counter_reset(state);
    }
    function crypto_secretstream_xchacha20poly1305_push(state, out, m, ad, tag) {
      assert(
        state.byteLength === crypto_secretstream_xchacha20poly1305_STATEBYTES,
        "state is should be crypto_secretstream_xchacha20poly1305_STATEBYTES long"
      );
      if (!ad) ad = new Uint8Array(0);
      const k = state.subarray(KEY_OFFSET, NONCE_OFFSET);
      const nonce = state.subarray(NONCE_OFFSET, PAD_OFFSET);
      const block = new Uint8Array(64);
      const slen = new Uint8Array(8);
      assert(crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX <= crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX);
      crypto_stream_chacha20_ietf(block, nonce, k);
      const poly = new Poly1305(block);
      block.fill(0);
      poly.update(ad, 0, ad.byteLength);
      poly.update(_pad0, 0, 16 - ad.byteLength & 15);
      block[0] = tag[0];
      crypto_stream_chacha20_ietf_xor_ic(block, block, nonce, 1, k);
      poly.update(block, 0, block.byteLength);
      out[0] = block[0];
      const c = out.subarray(1, out.byteLength);
      crypto_stream_chacha20_ietf_xor_ic(c, m, nonce, 2, k);
      poly.update(c, 0, m.byteLength);
      poly.update(_pad0, 0, 16 - block.byteLength + m.byteLength & 15);
      STORE64_LE(slen, ad.byteLength);
      poly.update(slen, 0, slen.byteLength);
      STORE64_LE(slen, block.byteLength + m.byteLength);
      poly.update(slen, 0, slen.byteLength);
      const mac = out.subarray(1 + m.byteLength, out.byteLength);
      poly.finish(mac, 0);
      assert(crypto_onetimeauth_poly1305_BYTES >= crypto_secretstream_xchacha20poly1305_INONCEBYTES);
      xor_buf(
        nonce.subarray(crypto_secretstream_xchacha20poly1305_COUNTERBYTES, nonce.length),
        mac,
        crypto_secretstream_xchacha20poly1305_INONCEBYTES
      );
      sodium_increment(nonce);
      if ((tag[0] & crypto_secretstream_xchacha20poly1305_TAG_REKEY) !== 0 || sodium_is_zero(nonce.subarray(0, crypto_secretstream_xchacha20poly1305_COUNTERBYTES))) {
        crypto_secretstream_xchacha20poly1305_rekey(state);
      }
      return crypto_secretstream_xchacha20poly1305_ABYTES + m.byteLength;
    }
    function crypto_secretstream_xchacha20poly1305_pull(state, m, tag, _in, ad) {
      assert(
        state.byteLength === crypto_secretstream_xchacha20poly1305_STATEBYTES,
        "state is should be crypto_secretstream_xchacha20poly1305_STATEBYTES long"
      );
      if (!ad) ad = new Uint8Array(0);
      const k = state.subarray(KEY_OFFSET, NONCE_OFFSET);
      const nonce = state.subarray(NONCE_OFFSET, PAD_OFFSET);
      const block = new Uint8Array(64);
      const slen = new Uint8Array(8);
      const mac = new Uint8Array(crypto_onetimeauth_poly1305_BYTES);
      assert(
        _in.byteLength >= crypto_secretstream_xchacha20poly1305_ABYTES,
        "ciphertext is too short."
      );
      const mlen = _in.byteLength - crypto_secretstream_xchacha20poly1305_ABYTES;
      crypto_stream_chacha20_ietf(block, nonce, k);
      const poly = new Poly1305(block);
      block.fill(0);
      poly.update(ad, 0, ad.byteLength);
      poly.update(_pad0, 0, 16 - ad.byteLength & 15);
      block.fill(0);
      block[0] = _in[0];
      crypto_stream_chacha20_ietf_xor_ic(block, block, nonce, 1, k);
      tag[0] = block[0];
      block[0] = _in[0];
      poly.update(block, 0, block.byteLength);
      const c = _in.subarray(1, _in.length);
      poly.update(c, 0, mlen);
      poly.update(_pad0, 0, 16 - block.byteLength + mlen & 15);
      STORE64_LE(slen, ad.byteLength);
      poly.update(slen, 0, slen.byteLength);
      STORE64_LE(slen, block.byteLength + m.byteLength);
      poly.update(slen, 0, slen.byteLength);
      poly.finish(mac, 0);
      const stored_mac = _in.subarray(1 + mlen, _in.length);
      if (!sodium_memcmp(mac, stored_mac)) {
        mac.fill(0);
        throw new Error("MAC could not be verified.");
      }
      crypto_stream_chacha20_ietf_xor_ic(m, c.subarray(0, m.length), nonce, 2, k);
      xor_buf(
        nonce.subarray(crypto_secretstream_xchacha20poly1305_COUNTERBYTES, nonce.length),
        mac,
        crypto_secretstream_xchacha20poly1305_INONCEBYTES
      );
      sodium_increment(nonce);
      if ((tag & crypto_secretstream_xchacha20poly1305_TAG_REKEY) !== 0 || sodium_is_zero(nonce.subarray(0, crypto_secretstream_xchacha20poly1305_COUNTERBYTES))) {
        crypto_secretstream_xchacha20poly1305_rekey(state);
      }
      return mlen;
    }
    function xor_buf(out, _in, n) {
      for (let i = 0; i < n; i++) {
        out[i] ^= _in[i];
      }
    }
    module.exports = {
      crypto_secretstream_xchacha20poly1305_keygen,
      crypto_secretstream_xchacha20poly1305_init_push,
      crypto_secretstream_xchacha20poly1305_init_pull,
      crypto_secretstream_xchacha20poly1305_rekey,
      crypto_secretstream_xchacha20poly1305_push,
      crypto_secretstream_xchacha20poly1305_pull,
      crypto_secretstream_xchacha20poly1305_STATEBYTES,
      crypto_secretstream_xchacha20poly1305_ABYTES,
      crypto_secretstream_xchacha20poly1305_HEADERBYTES,
      crypto_secretstream_xchacha20poly1305_KEYBYTES,
      crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX,
      crypto_secretstream_xchacha20poly1305_TAGBYTES,
      crypto_secretstream_xchacha20poly1305_TAG_MESSAGE,
      crypto_secretstream_xchacha20poly1305_TAG_PUSH,
      crypto_secretstream_xchacha20poly1305_TAG_REKEY,
      crypto_secretstream_xchacha20poly1305_TAG_FINAL
    };
  }
});

// ../../node_modules/.pnpm/siphash24@1.3.1/node_modules/siphash24/siphash24.js
var require_siphash24 = __commonJS({
  "../../node_modules/.pnpm/siphash24@1.3.1/node_modules/siphash24/siphash24.js"(exports, module) {
    var __commonJS2 = (cb, mod) => function __require2() {
      return mod || (0, cb[Object.keys(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
    };
    var __toBinary = /* @__PURE__ */ (() => {
      var table = new Uint8Array(128);
      for (var i = 0; i < 64; i++)
        table[i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i * 4 - 205] = i;
      return (base64) => {
        var n = base64.length, bytes2 = new Uint8Array((n - (base64[n - 1] == "=") - (base64[n - 2] == "=")) * 3 / 4 | 0);
        for (var i2 = 0, j = 0; i2 < n; ) {
          var c0 = table[base64.charCodeAt(i2++)], c1 = table[base64.charCodeAt(i2++)];
          var c2 = table[base64.charCodeAt(i2++)], c3 = table[base64.charCodeAt(i2++)];
          bytes2[j++] = c0 << 2 | c1 >> 4;
          bytes2[j++] = c1 << 4 | c2 >> 2;
          bytes2[j++] = c2 << 6 | c3;
        }
        return bytes2;
      };
    })();
    var require_siphash243 = __commonJS2({
      "wasm-binary:./siphash24.wat"(exports2, module2) {
        module2.exports = __toBinary("AGFzbQEAAAABBgFgAn9/AAMCAQAFBQEBCpBOBxQCBm1lbW9yeQIAB3NpcGhhc2gAAArdCAHaCAIIfgJ/QvXKzYPXrNu38wAhAkLt3pHzlszct+QAIQNC4eSV89bs2bzsACEEQvPK0cunjNmy9AAhBUEIKQMAIQdBECkDACEIIAGtQjiGIQYgAUEHcSELIAAgAWogC2shCiAFIAiFIQUgBCAHhSEEIAMgCIUhAyACIAeFIQICQANAIAAgCkYNASAAKQMAIQkgBSAJhSEFIAIgA3whAiADQg2JIQMgAyAChSEDIAJCIIkhAiAEIAV8IQQgBUIQiSEFIAUgBIUhBSACIAV8IQIgBUIViSEFIAUgAoUhBSAEIAN8IQQgA0IRiSEDIAMgBIUhAyAEQiCJIQQgAiADfCECIANCDYkhAyADIAKFIQMgAkIgiSECIAQgBXwhBCAFQhCJIQUgBSAEhSEFIAIgBXwhAiAFQhWJIQUgBSAChSEFIAQgA3whBCADQhGJIQMgAyAEhSEDIARCIIkhBCACIAmFIQIgAEEIaiEADAALCwJAAkACQAJAAkACQAJAAkAgCw4HBwYFBAMCAQALIAYgADEABkIwhoQhBgsgBiAAMQAFQiiGhCEGCyAGIAAxAARCIIaEIQYLIAYgADEAA0IYhoQhBgsgBiAAMQACQhCGhCEGCyAGIAAxAAFCCIaEIQYLIAYgADEAAIQhBgsgBSAGhSEFIAIgA3whAiADQg2JIQMgAyAChSEDIAJCIIkhAiAEIAV8IQQgBUIQiSEFIAUgBIUhBSACIAV8IQIgBUIViSEFIAUgAoUhBSAEIAN8IQQgA0IRiSEDIAMgBIUhAyAEQiCJIQQgAiADfCECIANCDYkhAyADIAKFIQMgAkIgiSECIAQgBXwhBCAFQhCJIQUgBSAEhSEFIAIgBXwhAiAFQhWJIQUgBSAChSEFIAQgA3whBCADQhGJIQMgAyAEhSEDIARCIIkhBCACIAaFIQIgBEL/AYUhBCACIAN8IQIgA0INiSEDIAMgAoUhAyACQiCJIQIgBCAFfCEEIAVCEIkhBSAFIASFIQUgAiAFfCECIAVCFYkhBSAFIAKFIQUgBCADfCEEIANCEYkhAyADIASFIQMgBEIgiSEEIAIgA3whAiADQg2JIQMgAyAChSEDIAJCIIkhAiAEIAV8IQQgBUIQiSEFIAUgBIUhBSACIAV8IQIgBUIViSEFIAUgAoUhBSAEIAN8IQQgA0IRiSEDIAMgBIUhAyAEQiCJIQQgAiADfCECIANCDYkhAyADIAKFIQMgAkIgiSECIAQgBXwhBCAFQhCJIQUgBSAEhSEFIAIgBXwhAiAFQhWJIQUgBSAChSEFIAQgA3whBCADQhGJIQMgAyAEhSEDIARCIIkhBCACIAN8IQIgA0INiSEDIAMgAoUhAyACQiCJIQIgBCAFfCEEIAVCEIkhBSAFIASFIQUgAiAFfCECIAVCFYkhBSAFIAKFIQUgBCADfCEEIANCEYkhAyADIASFIQMgBEIgiSEEQQAgAiADIAQgBYWFhTcDAAs=");
      }
    });
    var bytes = require_siphash243();
    var compiled = new WebAssembly.Module(bytes);
    module.exports = (imports) => {
      const instance = new WebAssembly.Instance(compiled, imports);
      return instance.exports;
    };
  }
});

// ../../node_modules/.pnpm/siphash24@1.3.1/node_modules/siphash24/fallback.js
var require_fallback = __commonJS({
  "../../node_modules/.pnpm/siphash24@1.3.1/node_modules/siphash24/fallback.js"(exports, module) {
    module.exports = fallback;
    function _add(a, b) {
      var rl = a.l + b.l;
      var a2 = {
        h: a.h + b.h + (rl / 2 >>> 31) >>> 0,
        l: rl >>> 0
      };
      a.h = a2.h;
      a.l = a2.l;
    }
    function _xor(a, b) {
      a.h ^= b.h;
      a.h >>>= 0;
      a.l ^= b.l;
      a.l >>>= 0;
    }
    function _rotl(a, n) {
      var a2 = {
        h: a.h << n | a.l >>> 32 - n,
        l: a.l << n | a.h >>> 32 - n
      };
      a.h = a2.h;
      a.l = a2.l;
    }
    function _rotl32(a) {
      var al = a.l;
      a.l = a.h;
      a.h = al;
    }
    function _compress(v0, v1, v2, v3) {
      _add(v0, v1);
      _add(v2, v3);
      _rotl(v1, 13);
      _rotl(v3, 16);
      _xor(v1, v0);
      _xor(v3, v2);
      _rotl32(v0);
      _add(v2, v1);
      _add(v0, v3);
      _rotl(v1, 17);
      _rotl(v3, 21);
      _xor(v1, v2);
      _xor(v3, v0);
      _rotl32(v2);
    }
    function _get_int(a, offset) {
      return a[offset + 3] << 24 | a[offset + 2] << 16 | a[offset + 1] << 8 | a[offset];
    }
    function fallback(out, m, key) {
      var k0 = { h: _get_int(key, 4), l: _get_int(key, 0) };
      var k1 = { h: _get_int(key, 12), l: _get_int(key, 8) };
      var v0 = { h: k0.h, l: k0.l };
      var v2 = k0;
      var v1 = { h: k1.h, l: k1.l };
      var v3 = k1;
      var mi;
      var mp = 0;
      var ml = m.length;
      var ml7 = ml - 7;
      var buf = new Uint8Array(new ArrayBuffer(8));
      _xor(v0, { h: 1936682341, l: 1886610805 });
      _xor(v1, { h: 1685025377, l: 1852075885 });
      _xor(v2, { h: 1819895653, l: 1852142177 });
      _xor(v3, { h: 1952801890, l: 2037671283 });
      while (mp < ml7) {
        mi = { h: _get_int(m, mp + 4), l: _get_int(m, mp) };
        _xor(v3, mi);
        _compress(v0, v1, v2, v3);
        _compress(v0, v1, v2, v3);
        _xor(v0, mi);
        mp += 8;
      }
      buf[7] = ml;
      var ic = 0;
      while (mp < ml) {
        buf[ic++] = m[mp++];
      }
      while (ic < 7) {
        buf[ic++] = 0;
      }
      mi = {
        h: buf[7] << 24 | buf[6] << 16 | buf[5] << 8 | buf[4],
        l: buf[3] << 24 | buf[2] << 16 | buf[1] << 8 | buf[0]
      };
      _xor(v3, mi);
      _compress(v0, v1, v2, v3);
      _compress(v0, v1, v2, v3);
      _xor(v0, mi);
      _xor(v2, { h: 0, l: 255 });
      _compress(v0, v1, v2, v3);
      _compress(v0, v1, v2, v3);
      _compress(v0, v1, v2, v3);
      _compress(v0, v1, v2, v3);
      var h = v0;
      _xor(h, v1);
      _xor(h, v2);
      _xor(h, v3);
      out[0] = h.l & 255;
      out[1] = h.l >> 8 & 255;
      out[2] = h.l >> 16 & 255;
      out[3] = h.l >> 24 & 255;
      out[4] = h.h & 255;
      out[5] = h.h >> 8 & 255;
      out[6] = h.h >> 16 & 255;
      out[7] = h.h >> 24 & 255;
    }
  }
});

// ../../node_modules/.pnpm/siphash24@1.3.1/node_modules/siphash24/index.js
var require_siphash242 = __commonJS({
  "../../node_modules/.pnpm/siphash24@1.3.1/node_modules/siphash24/index.js"(exports, module) {
    var assert = require_nanoassert();
    var wasm = typeof WebAssembly !== "undefined" && require_siphash24()();
    var fallback = require_fallback();
    module.exports = siphash24;
    var BYTES = siphash24.BYTES = 8;
    var KEYBYTES = siphash24.KEYBYTES = 16;
    siphash24.WASM_SUPPORTED = !!wasm;
    siphash24.WASM_LOADED = !!wasm;
    var memory = new Uint8Array(wasm ? wasm.memory.buffer : 0);
    function siphash24(data, key, out, noAssert) {
      if (!out) out = new Uint8Array(8);
      if (noAssert !== true) {
        assert(out.length >= BYTES, "output must be at least " + BYTES);
        assert(key.length >= KEYBYTES, "key must be at least " + KEYBYTES);
      }
      if (wasm) {
        if (data.length + 24 > memory.length) realloc(data.length + 24);
        memory.set(key, 8);
        memory.set(data, 24);
        wasm.siphash(24, data.length);
        out.set(memory.subarray(0, 8));
      } else {
        fallback(out, data, key);
      }
      return out;
    }
    function realloc(size) {
      wasm.memory.grow(Math.max(0, Math.ceil(Math.abs(size - memory.length) / 65536)));
      memory = new Uint8Array(wasm.memory.buffer);
    }
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_shorthash.js
var require_crypto_shorthash = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_shorthash.js"(exports) {
    var siphash = require_siphash242();
    if (new Uint16Array([1])[0] !== 1) throw new Error("Big endian architecture is not supported.");
    exports.crypto_shorthash_PRIMITIVE = "siphash24";
    exports.crypto_shorthash_BYTES = siphash.BYTES;
    exports.crypto_shorthash_KEYBYTES = siphash.KEYBYTES;
    exports.crypto_shorthash_WASM_SUPPORTED = siphash.WASM_SUPPORTED;
    exports.crypto_shorthash_WASM_LOADED = siphash.WASM_LOADED;
    exports.crypto_shorthash = shorthash;
    function shorthash(out, data, key, noAssert) {
      siphash(data, key, out, noAssert);
    }
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_sign.js
var require_crypto_sign = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/crypto_sign.js"(exports, module) {
    var { crypto_verify_32 } = require_crypto_verify();
    var { crypto_hash } = require_crypto_hash();
    var {
      gf,
      gf0,
      gf1,
      D,
      D2,
      X,
      Y,
      I,
      A,
      Z,
      M,
      S,
      sel25519,
      pack25519,
      inv25519,
      unpack25519
    } = require_ed25519();
    var { randombytes } = require_randombytes();
    var { crypto_scalarmult_BYTES } = require_crypto_scalarmult();
    var { crypto_hash_sha512_BYTES } = require_crypto_hash();
    var assert = require_nanoassert();
    var crypto_sign_ed25519_PUBLICKEYBYTES = 32;
    var crypto_sign_ed25519_SECRETKEYBYTES = 64;
    var crypto_sign_ed25519_SEEDBYTES = 32;
    var crypto_sign_ed25519_BYTES = 64;
    var crypto_sign_BYTES = crypto_sign_ed25519_BYTES;
    var crypto_sign_PUBLICKEYBYTES = crypto_sign_ed25519_PUBLICKEYBYTES;
    var crypto_sign_SECRETKEYBYTES = crypto_sign_ed25519_SECRETKEYBYTES;
    var crypto_sign_SEEDBYTES = crypto_sign_ed25519_SEEDBYTES;
    module.exports = {
      crypto_sign_keypair,
      crypto_sign_seed_keypair,
      crypto_sign,
      crypto_sign_detached,
      crypto_sign_open,
      crypto_sign_verify_detached,
      crypto_sign_BYTES,
      crypto_sign_PUBLICKEYBYTES,
      crypto_sign_SECRETKEYBYTES,
      crypto_sign_SEEDBYTES,
      crypto_sign_ed25519_PUBLICKEYBYTES,
      crypto_sign_ed25519_SECRETKEYBYTES,
      crypto_sign_ed25519_SEEDBYTES,
      crypto_sign_ed25519_BYTES,
      crypto_sign_ed25519_pk_to_curve25519,
      crypto_sign_ed25519_sk_to_curve25519,
      crypto_sign_ed25519_sk_to_pk,
      unpackneg,
      pack
    };
    function set25519(r, a) {
      for (let i = 0; i < 16; i++) r[i] = a[i] | 0;
    }
    function pow2523(o, i) {
      var c = gf();
      var a;
      for (a = 0; a < 16; a++) c[a] = i[a];
      for (a = 250; a >= 0; a--) {
        S(c, c);
        if (a !== 1) M(c, c, i);
      }
      for (a = 0; a < 16; a++) o[a] = c[a];
    }
    function add(p, q) {
      var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf(), g = gf(), h = gf(), t = gf();
      Z(a, p[1], p[0]);
      Z(t, q[1], q[0]);
      M(a, a, t);
      A(b, p[0], p[1]);
      A(t, q[0], q[1]);
      M(b, b, t);
      M(c, p[3], q[3]);
      M(c, c, D2);
      M(d, p[2], q[2]);
      A(d, d, d);
      Z(e, b, a);
      Z(f, d, c);
      A(g, d, c);
      A(h, b, a);
      M(p[0], e, f);
      M(p[1], h, g);
      M(p[2], g, f);
      M(p[3], e, h);
    }
    function cswap(p, q, b) {
      var i;
      for (i = 0; i < 4; i++) {
        sel25519(p[i], q[i], b);
      }
    }
    function pack(r, p) {
      var tx = gf(), ty = gf(), zi = gf();
      inv25519(zi, p[2]);
      M(tx, p[0], zi);
      M(ty, p[1], zi);
      pack25519(r, ty);
      r[31] ^= par25519(tx) << 7;
    }
    function scalarmult(p, q, s) {
      var h = [gf(q[0]), gf(q[1]), gf(q[2]), gf(q[3])];
      var b, i;
      set25519(p[0], gf0);
      set25519(p[1], gf1);
      set25519(p[2], gf1);
      set25519(p[3], gf0);
      for (i = 255; i >= 0; --i) {
        b = s[i / 8 | 0] >> (i & 7) & 1;
        cswap(p, h, b);
        add(h, p);
        add(p, p);
        cswap(p, h, b);
      }
    }
    function scalarbase(p, s) {
      var q = [gf(), gf(), gf(), gf()];
      set25519(q[0], X);
      set25519(q[1], Y);
      set25519(q[2], gf1);
      M(q[3], X, Y);
      scalarmult(p, q, s);
    }
    function crypto_sign_keypair(pk, sk, seeded) {
      check(pk, crypto_sign_PUBLICKEYBYTES);
      check(sk, crypto_sign_SECRETKEYBYTES);
      var d = new Uint8Array(64);
      var p = [gf(), gf(), gf(), gf()];
      var i;
      if (!seeded) randombytes(sk, 32);
      crypto_hash(d, sk, 32);
      d[0] &= 248;
      d[31] &= 127;
      d[31] |= 64;
      scalarbase(p, d);
      pack(pk, p);
      for (i = 0; i < 32; i++) sk[i + 32] = pk[i];
    }
    function crypto_sign_seed_keypair(pk, sk, seed) {
      check(seed, crypto_sign_SEEDBYTES);
      sk.set(seed);
      return crypto_sign_keypair(pk, sk, true);
    }
    var L = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);
    function modL(r, x) {
      var carry, i, j, k;
      for (i = 63; i >= 32; --i) {
        carry = 0;
        for (j = i - 32, k = i - 12; j < k; ++j) {
          x[j] += carry - 16 * x[i] * L[j - (i - 32)];
          carry = x[j] + 128 >> 8;
          x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
      }
      carry = 0;
      for (j = 0; j < 32; j++) {
        x[j] += carry - (x[31] >> 4) * L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
      }
      for (j = 0; j < 32; j++) x[j] -= carry * L[j];
      for (i = 0; i < 32; i++) {
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
      }
    }
    function reduce(r) {
      var x = new Float64Array(64);
      for (let i = 0; i < 64; i++) x[i] = r[i];
      for (let i = 0; i < 64; i++) r[i] = 0;
      modL(r, x);
    }
    function crypto_sign(sm, m, sk) {
      check(sm, crypto_sign_BYTES + m.length);
      check(m, 0);
      check(sk, crypto_sign_SECRETKEYBYTES);
      var n = m.length;
      var d = new Uint8Array(64), h = new Uint8Array(64), r = new Uint8Array(64);
      var i, j, x = new Float64Array(64);
      var p = [gf(), gf(), gf(), gf()];
      crypto_hash(d, sk, 32);
      d[0] &= 248;
      d[31] &= 127;
      d[31] |= 64;
      var smlen = n + 64;
      for (i = 0; i < n; i++) sm[64 + i] = m[i];
      for (i = 0; i < 32; i++) sm[32 + i] = d[32 + i];
      crypto_hash(r, sm.subarray(32), n + 32);
      reduce(r);
      scalarbase(p, r);
      pack(sm, p);
      for (i = 32; i < 64; i++) sm[i] = sk[i];
      crypto_hash(h, sm, n + 64);
      reduce(h);
      for (i = 0; i < 64; i++) x[i] = 0;
      for (i = 0; i < 32; i++) x[i] = r[i];
      for (i = 0; i < 32; i++) {
        for (j = 0; j < 32; j++) {
          x[i + j] += h[i] * d[j];
        }
      }
      modL(sm.subarray(32), x);
      return smlen;
    }
    function crypto_sign_detached(sig, m, sk) {
      var sm = new Uint8Array(m.length + crypto_sign_BYTES);
      crypto_sign(sm, m, sk);
      for (let i = 0; i < crypto_sign_BYTES; i++) sig[i] = sm[i];
    }
    function unpackneg(r, p) {
      var t = gf(), chk = gf(), num = gf(), den = gf(), den2 = gf(), den4 = gf(), den6 = gf();
      set25519(r[2], gf1);
      unpack25519(r[1], p);
      S(num, r[1]);
      M(den, num, D);
      Z(num, num, r[2]);
      A(den, r[2], den);
      S(den2, den);
      S(den4, den2);
      M(den6, den4, den2);
      M(t, den6, num);
      M(t, t, den);
      pow2523(t, t);
      M(t, t, num);
      M(t, t, den);
      M(t, t, den);
      M(r[0], t, den);
      S(chk, r[0]);
      M(chk, chk, den);
      if (!neq25519(chk, num)) M(r[0], r[0], I);
      S(chk, r[0]);
      M(chk, chk, den);
      if (!neq25519(chk, num)) return false;
      if (par25519(r[0]) === p[31] >> 7) {
        Z(r[0], gf(), r[0]);
      }
      M(r[3], r[0], r[1]);
      return true;
    }
    function crypto_sign_open(msg, sm, pk) {
      check(msg, sm.length - crypto_sign_BYTES);
      check(sm, crypto_sign_BYTES);
      check(pk, crypto_sign_PUBLICKEYBYTES);
      var n = sm.length;
      var m = new Uint8Array(sm.length);
      var i, mlen;
      var t = new Uint8Array(32), h = new Uint8Array(64);
      var p = [gf(), gf(), gf(), gf()], q = [gf(), gf(), gf(), gf()];
      mlen = -1;
      if (n < 64) return false;
      if (!unpackneg(q, pk)) return false;
      for (i = 0; i < n; i++) m[i] = sm[i];
      for (i = 0; i < 32; i++) m[i + 32] = pk[i];
      crypto_hash(h, m, n);
      reduce(h);
      scalarmult(p, q, h);
      scalarbase(q, sm.subarray(32));
      add(p, q);
      pack(t, p);
      n -= 64;
      if (!crypto_verify_32(sm, 0, t, 0)) {
        for (i = 0; i < n; i++) m[i] = 0;
        return false;
      }
      for (i = 0; i < n; i++) msg[i] = sm[i + 64];
      mlen = n;
      return true;
    }
    function crypto_sign_verify_detached(sig, m, pk) {
      check(sig, crypto_sign_BYTES);
      var sm = new Uint8Array(m.length + crypto_sign_BYTES);
      var i = 0;
      for (i = 0; i < crypto_sign_BYTES; i++) sm[i] = sig[i];
      for (i = 0; i < m.length; i++) sm[i + crypto_sign_BYTES] = m[i];
      return crypto_sign_open(m, sm, pk);
    }
    function par25519(a) {
      var d = new Uint8Array(32);
      pack25519(d, a);
      return d[0] & 1;
    }
    function neq25519(a, b) {
      var c = new Uint8Array(32), d = new Uint8Array(32);
      pack25519(c, a);
      pack25519(d, b);
      return crypto_verify_32(c, 0, d, 0);
    }
    function ed25519_mul_l(p, q) {
      scalarmult(p, q, L);
    }
    function ed25519_is_on_main_subgroup(p) {
      var pl = [gf(), gf(), gf(), gf()];
      ed25519_mul_l(pl, p);
      var zero = 0;
      for (let i = 0; i < 16; i++) {
        zero |= pl[0][i] & 65535;
      }
      return zero === 0;
    }
    function crypto_sign_ed25519_pk_to_curve25519(x25519_pk, ed25519_pk) {
      check(x25519_pk, crypto_sign_PUBLICKEYBYTES);
      check(ed25519_pk, crypto_sign_ed25519_PUBLICKEYBYTES);
      var a = [gf(), gf(), gf(), gf()];
      var x = gf([1]);
      var one_minus_y = gf([1]);
      assert(
        isSmallOrder(ed25519_pk) && unpackneg(a, ed25519_pk) && ed25519_is_on_main_subgroup(a),
        "Cannot convert key: bad point"
      );
      for (let i = 0; i < a.length; i++) {
        pack25519(x25519_pk, a[i]);
      }
      Z(one_minus_y, one_minus_y, a[1]);
      A(x, x, a[1]);
      inv25519(one_minus_y, one_minus_y);
      M(x, x, one_minus_y);
      pack25519(x25519_pk, x);
      return 0;
    }
    function isSmallOrder(s) {
      Uint8Array.from([]);
      var bad_points = [
        // 0 (order 4)
        Uint8Array.from([
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]),
        // 1 (order 1)
        Uint8Array.from([
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ]),
        // 2707385501144840649318225287225658788936804267575313519463743609750303402022(order 8)
        Uint8Array.from([
          38,
          232,
          149,
          143,
          194,
          178,
          39,
          176,
          69,
          195,
          244,
          137,
          242,
          239,
          152,
          240,
          213,
          223,
          172,
          5,
          211,
          198,
          51,
          57,
          177,
          56,
          2,
          136,
          109,
          83,
          252,
          5
        ]),
        // 55188659117513257062467267217118295137698188065244968500265048394206261417927 (order 8)
        Uint8Array.from([
          199,
          23,
          106,
          112,
          61,
          77,
          216,
          79,
          186,
          60,
          11,
          118,
          13,
          16,
          103,
          15,
          42,
          32,
          83,
          250,
          44,
          57,
          204,
          198,
          78,
          199,
          253,
          119,
          146,
          172,
          3,
          122
        ]),
        // p-1 (order 2)
        Uint8Array.from([
          236,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          127
        ]),
        //  p (=0 order 4)
        Uint8Array.from([
          237,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          127
        ]),
        // p + 1 (=1 order 1)
        Uint8Array.from([
          238,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          255,
          127
        ])
      ];
      var c = new Uint8Array(7);
      var j;
      check(bad_points, 7);
      for (let i = 0; i < bad_points.length; i++) {
        for (j = 0; j < 31; j++) {
          c[i] |= s[j] ^ bad_points[i][j];
        }
      }
      for (let i = 0; i < bad_points.length; i++) {
        c[i] |= s[j] & 127 ^ bad_points[i][j];
      }
      var k = 0;
      for (let i = 0; i < bad_points.length; i++) {
        k |= c[i] - 1;
      }
      return (k >> 8 & 1) === 0;
    }
    function crypto_sign_ed25519_sk_to_pk(pk, sk) {
      check(pk, crypto_sign_ed25519_PUBLICKEYBYTES);
      pk.set(sk.subarray(crypto_sign_ed25519_SEEDBYTES));
      return pk;
    }
    function crypto_sign_ed25519_sk_to_curve25519(curveSk, edSk) {
      assert(curveSk && curveSk.byteLength === crypto_scalarmult_BYTES, "curveSk must be 'crypto_sign_SECRETKEYBYTES' long");
      assert(edSk && edSk.byteLength === crypto_sign_ed25519_SECRETKEYBYTES, "edSk must be 'crypto_sign_ed25519_SECRETKEYBYTES' long");
      var h = new Uint8Array(crypto_hash_sha512_BYTES);
      crypto_hash(h, edSk, 32);
      h[0] &= 248;
      h[31] &= 127;
      h[31] |= 64;
      curveSk.set(h.subarray(0, crypto_scalarmult_BYTES));
      h.fill(0);
      return curveSk;
    }
    function check(buf, len, arg = "Argument") {
      if (!buf || len && buf.length < len) throw new Error(arg + " must be a buffer" + (len ? " of length " + len : ""));
    }
  }
});

// ../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/index.js
var require_sodium_javascript = __commonJS({
  "../../node_modules/.pnpm/sodium-javascript@0.8.0/node_modules/sodium-javascript/index.js"(exports, module) {
    "use strict";
    forward(require_randombytes());
    forward(require_memory());
    forward(require_helpers());
    forward(require_crypto_verify());
    forward(require_crypto_auth());
    forward(require_crypto_box());
    forward(require_crypto_generichash());
    forward(require_crypto_hash());
    forward(require_crypto_hash_sha256());
    forward(require_crypto_kdf());
    forward(require_crypto_kx());
    forward(require_crypto_aead());
    forward(require_crypto_onetimeauth());
    forward(require_crypto_scalarmult());
    forward(require_crypto_secretbox());
    forward(require_crypto_secretstream());
    forward(require_crypto_shorthash());
    forward(require_crypto_sign());
    forward(require_crypto_stream());
    forward(require_crypto_stream_chacha20());
    function forward(submodule) {
      Object.keys(submodule).forEach(function(prop) {
        module.exports[prop] = submodule[prop];
      });
    }
  }
});

// ../../node_modules/.pnpm/uint64be@3.0.0/node_modules/uint64be/index.js
var require_uint64be = __commonJS({
  "../../node_modules/.pnpm/uint64be@3.0.0/node_modules/uint64be/index.js"(exports) {
    var UINT_32_MAX = Math.pow(2, 32);
    exports.encodingLength = function() {
      return 8;
    };
    exports.encode = function(num, buf, offset) {
      if (!buf) buf = Buffer.allocUnsafe(8);
      if (!offset) offset = 0;
      const top = Math.floor(num / UINT_32_MAX);
      const rem = num - top * UINT_32_MAX;
      buf.writeUInt32BE(top, offset);
      buf.writeUInt32BE(rem, offset + 4);
      return buf;
    };
    exports.decode = function(buf, offset) {
      if (!offset) offset = 0;
      const top = buf.readUInt32BE(offset);
      const rem = buf.readUInt32BE(offset + 4);
      return top * UINT_32_MAX + rem;
    };
    exports.encode.bytes = 8;
    exports.decode.bytes = 8;
  }
});

// ../../node_modules/.pnpm/hypercore-crypto@2.3.2/node_modules/hypercore-crypto/index.js
var require_hypercore_crypto = __commonJS({
  "../../node_modules/.pnpm/hypercore-crypto@2.3.2/node_modules/hypercore-crypto/index.js"(exports) {
    var sodium = require_sodium_javascript();
    var uint64be = require_uint64be();
    var LEAF_TYPE = Buffer.from([0]);
    var PARENT_TYPE = Buffer.from([1]);
    var ROOT_TYPE = Buffer.from([2]);
    var CAP_TYPE = Buffer.from([3]);
    var HYPERCORE = Buffer.from("hypercore");
    var HYPERCORE_CAP = Buffer.from("hypercore capability");
    exports.writerCapability = function(key, secretKey, split) {
      if (!split) return null;
      const out = Buffer.allocUnsafe(32);
      sodium.crypto_generichash_batch(out, [
        CAP_TYPE,
        HYPERCORE_CAP,
        split.tx.slice(0, 32),
        key
      ], split.rx.slice(0, 32));
      return exports.sign(out, secretKey);
    };
    exports.verifyRemoteWriterCapability = function(key, cap, split) {
      if (!split) return null;
      const out = Buffer.allocUnsafe(32);
      sodium.crypto_generichash_batch(out, [
        CAP_TYPE,
        HYPERCORE_CAP,
        split.rx.slice(0, 32),
        key
      ], split.tx.slice(0, 32));
      return exports.verify(out, cap, key);
    };
    exports.capability = function(key, split) {
      if (!split) return null;
      const out = Buffer.allocUnsafe(32);
      sodium.crypto_generichash_batch(out, [
        HYPERCORE_CAP,
        split.tx.slice(0, 32),
        key
      ], split.rx.slice(0, 32));
      return out;
    };
    exports.remoteCapability = function(key, split) {
      if (!split) return null;
      const out = Buffer.allocUnsafe(32);
      sodium.crypto_generichash_batch(out, [
        HYPERCORE_CAP,
        split.rx.slice(0, 32),
        key
      ], split.tx.slice(0, 32));
      return out;
    };
    exports.keyPair = function(seed) {
      const publicKey = Buffer.allocUnsafe(sodium.crypto_sign_PUBLICKEYBYTES);
      const secretKey = Buffer.allocUnsafe(sodium.crypto_sign_SECRETKEYBYTES);
      if (seed) sodium.crypto_sign_seed_keypair(publicKey, secretKey, seed);
      else sodium.crypto_sign_keypair(publicKey, secretKey);
      return {
        publicKey,
        secretKey
      };
    };
    exports.validateKeyPair = function(keyPair) {
      const pk = Buffer.allocUnsafe(sodium.crypto_sign_PUBLICKEYBYTES);
      sodium.crypto_sign_ed25519_sk_to_pk(pk, keyPair.secretKey);
      return pk.equals(keyPair.publicKey);
    };
    exports.sign = function(message, secretKey) {
      const signature = Buffer.allocUnsafe(sodium.crypto_sign_BYTES);
      sodium.crypto_sign_detached(signature, message, secretKey);
      return signature;
    };
    exports.verify = function(message, signature, publicKey) {
      return sodium.crypto_sign_verify_detached(signature, message, publicKey);
    };
    exports.data = function(data) {
      const out = Buffer.allocUnsafe(32);
      sodium.crypto_generichash_batch(out, [
        LEAF_TYPE,
        encodeUInt64(data.length),
        data
      ]);
      return out;
    };
    exports.leaf = function(leaf) {
      return exports.data(leaf.data);
    };
    exports.parent = function(a, b) {
      if (a.index > b.index) {
        const tmp = a;
        a = b;
        b = tmp;
      }
      const out = Buffer.allocUnsafe(32);
      sodium.crypto_generichash_batch(out, [
        PARENT_TYPE,
        encodeUInt64(a.size + b.size),
        a.hash,
        b.hash
      ]);
      return out;
    };
    exports.tree = function(roots, out) {
      const buffers = new Array(3 * roots.length + 1);
      var j = 0;
      buffers[j++] = ROOT_TYPE;
      for (var i = 0; i < roots.length; i++) {
        const r = roots[i];
        buffers[j++] = r.hash;
        buffers[j++] = encodeUInt64(r.index);
        buffers[j++] = encodeUInt64(r.size);
      }
      if (!out) out = Buffer.allocUnsafe(32);
      sodium.crypto_generichash_batch(out, buffers);
      return out;
    };
    exports.signable = function(roots, length) {
      const out = Buffer.allocUnsafe(40);
      if (Buffer.isBuffer(roots)) roots.copy(out);
      else exports.tree(roots, out.slice(0, 32));
      uint64be.encode(length, out.slice(32));
      return out;
    };
    exports.randomBytes = function(n) {
      const buf = Buffer.allocUnsafe(n);
      sodium.randombytes_buf(buf);
      return buf;
    };
    exports.discoveryKey = function(publicKey) {
      const digest = Buffer.allocUnsafe(32);
      sodium.crypto_generichash(digest, HYPERCORE, publicKey);
      return digest;
    };
    if (sodium.sodium_free) {
      exports.free = function(secureBuf) {
        if (secureBuf.secure) sodium.sodium_free(secureBuf);
      };
    } else {
      exports.free = function() {
      };
    }
    function encodeUInt64(n) {
      return uint64be.encode(n, Buffer.allocUnsafe(8));
    }
  }
});

export {
  __commonJS,
  __export,
  __reExport,
  __toESM,
  require_nanoassert,
  require_memory,
  require_helpers,
  require_browser,
  require_crypto_scalarmult,
  require_crypto_generichash,
  require_xsalsa202 as require_xsalsa20,
  require_crypto_kx,
  require_crypto_aead,
  require_hypercore_crypto
};
//# sourceMappingURL=chunk-DEF4I65T.mjs.map
